var ga = Object.defineProperty, Xa = Object.defineProperties;
var Ga = Object.getOwnPropertyDescriptors;
var At = Object.getOwnPropertySymbols;
var Ur = Object.prototype.hasOwnProperty, Kr = Object.prototype.propertyIsEnumerable;
var is = (s, e, t) => e in s ? ga(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, x = (s, e) => {
  for (var t in e || (e = {}))
    Ur.call(e, t) && is(s, t, e[t]);
  if (At)
    for (var t of At(e))
      Kr.call(e, t) && is(s, t, e[t]);
  return s;
}, re = (s, e) => Xa(s, Ga(e));
var Qe = (s, e) => {
  var t = {};
  for (var i in s)
    Ur.call(s, i) && e.indexOf(i) < 0 && (t[i] = s[i]);
  if (s != null && At)
    for (var i of At(s))
      e.indexOf(i) < 0 && Kr.call(s, i) && (t[i] = s[i]);
  return t;
};
var L = (s, e, t) => is(s, typeof e != "symbol" ? e + "" : e, t);
var ne = (s, e, t) => new Promise((i, r) => {
  var n = (l) => {
    try {
      a(t.next(l));
    } catch (u) {
      r(u);
    }
  }, o = (l) => {
    try {
      a(t.throw(l));
    } catch (u) {
      r(u);
    }
  }, a = (l) => l.done ? i(l.value) : Promise.resolve(l.value).then(n, o);
  a((t = t.apply(s, e)).next());
});
import { y as hl, z as Sa, a as we, S as ve, d as je, g as ss, r as Fr, G as rs, b as Ia, c as Va, n as Ra, o as Wa, l as Mr, e as ns, f as gt, F as zr, V as Ca, P as wa, h as xa, q as La, H as Hr, M as ka, i as Ja, s as va, L as Ya, A as Na, B as Ta, C as Ua, D as Ka, p as Fa, k as Or, u as Ma, E as za, x as Ha, I as Pr, J as Oa, K as Pa, N as Ea, O as Ba, Q as Qa, R as Da, T as ja } from "./common-BAgOa6vM.js";
import { L as Aa, i as Fe } from "./buffer-DIFxvF2Q.js";
import { LDRecord as _a } from "./LDRecord.js";
const $a = {
  key: "_sid"
}, qa = "rrweb/sequential-id@1", ec = (s) => {
  const e = $a;
  let t = 0;
  return {
    name: qa,
    eventProcessor(i) {
      return Object.assign(i, {
        [e.key]: ++t
      }), i;
    },
    options: e
  };
};
var tc = Object.defineProperty, ic = (s, e, t) => e in s ? tc(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, X = (s, e, t) => ic(s, typeof e != "symbol" ? e + "" : e, t), Er, sc = Object.defineProperty, rc = (s, e, t) => e in s ? sc(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, Br = (s, e, t) => rc(s, typeof e != "symbol" ? e + "" : e, t), ie = /* @__PURE__ */ ((s) => (s[s.Document = 0] = "Document", s[s.DocumentType = 1] = "DocumentType", s[s.Element = 2] = "Element", s[s.Text = 3] = "Text", s[s.CDATA = 4] = "CDATA", s[s.Comment = 5] = "Comment", s))(ie || {});
const _t = /* @__PURE__ */ new Map(), Qr = /* @__PURE__ */ new WeakSet();
function Dr(s) {
  return s !== null && typeof s == "object" && "complete" in s && "naturalWidth" in s && "naturalHeight" in s && "src" in s && "onload" in s;
}
function nc(s) {
  if (Qr.has(s))
    return;
  Qr.add(s);
  const e = s.drawImage.bind(s);
  s.drawImage = function(t, ...i) {
    const r = _t.get(s);
    r && (r.cancelled = !0);
    const n = () => {
      i.length === 2 && Dr(t) && i.push(t.naturalWidth || t.width, t.naturalHeight || t.height), e(t, ...i);
    };
    if (Dr(t) && !t.complete) {
      const o = { cancelled: !1 };
      _t.set(s, o);
      const a = () => {
        o.cancelled || (_t.delete(s), n());
      }, l = () => {
        if (!o.cancelled) {
          _t.delete(s);
          try {
            n();
          } catch (u) {
          }
        }
      };
      t.onload = a, t.onerror = l;
    } else
      n();
  };
}
const jr = {
  Node: ["childNodes", "parentNode", "parentElement", "textContent"],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
}, Ar = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
}, $t = {}, lc = () => !!globalThis.Zone;
function or(s) {
  if ($t[s])
    return $t[s];
  const e = globalThis[s], t = e.prototype, i = s in jr ? jr[s] : void 0, r = !!(i && // @ts-expect-error 2345
  i.every(
    (a) => {
      var l, u;
      return !!((u = (l = Object.getOwnPropertyDescriptor(t, a)) == null ? void 0 : l.get) != null && u.toString().includes("[native code]"));
    }
  )), n = s in Ar ? Ar[s] : void 0, o = !!(n && n.every(
    // @ts-expect-error 2345
    (a) => {
      var l;
      return typeof t[a] == "function" && ((l = t[a]) == null ? void 0 : l.toString().includes("[native code]"));
    }
  ));
  if (r && o && !lc())
    return $t[s] = e.prototype, e.prototype;
  try {
    const a = document.createElement("iframe");
    document.body.appendChild(a);
    const l = a.contentWindow;
    if (!l) return e.prototype;
    const u = l[s].prototype;
    return document.body.removeChild(a), u ? $t[s] = u : t;
  } catch (a) {
    return t;
  }
}
const ls = {};
function He(s, e, t) {
  var i;
  const r = `${s}.${String(t)}`;
  if (ls[r])
    return ls[r].call(
      e
    );
  const n = or(s), o = (i = Object.getOwnPropertyDescriptor(
    n,
    t
  )) == null ? void 0 : i.get;
  return o ? (ls[r] = o, o.call(e)) : e[t];
}
const os = {};
function dl(s, e, t) {
  const i = `${s}.${String(t)}`;
  if (os[i])
    return os[i].bind(
      e
    );
  const n = or(s)[t];
  return typeof n != "function" ? e[t] : (os[i] = n, n.bind(e));
}
function oc(s) {
  return He("Node", s, "childNodes");
}
function ac(s) {
  return He("Node", s, "parentNode");
}
function cc(s) {
  return He("Node", s, "parentElement");
}
function uc(s) {
  return He("Node", s, "textContent");
}
function hc(s, e) {
  return dl("Node", s, "contains")(e);
}
function dc(s) {
  return dl("Node", s, "getRootNode")();
}
function pc(s) {
  return !s || !("host" in s) ? null : He("ShadowRoot", s, "host");
}
function mc(s) {
  return s.styleSheets;
}
function fc(s) {
  return !s || !("shadowRoot" in s) ? null : He("Element", s, "shadowRoot");
}
function bc(s, e) {
  return He("Element", s, "querySelector")(e);
}
function Zc(s, e) {
  return He("Element", s, "querySelectorAll")(e);
}
function yc() {
  return or("MutationObserver").constructor;
}
function gc(s, e, t) {
  try {
    if (!(e in s))
      return () => {
      };
    const i = s[e], r = t(i);
    return typeof r == "function" && (r.prototype = r.prototype || {}, Object.defineProperties(r, {
      __rrweb_original__: {
        enumerable: !1,
        value: i
      }
    })), s[e] = r, () => {
      s[e] = i;
    };
  } catch (i) {
    return () => {
    };
  }
}
const le = {
  childNodes: oc,
  parentNode: ac,
  parentElement: cc,
  textContent: uc,
  contains: hc,
  getRootNode: dc,
  host: pc,
  styleSheets: mc,
  shadowRoot: fc,
  querySelector: bc,
  querySelectorAll: Zc,
  mutationObserver: yc,
  patch: gc,
  wrapCanvasContextDrawImage: nc
};
function pl(s) {
  return s.nodeType === s.ELEMENT_NODE;
}
function wt(s) {
  const e = (
    // anchor and textarea elements also have a `host` property
    // but only shadow roots have a `mode` property
    s && "host" in s && "mode" in s && le.host(s) || null
  );
  return !!(e && "shadowRoot" in e && le.shadowRoot(e) === s);
}
function xt(s) {
  return Object.prototype.toString.call(s) === "[object ShadowRoot]";
}
function Xc(s) {
  return s.includes(" background-clip: text;") && !s.includes(" -webkit-background-clip: text;") && (s = s.replace(
    /\sbackground-clip:\s*text;/g,
    " -webkit-background-clip: text; background-clip: text;"
  )), s;
}
function Gc(s) {
  const { cssText: e } = s;
  if (e.split('"').length < 3) return e;
  const t = ["@import", `url(${JSON.stringify(s.href)})`];
  return s.layerName === "" ? t.push("layer") : s.layerName && t.push(`layer(${s.layerName})`), s.supportsText && t.push(`supports(${s.supportsText})`), s.media.length && t.push(s.media.mediaText), t.join(" ") + ";";
}
function Ss(s) {
  try {
    const e = s.rules || s.cssRules;
    if (!e)
      return null;
    let t = s.href;
    !t && s.ownerNode && s.ownerNode.ownerDocument && (t = s.ownerNode.ownerDocument.location.href);
    const i = Array.from(
      e,
      (r) => ml(r, t)
    ).join("");
    return Xc(i);
  } catch (e) {
    return null;
  }
}
function ml(s, e) {
  if (Ic(s)) {
    let t;
    try {
      t = // for same-origin stylesheets,
      // we can access the imported stylesheet rules directly
      Ss(s.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      Gc(s);
    } catch (i) {
      t = s.cssText;
    }
    return s.styleSheet.href ? xi(t, s.styleSheet.href) : t;
  } else {
    let t = s.cssText;
    return Vc(s) && s.selectorText.includes(":") && (t = Sc(t)), e ? xi(t, e) : t;
  }
}
function Sc(s) {
  const e = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return s.replace(e, "$1\\$2");
}
function Ic(s) {
  return "styleSheet" in s;
}
function Vc(s) {
  return "selectorText" in s;
}
class fl {
  constructor() {
    Br(this, "idNodeMap", /* @__PURE__ */ new Map()), Br(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(e) {
    var t;
    if (!e) return -1;
    const i = (t = this.getMeta(e)) == null ? void 0 : t.id;
    return i != null ? i : -1;
  }
  getNode(e) {
    return this.idNodeMap.get(e) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(e) {
    return this.nodeMetaMap.get(e) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(e) {
    const t = this.getId(e);
    this.idNodeMap.delete(t), e.childNodes && e.childNodes.forEach(
      (i) => this.removeNodeFromMap(i)
    );
  }
  has(e) {
    return this.idNodeMap.has(e);
  }
  hasNode(e) {
    return this.nodeMetaMap.has(e);
  }
  add(e, t) {
    const i = t.id;
    this.idNodeMap.set(i, e), this.nodeMetaMap.set(e, t);
  }
  replace(e, t) {
    const i = this.getNode(e);
    if (i) {
      const r = this.nodeMetaMap.get(i);
      r && this.nodeMetaMap.set(t, r);
    }
    this.idNodeMap.set(e, t);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map(), this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function Rc() {
  return new fl();
}
function Ci({
  element: s,
  maskInputOptions: e,
  tagName: t,
  type: i,
  value: r,
  overwriteRecord: n,
  maskInputFn: o
}) {
  let a = r || "";
  return yl({
    maskInputOptions: e,
    tagName: t,
    type: i,
    overwriteRecord: n
  }) && (o ? a = o(a, s) : a = "*".repeat(a.length)), a;
}
function ct(s) {
  return s.toLowerCase();
}
const _r = "__rrweb_original__";
function Wc(s) {
  const e = s.getContext("2d");
  if (!e) return !0;
  const t = 50;
  for (let i = 0; i < s.width; i += t)
    for (let r = 0; r < s.height; r += t) {
      const n = e.getImageData, o = _r in n ? n[_r] : n;
      if (new Uint32Array(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        o.call(
          e,
          i,
          r,
          Math.min(t, s.width - i),
          Math.min(t, s.height - r)
        ).data.buffer
      ).some((l) => l !== 0)) return !1;
    }
  return !0;
}
function wi(s) {
  const e = s.type;
  return s.hasAttribute("data-rr-is-password") ? "password" : e ? (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    ct(e)
  ) : null;
}
function bl(s, e) {
  var n;
  let t;
  try {
    t = new URL(s, window.location.href);
  } catch (o) {
    return null;
  }
  const i = /\.([0-9a-z]+)(?:$)/i, r = t.pathname.match(i);
  return (n = r == null ? void 0 : r[1]) != null ? n : null;
}
function Cc(s) {
  let e = "";
  return s.indexOf("//") > -1 ? e = s.split("/").slice(0, 3).join("/") : e = s.split("/")[0], e = e.split("?")[0], e;
}
const wc = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm, xc = /^(?:[a-z+]+:)?\/\//i, Lc = /^www\..*/i, kc = /^(data:)([^,]*),(.*)/i;
function xi(s, e) {
  return (s || "").replace(
    wc,
    (t, i, r, n, o, a) => {
      const l = r || o || a, u = i || n || "";
      if (!l)
        return t;
      if (xc.test(l) || Lc.test(l))
        return `url(${u}${l}${u})`;
      if (kc.test(l))
        return `url(${u}${l}${u})`;
      if (l[0] === "/")
        return `url(${u}${Cc(e) + l}${u})`;
      const c = e.split("/"), h = l.split("/");
      c.pop();
      for (const p of h)
        p !== "." && (p === ".." ? c.pop() : c.push(p));
      return `url(${u}${c.join("/")}${u})`;
    }
  );
}
function qt(s, e = !1) {
  return e ? s.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "") : s.replace(/(\/\*[^*]*\*\/)|[\s;]/g, "").replace(/0px/g, "0");
}
function Jc(s, e, t = !1) {
  const i = Array.from(e.childNodes), r = [];
  let n = 0;
  if (i.length > 1 && s && typeof s == "string") {
    let o = qt(s, t);
    const a = o.length / s.length;
    for (let l = 1; l < i.length; l++)
      if (i[l].textContent && typeof i[l].textContent == "string") {
        const u = qt(
          i[l].textContent,
          t
        ), c = 100;
        let h = 3;
        for (; h < u.length && // keep consuming css identifiers (to get a decent chunk more quickly)
        (u[h].match(/[a-zA-Z0-9]/) || // substring needs to be unique to this section
        u.indexOf(u.substring(0, h), 1) !== -1); h++)
          ;
        for (; h < u.length; h++) {
          let p = u.substring(0, h), d = o.split(p), b = -1;
          if (d.length === 2)
            b = d[0].length;
          else if (d.length > 2 && d[0] === "" && i[l - 1].textContent !== "")
            b = o.indexOf(p, 1);
          else if (d.length === 1) {
            if (p = p.substring(
              0,
              p.length - 1
            ), d = o.split(p), d.length <= 1)
              return r.push(s), r;
            h = c + 1;
          } else h === u.length - 1 && (b = o.indexOf(p));
          if (d.length >= 2 && h > c) {
            const m = i[l - 1].textContent;
            if (m && typeof m == "string") {
              const f = qt(m).length;
              b = o.indexOf(p, f);
            }
            b === -1 && (b = d[0].length);
          }
          if (b !== -1) {
            let m = Math.floor(b / a);
            for (; m > 0 && m < s.length; ) {
              if (n += 1, n > 50 * i.length)
                return r.push(s), r;
              const f = qt(
                s.substring(0, m),
                t
              );
              if (f.length === b) {
                r.push(s.substring(0, m)), s = s.substring(m), o = o.substring(b);
                break;
              } else f.length < b ? m += Math.max(
                1,
                Math.floor((b - f.length) / a)
              ) : m -= Math.max(
                1,
                Math.floor((f.length - b) * a)
              );
            }
            break;
          }
        }
      }
  }
  return r.push(s), r;
}
function vc(s, e) {
  return Jc(s, e).join("/* rr_split */");
}
function ar(s) {
  return s = s.replace(/[^ -~]+/g, ""), s = (s == null ? void 0 : s.split(" ").map((e) => e ? Math.random().toString(20).substring(2, e.length + 2) : "").join(" ")) || "", s;
}
function Is(s) {
  return s === "img" || s === "video" || s === "audio" || s === "source";
}
const Yc = new RegExp(
  /[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*/
), Nc = new RegExp(/[0-9]{9,16}/), Tc = new RegExp(/[0-9]{3}-?[0-9]{2}-?[0-9]{4}/), Uc = new RegExp(
  /[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}/
), Kc = new RegExp(/[0-9]{4}-?[0-9]{4}-?[0-9]{4}-?[0-9]{4}/), Fc = new RegExp(
  /[0-9]{1,5}.?[0-9]{0,3}\s[a-zA-Z]{2,30}\s[a-zA-Z]{2,15}/
), Mc = new RegExp(/(?:[0-9]{1,3}.){3}[0-9]{1,3}/), zc = [
  Yc,
  Nc,
  Tc,
  Uc,
  Kc,
  Fc,
  Mc
];
function Zl(s) {
  return s ? zc.some((e) => e.test(s)) : !1;
}
const yl = ({
  maskInputOptions: s,
  tagName: e,
  type: t,
  overwriteRecord: i
}) => {
  const r = t && t.toLowerCase();
  return i !== "true" && (!!s[e.toLowerCase()] || !!(r && s[r]));
};
let Hc = 1;
const Oc = new RegExp("[^a-z0-9-_:]"), vt = -2;
function gl() {
  return Hc++;
}
function Pc(s) {
  if (s instanceof HTMLFormElement)
    return "form";
  const e = ct(s.tagName);
  return Oc.test(e) ? "div" : e;
}
let st, $r;
const Ec = /^[^ \t\n\r\u000c]+/, Bc = /^[, \t\n\r\u000c]+/;
function Qc(s, e) {
  if (e.trim() === "")
    return e;
  let t = 0;
  function i(n) {
    let o;
    const a = n.exec(e.substring(t));
    return a ? (o = a[0], t += o.length, o) : "";
  }
  const r = [];
  for (; i(Bc), !(t >= e.length); ) {
    let n = i(Ec);
    if (n.slice(-1) === ",")
      n = lt(s, n.substring(0, n.length - 1)), r.push(n);
    else {
      let o = "";
      n = lt(s, n);
      let a = !1;
      for (; ; ) {
        const l = e.charAt(t);
        if (l === "") {
          r.push((n + o).trim());
          break;
        } else if (a)
          l === ")" && (a = !1);
        else if (l === ",") {
          t += 1, r.push((n + o).trim());
          break;
        } else l === "(" && (a = !0);
        o += l, t += 1;
      }
    }
  }
  return r.join(", ");
}
const qr = /* @__PURE__ */ new WeakMap();
function lt(s, e) {
  return !e || e.trim() === "" ? e : cr(s, e);
}
function Dc(s) {
  return !!(s.tagName === "svg" || s.ownerSVGElement);
}
function cr(s, e) {
  let t = qr.get(s);
  if (t || (t = s.createElement("a"), qr.set(s, t)), !e)
    e = "";
  else if (e.startsWith("blob:") || e.startsWith("data:"))
    return e;
  return t.setAttribute("href", e), t.href;
}
function Xl(s, e, t, i) {
  return i && (t === "src" || t === "href" && !(e === "use" && i[0] === "#") || t === "xlink:href" && i[0] !== "#" || t === "background" && (e === "table" || e === "td" || e === "th") ? lt(s, i) : t === "srcset" ? Qc(s, i) : t === "style" ? xi(i, cr(s)) : e === "object" && t === "data" ? lt(s, i) : i);
}
function Gl(s, e, t) {
  return (s === "video" || s === "audio") && e === "autoplay";
}
function en(s, e, t) {
  try {
    if (typeof e == "string") {
      if (s.classList.contains(e))
        return !0;
    } else
      for (let i = s.classList.length; i--; ) {
        const r = s.classList[i];
        if (e.test(r))
          return !0;
      }
    if (t)
      return s.matches(t);
  } catch (i) {
  }
  return !1;
}
function Li(s, e, t) {
  if (!s) return !1;
  if (s.nodeType !== s.ELEMENT_NODE)
    return t ? Li(le.parentNode(s), e, t) : !1;
  for (let i = s.classList.length; i--; ) {
    const r = s.classList[i];
    if (e.test(r))
      return !0;
  }
  return t ? Li(le.parentNode(s), e, t) : !1;
}
function Sl(s, e, t, i) {
  let r;
  if (pl(s)) {
    if (r = s, !le.childNodes(r).length)
      return !1;
  } else {
    if (le.parentElement(s) === null)
      return !1;
    r = le.parentElement(s);
  }
  try {
    if (typeof e == "string") {
      if (i) {
        if (r.closest(`.${e}`)) return !0;
      } else if (r.classList.contains(e)) return !0;
    } else if (Li(r, e, i)) return !0;
    if (t) {
      if (i) {
        if (r.closest(t)) return !0;
      } else if (r.matches(t)) return !0;
    }
  } catch (n) {
  }
  return !1;
}
function jc(s, e, t) {
  const i = s.contentWindow;
  if (!i)
    return;
  let r = !1, n;
  try {
    n = i.document.readyState;
  } catch (a) {
    return;
  }
  if (n !== "complete") {
    const a = setTimeout(() => {
      r || (e(), r = !0);
    }, t);
    s.addEventListener("load", () => {
      clearTimeout(a), r = !0, e();
    });
    return;
  }
  const o = "about:blank";
  if (i.location.href !== o || s.src === o || s.src === "")
    return setTimeout(e, 0), s.addEventListener("load", e);
  s.addEventListener("load", e);
}
function Ac(s, e, t) {
  let i = !1, r;
  try {
    r = s.sheet;
  } catch (o) {
    return;
  }
  if (r) return;
  const n = setTimeout(() => {
    i || (e(), i = !0);
  }, t);
  s.addEventListener("load", () => {
    clearTimeout(n), i = !0, e();
  });
}
function _c(s, e) {
  const {
    doc: t,
    mirror: i,
    blockClass: r,
    blockSelector: n,
    needsMask: o,
    inlineStylesheet: a,
    maskInputOptions: l = {},
    maskTextClass: u,
    maskTextFn: c,
    maskInputFn: h,
    dataURLOptions: p = {},
    inlineImages: d,
    inlineVideos: b,
    recordCanvas: m,
    keepIframeSrcFn: f,
    newlyAddedElement: V = !1,
    cssCaptured: G = !1,
    privacySetting: g
  } = e, S = $c(t, i);
  switch (s.nodeType) {
    case s.DOCUMENT_NODE:
      return s.compatMode !== "CSS1Compat" ? {
        type: ie.Document,
        childNodes: [],
        compatMode: s.compatMode
        // probably "BackCompat"
      } : {
        type: ie.Document,
        childNodes: []
      };
    case s.DOCUMENT_TYPE_NODE:
      return {
        type: ie.DocumentType,
        name: s.name,
        publicId: s.publicId,
        systemId: s.systemId,
        rootId: S
      };
    case s.ELEMENT_NODE:
      return eu(s, {
        doc: t,
        blockClass: r,
        blockSelector: n,
        inlineStylesheet: a,
        maskInputOptions: l,
        maskInputFn: h,
        maskTextClass: u,
        dataURLOptions: p,
        inlineImages: d,
        inlineVideos: b,
        recordCanvas: m,
        keepIframeSrcFn: f,
        newlyAddedElement: V,
        privacySetting: g,
        rootId: S
      });
    case s.TEXT_NODE:
      return qc(s, {
        doc: t,
        needsMask: o,
        maskTextFn: c,
        privacySetting: g,
        rootId: S,
        cssCaptured: G
      });
    case s.CDATA_SECTION_NODE:
      return {
        type: ie.CDATA,
        textContent: "",
        rootId: S
      };
    case s.COMMENT_NODE:
      return {
        type: ie.Comment,
        textContent: le.textContent(s) || "",
        rootId: S
      };
    default:
      return !1;
  }
}
function $c(s, e) {
  if (!e.hasNode(s)) return;
  const t = e.getId(s);
  return t === 1 ? void 0 : t;
}
function qc(s, e) {
  var t;
  const { needsMask: i, maskTextFn: r, privacySetting: n, rootId: o, cssCaptured: a } = e, l = le.parentNode(s), u = l && l.tagName;
  let c = "";
  const h = u === "STYLE" ? !0 : void 0, p = u === "SCRIPT" ? !0 : void 0;
  p ? c = "SCRIPT_PLACEHOLDER" : a || (c = le.textContent(s), h && c && (c = xi(c, cr(e.doc)))), !h && !p && c && i && (c = r ? r(c, le.parentElement(s)) : c.replace(/[\S]/g, "*"));
  const d = n === "strict", b = (t = s.parentElement) == null ? void 0 : t.getAttribute("data-hl-record"), m = n === "default" && Zl(c);
  return (d || m) && !b && u && !(/* @__PURE__ */ new Set([
    "HEAD",
    "TITLE",
    "STYLE",
    "SCRIPT",
    "HTML",
    "BODY",
    "NOSCRIPT"
  ])).has(u) && c && (c = ar(c)), {
    type: ie.Text,
    textContent: c || "",
    rootId: o
  };
}
function eu(s, e) {
  const {
    doc: t,
    blockClass: i,
    blockSelector: r,
    inlineStylesheet: n,
    maskInputOptions: o = {},
    maskInputFn: a,
    maskTextClass: l,
    dataURLOptions: u = {},
    inlineImages: c,
    inlineVideos: h,
    recordCanvas: p,
    keepIframeSrcFn: d,
    newlyAddedElement: b = !1,
    privacySetting: m,
    rootId: f
  } = e;
  let V = en(s, i, r);
  const G = en(s, l, null), g = m === "strict";
  let S = Pc(s), y = {};
  const W = s.attributes.length;
  for (let Z = 0; Z < W; Z++) {
    const I = s.attributes[Z];
    Gl(S, I.name) || (y[I.name] = Xl(
      t,
      S,
      ct(I.name),
      I.value
    ));
  }
  if (S === "link" && n) {
    const Z = Array.from(t.styleSheets).find((Y) => Y.href === s.href);
    let I = null;
    Z && (I = Ss(Z)), I && (delete y.rel, delete y.href, y._cssText = I);
  }
  if (S === "style" && s.sheet) {
    let Z = Ss(
      s.sheet
    );
    Z && (s.childNodes.length > 1 && (Z = vc(Z, s)), y._cssText = Z);
  }
  if (S === "input" || S === "textarea" || S === "select") {
    const Z = s.value, I = s.checked;
    y.type !== "radio" && y.type !== "checkbox" && y.type !== "submit" && y.type !== "button" && Z ? y.value = Ci({
      element: s,
      type: wi(s),
      tagName: S,
      value: Z,
      overwriteRecord: s.getAttribute("data-hl-record"),
      maskInputOptions: o,
      maskInputFn: a
    }) : I && (y.checked = I);
  }
  if (S === "option" && (s.selected && !o.select ? y.selected = !0 : delete y.selected), S === "dialog" && s.open && (y.rr_open_mode = s.matches("dialog:modal") ? "modal" : "non-modal"), S === "canvas" && p) {
    if (s.__context === "2d")
      Wc(s);
    else if (!("__context" in s)) {
      const Z = s.toDataURL(
        u.type,
        u.quality
      ), I = t.createElement("canvas");
      I.width = s.width, I.height = s.height;
      const Y = I.toDataURL(
        u.type,
        u.quality
      );
      Z !== Y && (y.rr_dataURL = Z);
    }
  }
  if (S === "img" && c && !V && !G && !g) {
    st || (st = t.createElement("canvas"), $r = st.getContext("2d"));
    const Z = s, I = Z.currentSrc || Z.getAttribute("src") || "<unknown-src>", Y = Z.crossOrigin, v = () => {
      Z.removeEventListener("load", v);
      try {
        st.width = Z.naturalWidth, st.height = Z.naturalHeight, $r.drawImage(Z, 0, 0), y.rr_dataURL = st.toDataURL(
          u.type,
          u.quality
        );
      } catch (Q) {
        if (Z.crossOrigin !== "anonymous") {
          Z.crossOrigin = "anonymous", Z.complete && Z.naturalWidth !== 0 ? v() : Z.addEventListener("load", v);
          return;
        } else
          console.warn(
            `Cannot inline img src=${I}! Error: ${Q}`
          );
      }
      Z.crossOrigin === "anonymous" && (Y ? y.crossOrigin = Y : Z.removeAttribute("crossorigin"));
    };
    Z.complete && Z.naturalWidth !== 0 ? v() : Z.addEventListener("load", v);
  }
  if (S === "audio" || S === "video") {
    const Z = y;
    Z.rr_mediaState = s.paused ? "paused" : "played", Z.rr_mediaCurrentTime = s.currentTime, Z.rr_mediaPlaybackRate = s.playbackRate, Z.rr_mediaMuted = s.muted, Z.rr_mediaLoop = s.loop, Z.rr_mediaVolume = s.volume;
  }
  if (b || (s.scrollLeft && (y.rr_scrollLeft = s.scrollLeft), s.scrollTop && (y.rr_scrollTop = s.scrollTop)), V || G || g && Is(S)) {
    const { width: Z, height: I } = s.getBoundingClientRect();
    y = {
      class: y.class,
      rr_width: `${Z}px`,
      rr_height: `${I}px`
    };
  }
  g && Is(S) && (V = !0), S === "iframe" && !d(y.src) && (s.contentDocument || (y.rr_src = y.src), delete y.src);
  let C;
  try {
    customElements.get(S) && (C = !0);
  } catch (Z) {
  }
  const R = (Z) => {
    const { width: I, height: Y } = Z.getBoundingClientRect();
    y = {
      width: I,
      height: Y,
      rr_width: `${I}px`,
      rr_height: `${Y}px`,
      rr_inlined_video: !0,
      class: y.class,
      style: y.style
    }, S = "canvas";
    const v = t.createElement("canvas");
    v.width = s.width, v.height = s.height, y.rr_dataURL = v.toDataURL(
      u.type,
      u.quality
    );
  };
  if (S === "video") {
    const Z = s;
    c && (Z.src === "" || Z.src.indexOf("blob:") !== -1) && R(Z), h && Z.src !== "" && Z.src.indexOf("blob:") === -1 && R(Z);
  }
  return {
    type: ie.Element,
    tagName: S,
    attributes: y,
    childNodes: [],
    isSVG: Dc(s) || void 0,
    needBlock: V,
    needMask: G,
    rootId: f,
    isCustom: C
  };
}
function B(s) {
  return s == null ? "" : s.toLowerCase();
}
function tu(s, e) {
  if (e.comment && s.type === ie.Comment)
    return !0;
  if (s.type === ie.Element) {
    if (e.script && // script tag
    (s.tagName === "script" || // (module)preload link
    s.tagName === "link" && (s.attributes.rel === "preload" && s.attributes.as === "script" || s.attributes.rel === "modulepreload") || // prefetch link
    s.tagName === "link" && s.attributes.rel === "prefetch" && typeof s.attributes.href == "string" && bl(s.attributes.href) === "js"))
      return !0;
    if (e.headFavicon && (s.tagName === "link" && s.attributes.rel === "shortcut icon" || s.tagName === "meta" && (B(s.attributes.name).match(
      /^msapplication-tile(image|color)$/
    ) || B(s.attributes.name) === "application-name" || B(s.attributes.rel) === "icon" || B(s.attributes.rel) === "apple-touch-icon" || B(s.attributes.rel) === "shortcut icon")))
      return !0;
    if (s.tagName === "meta") {
      if (e.headMetaDescKeywords && B(s.attributes.name).match(/^description|keywords$/))
        return !0;
      if (e.headMetaSocial && (B(s.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      B(s.attributes.name).match(/^(og|twitter):/) || B(s.attributes.name) === "pinterest"))
        return !0;
      if (e.headMetaRobots && (B(s.attributes.name) === "robots" || B(s.attributes.name) === "googlebot" || B(s.attributes.name) === "bingbot"))
        return !0;
      if (e.headMetaHttpEquiv && s.attributes["http-equiv"] !== void 0)
        return !0;
      if (e.headMetaAuthorship && (B(s.attributes.name) === "author" || B(s.attributes.name) === "generator" || B(s.attributes.name) === "framework" || B(s.attributes.name) === "publisher" || B(s.attributes.name) === "progid" || B(s.attributes.property).match(/^article:/) || B(s.attributes.property).match(/^product:/)))
        return !0;
      if (e.headMetaVerification && (B(s.attributes.name) === "google-site-verification" || B(s.attributes.name) === "yandex-verification" || B(s.attributes.name) === "csrf-token" || B(s.attributes.name) === "p:domain_verify" || B(s.attributes.name) === "verify-v1" || B(s.attributes.name) === "verification" || B(s.attributes.name) === "shopify-checkout-api-token"))
        return !0;
    }
  }
  return !1;
}
function ot(s, e) {
  const {
    doc: t,
    mirror: i,
    blockClass: r,
    blockSelector: n,
    maskTextClass: o,
    maskTextSelector: a,
    skipChild: l = !1,
    inlineStylesheet: u = !0,
    maskInputOptions: c = {},
    maskTextFn: h,
    maskInputFn: p,
    slimDOMOptions: d,
    dataURLOptions: b = {},
    inlineImages: m = !1,
    inlineVideos: f = !1,
    recordCanvas: V = !1,
    onSerialize: G,
    onIframeLoad: g,
    iframeLoadTimeout: S = 5e3,
    onStylesheetLoad: y,
    stylesheetLoadTimeout: W = 5e3,
    keepIframeSrcFn: C = () => !1,
    newlyAddedElement: R = !1,
    cssCaptured: Z = !1,
    privacySetting: I
  } = e;
  let { needsMask: Y } = e, { preserveWhiteSpace: v = !0 } = e;
  Y || (Y = Sl(
    s,
    o,
    a,
    Y === void 0
  ));
  const Q = _c(s, {
    doc: t,
    mirror: i,
    blockClass: r,
    blockSelector: n,
    needsMask: Y,
    inlineStylesheet: u,
    maskInputOptions: c,
    maskTextClass: o,
    maskTextFn: h,
    maskInputFn: p,
    dataURLOptions: b,
    inlineImages: m,
    inlineVideos: f,
    recordCanvas: V,
    keepIframeSrcFn: C,
    newlyAddedElement: R,
    cssCaptured: Z,
    privacySetting: I
  });
  if (!Q)
    return console.warn(s, "not serialized"), null;
  let A;
  i.hasNode(s) ? A = i.getId(s) : tu(Q, d) || !v && Q.type === ie.Text && !Q.textContent.replace(/^\s+|\s+$/gm, "").length ? A = vt : A = gl();
  const w = Object.assign(Q, { id: A });
  if (i.add(s, w), A === vt)
    return null;
  G && G(s);
  let te = !l, H = I, D = I === "strict";
  if (w.type === ie.Element) {
    if (te = te && !w.needBlock, D || (D = !!w.needBlock || !!w.needMask), H = D ? "strict" : H, D && Is(w.tagName)) {
      const O = s.cloneNode();
      O.src = "", i.add(O, w);
    }
    delete w.needBlock, delete w.needMask;
    const E = le.shadowRoot(s);
    E && xt(E) && (w.isShadowHost = !0);
  }
  if ((w.type === ie.Document || w.type === ie.Element) && te) {
    d.headWhitespace && w.type === ie.Element && w.tagName === "head" && (v = !1);
    const E = {
      doc: t,
      mirror: i,
      blockClass: r,
      blockSelector: n,
      needsMask: Y,
      maskTextClass: o,
      maskTextSelector: a,
      skipChild: l,
      inlineStylesheet: u,
      maskInputOptions: c,
      maskTextFn: h,
      maskInputFn: p,
      slimDOMOptions: d,
      dataURLOptions: b,
      inlineImages: m,
      inlineVideos: f,
      recordCanvas: V,
      preserveWhiteSpace: v,
      onSerialize: G,
      onIframeLoad: g,
      iframeLoadTimeout: S,
      onStylesheetLoad: y,
      stylesheetLoadTimeout: W,
      keepIframeSrcFn: C,
      cssCaptured: !1,
      privacySetting: H
    };
    if (!(w.type === ie.Element && w.tagName === "textarea" && w.attributes.value !== void 0)) {
      w.type === ie.Element && w.attributes._cssText !== void 0 && typeof w.attributes._cssText == "string" && (E.cssCaptured = !0);
      for (const pe of Array.from(le.childNodes(s))) {
        const ae = ot(pe, E);
        ae && w.childNodes.push(ae);
      }
    }
    let O = null;
    if (pl(s) && (O = le.shadowRoot(s)))
      for (const pe of Array.from(le.childNodes(O))) {
        const ae = ot(pe, E);
        ae && (xt(O) && (ae.isShadow = !0), w.childNodes.push(ae));
      }
  }
  const ee = le.parentNode(s);
  return ee && wt(ee) && xt(ee) && (w.isShadow = !0), w.type === ie.Element && w.tagName === "iframe" && jc(
    s,
    () => {
      const E = s.contentDocument;
      if (E && g) {
        const O = ot(E, {
          doc: E,
          mirror: i,
          blockClass: r,
          blockSelector: n,
          needsMask: Y,
          maskTextClass: o,
          maskTextSelector: a,
          skipChild: !1,
          inlineStylesheet: u,
          maskInputOptions: c,
          maskTextFn: h,
          maskInputFn: p,
          slimDOMOptions: d,
          dataURLOptions: b,
          inlineImages: m,
          inlineVideos: f,
          recordCanvas: V,
          preserveWhiteSpace: v,
          onSerialize: G,
          onIframeLoad: g,
          iframeLoadTimeout: S,
          onStylesheetLoad: y,
          stylesheetLoadTimeout: W,
          keepIframeSrcFn: C,
          privacySetting: I
        });
        O && g(
          s,
          O
        );
      }
    },
    S
  ), w.type === ie.Element && w.tagName === "link" && typeof w.attributes.rel == "string" && (w.attributes.rel === "stylesheet" || w.attributes.rel === "preload" && typeof w.attributes.href == "string" && bl(w.attributes.href) === "css") && Ac(
    s,
    () => {
      if (y) {
        const E = ot(s, {
          doc: t,
          mirror: i,
          blockClass: r,
          blockSelector: n,
          needsMask: Y,
          maskTextClass: o,
          maskTextSelector: a,
          skipChild: !1,
          inlineStylesheet: u,
          maskInputOptions: c,
          maskTextFn: h,
          maskInputFn: p,
          slimDOMOptions: d,
          dataURLOptions: b,
          inlineImages: m,
          inlineVideos: f,
          recordCanvas: V,
          preserveWhiteSpace: v,
          onSerialize: G,
          onIframeLoad: g,
          iframeLoadTimeout: S,
          onStylesheetLoad: y,
          stylesheetLoadTimeout: W,
          keepIframeSrcFn: C,
          privacySetting: I
        });
        E && y(
          s,
          E
        );
      }
    },
    W
  ), w;
}
function iu(s, e) {
  const {
    mirror: t = new fl(),
    blockClass: i = "highlight-block",
    blockSelector: r = null,
    maskTextClass: n = "highlight-mask",
    maskTextSelector: o = null,
    inlineStylesheet: a = !0,
    inlineImages: l = !1,
    inlineVideos: u = !1,
    recordCanvas: c = !1,
    maskAllInputs: h = !1,
    maskTextFn: p,
    maskInputFn: d,
    slimDOM: b = !1,
    dataURLOptions: m,
    preserveWhiteSpace: f,
    onSerialize: V,
    onIframeLoad: G,
    iframeLoadTimeout: g,
    onStylesheetLoad: S,
    stylesheetLoadTimeout: y,
    keepIframeSrcFn: W = () => !1,
    privacySetting: C = "default"
  } = e || {};
  return ot(s, {
    doc: s,
    mirror: t,
    blockClass: i,
    blockSelector: r,
    maskTextClass: n,
    maskTextSelector: o,
    skipChild: !1,
    inlineStylesheet: a,
    maskInputOptions: h === !0 ? {
      color: !0,
      date: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0,
      textarea: !0,
      select: !0,
      password: !0
    } : h === !1 ? {
      password: !0
    } : h,
    maskTextFn: p,
    maskInputFn: d,
    slimDOMOptions: b || b === "all" ? (
      // if true: set of sensible options that should not throw away any information
      {
        script: !0,
        comment: !0,
        headFavicon: !0,
        headWhitespace: !0,
        headMetaDescKeywords: b === "all",
        // destructive
        headMetaSocial: !0,
        headMetaRobots: !0,
        headMetaHttpEquiv: !0,
        headMetaAuthorship: !0,
        headMetaVerification: !0
      }
    ) : b || {},
    dataURLOptions: m,
    inlineImages: l,
    inlineVideos: u,
    recordCanvas: c,
    preserveWhiteSpace: f,
    onSerialize: V,
    onIframeLoad: G,
    iframeLoadTimeout: g,
    onStylesheetLoad: S,
    stylesheetLoadTimeout: y,
    keepIframeSrcFn: W,
    newlyAddedElement: !1,
    privacySetting: C
  });
}
function su(s) {
  if (s.__esModule) return s;
  var e = s.default;
  if (typeof e == "function") {
    var t = function i() {
      return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(s).forEach(function(i) {
    var r = Object.getOwnPropertyDescriptor(s, i);
    Object.defineProperty(t, i, r.get ? r : {
      enumerable: !0,
      get: function() {
        return s[i];
      }
    });
  }), t;
}
var ur = { exports: {} }, k = String, Il = function() {
  return { isColorSupported: !1, reset: k, bold: k, dim: k, italic: k, underline: k, inverse: k, hidden: k, strikethrough: k, black: k, red: k, green: k, yellow: k, blue: k, magenta: k, cyan: k, white: k, gray: k, bgBlack: k, bgRed: k, bgGreen: k, bgYellow: k, bgBlue: k, bgMagenta: k, bgCyan: k, bgWhite: k, blackBright: k, redBright: k, greenBright: k, yellowBright: k, blueBright: k, magentaBright: k, cyanBright: k, whiteBright: k, bgBlackBright: k, bgRedBright: k, bgGreenBright: k, bgYellowBright: k, bgBlueBright: k, bgMagentaBright: k, bgCyanBright: k, bgWhiteBright: k };
};
ur.exports = Il();
ur.exports.createColors = Il;
var ru = ur.exports;
const nu = {}, lu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: nu
}, Symbol.toStringTag, { value: "Module" })), Ge = /* @__PURE__ */ su(lu);
let tn = ru, sn = Ge, Vs = class Vl extends Error {
  constructor(e, t, i, r, n, o) {
    super(e), this.name = "CssSyntaxError", this.reason = e, n && (this.file = n), r && (this.source = r), o && (this.plugin = o), typeof t != "undefined" && typeof i != "undefined" && (typeof t == "number" ? (this.line = t, this.column = i) : (this.line = t.line, this.column = t.column, this.endLine = i.line, this.endColumn = i.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, Vl);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line != "undefined" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source) return "";
    let t = this.source;
    e == null && (e = tn.isColorSupported);
    let i = (c) => c, r = (c) => c, n = (c) => c;
    if (e) {
      let { bold: c, gray: h, red: p } = tn.createColors(!0);
      r = (d) => c(p(d)), i = (d) => h(d), sn && (n = (d) => sn(d));
    }
    let o = t.split(/\r?\n/), a = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, o.length), u = String(l).length;
    return o.slice(a, l).map((c, h) => {
      let p = a + 1 + h, d = " " + (" " + p).slice(-u) + " | ";
      if (p === this.line) {
        if (c.length > 160) {
          let m = 20, f = Math.max(0, this.column - m), V = Math.max(
            this.column + m,
            this.endColumn + m
          ), G = c.slice(f, V), g = i(d.replace(/\d/g, " ")) + c.slice(0, Math.min(this.column - 1, m - 1)).replace(/[^\t]/g, " ");
          return r(">") + i(d) + n(G) + `
 ` + g + r("^");
        }
        let b = i(d.replace(/\d/g, " ")) + c.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return r(">") + i(d) + n(c) + `
 ` + b + r("^");
      }
      return " " + i(d) + n(c);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var hr = Vs;
Vs.default = Vs;
const rn = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function ou(s) {
  return s[0].toUpperCase() + s.slice(1);
}
let Rs = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let i = "@" + e.name, r = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName != "undefined" ? i += e.raws.afterName : r && (i += " "), e.nodes)
      this.block(e, i + r);
    else {
      let n = (e.raws.between || "") + (t ? ";" : "");
      this.builder(i + r + n, e);
    }
  }
  beforeAfter(e, t) {
    let i;
    e.type === "decl" ? i = this.raw(e, null, "beforeDecl") : e.type === "comment" ? i = this.raw(e, null, "beforeComment") : t === "before" ? i = this.raw(e, null, "beforeRule") : i = this.raw(e, null, "beforeClose");
    let r = e.parent, n = 0;
    for (; r && r.type !== "root"; )
      n += 1, r = r.parent;
    if (i.includes(`
`)) {
      let o = this.raw(e, null, "indent");
      if (o.length)
        for (let a = 0; a < n; a++) i += o;
    }
    return i;
  }
  block(e, t) {
    let i = this.raw(e, "between", "beforeOpen");
    this.builder(t + i + "{", e, "start");
    let r;
    e.nodes && e.nodes.length ? (this.body(e), r = this.raw(e, "after")) : r = this.raw(e, "after", "emptyBody"), r && this.builder(r), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let i = this.raw(e, "semicolon");
    for (let r = 0; r < e.nodes.length; r++) {
      let n = e.nodes[r], o = this.raw(n, "before");
      o && this.builder(o), this.stringify(n, t !== r || i);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), i = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + i + "*/", e);
  }
  decl(e, t) {
    let i = this.raw(e, "between", "colon"), r = e.prop + i + this.rawValue(e, "value");
    e.important && (r += e.raws.important || " !important"), t && (r += ";"), this.builder(r, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, i) {
    let r;
    if (i || (i = t), t && (r = e.raws[t], typeof r != "undefined"))
      return r;
    let n = e.parent;
    if (i === "before" && (!n || n.type === "root" && n.first === e || n && n.type === "document"))
      return "";
    if (!n) return rn[i];
    let o = e.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[i] != "undefined")
      return o.rawCache[i];
    if (i === "before" || i === "after")
      return this.beforeAfter(e, i);
    {
      let a = "raw" + ou(i);
      this[a] ? r = this[a](o, e) : o.walk((l) => {
        if (r = l.raws[t], typeof r != "undefined") return !1;
      });
    }
    return typeof r == "undefined" && (r = rn[i]), o.rawCache[i] = r, r;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length > 0 && typeof i.raws.after != "undefined")
        return t = i.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let i;
    return e.walkComments((r) => {
      if (typeof r.raws.before != "undefined")
        return i = r.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), typeof i == "undefined" ? i = this.raw(t, null, "beforeDecl") : i && (i = i.replace(/\S/g, "")), i;
  }
  rawBeforeDecl(e, t) {
    let i;
    return e.walkDecls((r) => {
      if (typeof r.raws.before != "undefined")
        return i = r.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), typeof i == "undefined" ? i = this.raw(t, null, "beforeRule") : i && (i = i.replace(/\S/g, "")), i;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((i) => {
      if (i.type !== "decl" && (t = i.raws.between, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && (i.parent !== e || e.first !== i) && typeof i.raws.before != "undefined")
        return t = i.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((i) => {
      if (typeof i.raws.between != "undefined")
        return t = i.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length === 0 && (t = i.raws.after, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((i) => {
      let r = i.parent;
      if (r && r !== e && r.parent && r.parent === e && typeof i.raws.before != "undefined") {
        let n = i.raws.before.split(`
`);
        return t = n[n.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length && i.last.type === "decl" && (t = i.raws.semicolon, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let i = e[t], r = e.raws[t];
    return r && r.value === i ? r.raw : i;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var Rl = Rs;
Rs.default = Rs;
let au = Rl;
function Ws(s, e) {
  new au(e).stringify(s);
}
var Oi = Ws;
Ws.default = Ws;
var Pt = {};
Pt.isClean = Symbol("isClean");
Pt.my = Symbol("my");
let cu = hr, uu = Rl, hu = Oi, { isClean: Xt, my: du } = Pt;
function Cs(s, e) {
  let t = new s.constructor();
  for (let i in s) {
    if (!Object.prototype.hasOwnProperty.call(s, i) || i === "proxyCache") continue;
    let r = s[i], n = typeof r;
    i === "parent" && n === "object" ? e && (t[i] = e) : i === "source" ? t[i] = r : Array.isArray(r) ? t[i] = r.map((o) => Cs(o, t)) : (n === "object" && r !== null && (r = Cs(r)), t[i] = r);
  }
  return t;
}
function Le(s, e) {
  if (e && typeof e.offset != "undefined")
    return e.offset;
  let t = 1, i = 1, r = 0;
  for (let n = 0; n < s.length; n++) {
    if (i === e.line && t === e.column) {
      r = n;
      break;
    }
    s[n] === `
` ? (t = 1, i += 1) : t += 1;
  }
  return r;
}
let ws = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[Xt] = !1, this[du] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let i of e[t])
          typeof i.clone == "function" ? this.append(i.clone()) : this.append(i);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = Cs(this);
    for (let i in e)
      t[i] = e[i];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: i, start: r } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: r.column, line: r.line },
        { column: i.column, line: i.line },
        t
      );
    }
    return new cu(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, i) {
        return e[t] === i || (e[t] = i, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[Xt] = !0;
  }
  markDirty() {
    if (this[Xt]) {
      this[Xt] = !1;
      let e = this;
      for (; e = e.parent; )
        e[Xt] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e = {}) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let i = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = i.slice(
        Le(i, this.source.start),
        Le(i, this.source.end)
      ).indexOf(e.word);
      n !== -1 && (t = this.positionInside(n));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, i = this.source.start.line, r = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = Le(r, this.source.start), o = n + e;
    for (let a = n; a < o; a++)
      r[a] === `
` ? (t = 1, i += 1) : t += 1;
    return { column: t, line: i, offset: o };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e = {}) {
    let t = "document" in this.source.input ? this.source.input.document : this.source.input.css, i = {
      column: this.source.start.column,
      line: this.source.start.line,
      offset: Le(t, this.source.start)
    }, r = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line,
      offset: typeof this.source.end.offset == "number" ? (
        // `source.end.offset` is exclusive, so we don't need to add 1
        this.source.end.offset
      ) : (
        // Since line/column in this.source.end is inclusive,
        // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
        // So, we add 1 to convert it to exclusive.
        Le(t, this.source.end) + 1
      )
    } : {
      column: i.column + 1,
      line: i.line,
      offset: i.offset + 1
    };
    if (e.word) {
      let o = t.slice(
        Le(t, this.source.start),
        Le(t, this.source.end)
      ).indexOf(e.word);
      o !== -1 && (i = this.positionInside(o), r = this.positionInside(o + e.word.length));
    } else
      e.start ? i = {
        column: e.start.column,
        line: e.start.line,
        offset: Le(t, e.start)
      } : e.index && (i = this.positionInside(e.index)), e.end ? r = {
        column: e.end.column,
        line: e.end.line,
        offset: Le(t, e.end)
      } : typeof e.endIndex == "number" ? r = this.positionInside(e.endIndex) : e.index && (r = this.positionInside(e.index + 1));
    return (r.line < i.line || r.line === i.line && r.column <= i.column) && (r = {
      column: i.column + 1,
      line: i.line,
      offset: i.offset + 1
    }), { end: r, start: i };
  }
  raw(e, t) {
    return new uu().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, i = !1;
      for (let r of e)
        r === this ? i = !0 : i ? (this.parent.insertAfter(t, r), t = r) : this.parent.insertBefore(t, r);
      i || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let i = {}, r = t == null;
    t = t || /* @__PURE__ */ new Map();
    let n = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
      let a = this[o];
      if (Array.isArray(a))
        i[o] = a.map((l) => typeof l == "object" && l.toJSON ? l.toJSON(null, t) : l);
      else if (typeof a == "object" && a.toJSON)
        i[o] = a.toJSON(null, t);
      else if (o === "source") {
        if (a == null) continue;
        let l = t.get(a.input);
        l == null && (l = n, t.set(a.input, n), n++), i[o] = {
          end: a.end,
          inputId: l,
          start: a.start
        };
      } else
        i[o] = a;
    }
    return r && (i.inputs = [...t.keys()].map((o) => o.toJSON())), i;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = hu) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (i) => {
      t += i;
    }), t;
  }
  warn(e, t, i = {}) {
    let r = { node: this };
    for (let n in i) r[n] = i[n];
    return e.warn(t, r);
  }
};
var Pi = ws;
ws.default = ws;
let pu = Pi, xs = class extends pu {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var Ei = xs;
xs.default = xs;
let mu = Pi, Ls = class extends mu {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value != "undefined" && typeof e.value != "string" && (e = re(x({}, e), { value: String(e.value) })), super(e), this.type = "decl";
  }
};
var Bi = Ls;
Ls.default = Ls;
let Wl = Ei, Cl = Bi, fu = Pi, { isClean: wl, my: xl } = Pt, dr, Ll, kl, pr;
function Jl(s) {
  return s.map((e) => (e.nodes && (e.nodes = Jl(e.nodes)), delete e.source, e));
}
function vl(s) {
  if (s[wl] = !1, s.proxyOf.nodes)
    for (let e of s.proxyOf.nodes)
      vl(e);
}
let Ne = class Yl extends fu {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...e) {
    for (let t of e) {
      let i = this.normalize(t, this.last);
      for (let r of i) this.proxyOf.nodes.push(r);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let t of this.nodes) t.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes) return;
    let t = this.getIterator(), i, r;
    for (; this.indexes[t] < this.proxyOf.nodes.length && (i = this.indexes[t], r = e(this.proxyOf.nodes[i], i), r !== !1); )
      this.indexes[t] += 1;
    return delete this.indexes[t], r;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : e[t] ? t === "each" || typeof t == "string" && t.startsWith("walk") ? (...i) => e[t](
          ...i.map((r) => typeof r == "function" ? (n, o) => r(n.toProxy(), o) : r)
        ) : t === "every" || t === "some" ? (i) => e[t](
          (r, ...n) => i(r.toProxy(), ...n)
        ) : t === "root" ? () => e.root().toProxy() : t === "nodes" ? e.nodes.map((i) => i.toProxy()) : t === "first" || t === "last" ? e[t].toProxy() : e[t] : e[t];
      },
      set(e, t, i) {
        return e[t] === i || (e[t] = i, (t === "name" || t === "params" || t === "selector") && e.markDirty()), !0;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, t) {
    let i = this.index(e), r = this.normalize(t, this.proxyOf.nodes[i]).reverse();
    i = this.index(e);
    for (let o of r) this.proxyOf.nodes.splice(i + 1, 0, o);
    let n;
    for (let o in this.indexes)
      n = this.indexes[o], i < n && (this.indexes[o] = n + r.length);
    return this.markDirty(), this;
  }
  insertBefore(e, t) {
    let i = this.index(e), r = i === 0 ? "prepend" : !1, n = this.normalize(
      t,
      this.proxyOf.nodes[i],
      r
    ).reverse();
    i = this.index(e);
    for (let a of n) this.proxyOf.nodes.splice(i, 0, a);
    let o;
    for (let a in this.indexes)
      o = this.indexes[a], i <= o && (this.indexes[a] = o + n.length);
    return this.markDirty(), this;
  }
  normalize(e, t) {
    if (typeof e == "string")
      e = Jl(Ll(e).nodes);
    else if (typeof e == "undefined")
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let r of e)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let r of e)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value == "undefined")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new Cl(e)];
    } else if (e.selector || e.selectors)
      e = [new pr(e)];
    else if (e.name)
      e = [new dr(e)];
    else if (e.text)
      e = [new Wl(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((r) => (r[xl] || Yl.rebuild(r), r = r.proxyOf, r.parent && r.parent.removeChild(r), r[wl] && vl(r), r.raws || (r.raws = {}), typeof r.raws.before == "undefined" && t && typeof t.raws.before != "undefined" && (r.raws.before = t.raws.before.replace(/\S/g, "")), r.parent = this.proxyOf, r));
  }
  prepend(...e) {
    e = e.reverse();
    for (let t of e) {
      let i = this.normalize(t, this.first, "prepend").reverse();
      for (let r of i) this.proxyOf.nodes.unshift(r);
      for (let r in this.indexes)
        this.indexes[r] = this.indexes[r] + i.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes) e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let t;
    for (let i in this.indexes)
      t = this.indexes[i], t >= e && (this.indexes[i] = t - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, t, i) {
    return i || (i = t, t = {}), this.walkDecls((r) => {
      t.props && !t.props.includes(r.prop) || t.fast && !r.value.includes(t.fast) || (r.value = r.value.replace(e, i));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((t, i) => {
      let r;
      try {
        r = e(t, i);
      } catch (n) {
        throw t.addToError(n);
      }
      return r !== !1 && t.walk && (r = t.walk(e)), r;
    });
  }
  walkAtRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "atrule" && e.test(i.name))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "atrule" && i.name === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "atrule")
        return t(i, r);
    }));
  }
  walkComments(e) {
    return this.walk((t, i) => {
      if (t.type === "comment")
        return e(t, i);
    });
  }
  walkDecls(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "decl" && e.test(i.prop))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "decl" && i.prop === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "decl")
        return t(i, r);
    }));
  }
  walkRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "rule" && e.test(i.selector))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "rule" && i.selector === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "rule")
        return t(i, r);
    }));
  }
};
Ne.registerParse = (s) => {
  Ll = s;
};
Ne.registerRule = (s) => {
  pr = s;
};
Ne.registerAtRule = (s) => {
  dr = s;
};
Ne.registerRoot = (s) => {
  kl = s;
};
var _e = Ne;
Ne.default = Ne;
Ne.rebuild = (s) => {
  s.type === "atrule" ? Object.setPrototypeOf(s, dr.prototype) : s.type === "rule" ? Object.setPrototypeOf(s, pr.prototype) : s.type === "decl" ? Object.setPrototypeOf(s, Cl.prototype) : s.type === "comment" ? Object.setPrototypeOf(s, Wl.prototype) : s.type === "root" && Object.setPrototypeOf(s, kl.prototype), s[xl] = !0, s.nodes && s.nodes.forEach((e) => {
    Ne.rebuild(e);
  });
};
let Nl = _e, ki = class extends Nl {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var mr = ki;
ki.default = ki;
Nl.registerAtRule(ki);
let bu = _e, Tl, Ul, Yt = class extends bu {
  constructor(e) {
    super(x({ type: "document" }, e)), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new Tl(new Ul(), this, e).stringify();
  }
};
Yt.registerLazyResult = (s) => {
  Tl = s;
};
Yt.registerProcessor = (s) => {
  Ul = s;
};
var fr = Yt;
Yt.default = Yt;
let Zu = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", yu = (s = 21) => {
  let e = "", t = s | 0;
  for (; t--; )
    e += Zu[Math.random() * 64 | 0];
  return e;
};
var gu = { nanoid: yu };
let { existsSync: Xu, readFileSync: Gu } = Ge, { dirname: as, join: Su } = Ge, { SourceMapConsumer: nn, SourceMapGenerator: ln } = Ge;
function Iu(s) {
  return Buffer ? Buffer.from(s, "base64").toString() : window.atob(s);
}
let ks = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let i = t.map ? t.map.prev : void 0, r = this.loadMap(t.from, i);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = as(this.mapFile)), r && (this.text = r);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new nn(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, i = /^data:application\/json;base64,/, r = /^data:application\/json;charset=utf-?8,/, n = /^data:application\/json,/, o = e.match(r) || e.match(n);
    if (o)
      return decodeURIComponent(e.substr(o[0].length));
    let a = e.match(t) || e.match(i);
    if (a)
      return Iu(e.substr(a[0].length));
    let l = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + l);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let i = e.lastIndexOf(t.pop()), r = e.indexOf("*/", i);
    i > -1 && r > -1 && (this.annotation = this.getAnnotationURL(e.substring(i, r)));
  }
  loadFile(e) {
    if (this.root = as(e), Xu(e))
      return this.mapFile = e, Gu(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let i = t(e);
        if (i) {
          let r = this.loadFile(i);
          if (!r)
            throw new Error(
              "Unable to load previous source map: " + i.toString()
            );
          return r;
        }
      } else {
        if (t instanceof nn)
          return ln.fromSourceMap(t).toString();
        if (t instanceof ln)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let i = this.annotation;
        return e && (i = Su(as(e), i)), this.loadFile(i);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var Kl = ks;
ks.default = ks;
let { nanoid: Vu } = gu, { isAbsolute: Js, resolve: vs } = Ge, { SourceMapConsumer: Ru, SourceMapGenerator: Wu } = Ge, { fileURLToPath: on, pathToFileURL: ei } = Ge, an = hr, Cu = Kl, cs = Ge, us = Symbol("lineToIndexCache"), wu = !!(Ru && Wu), cn = !!(vs && Js);
function un(s) {
  if (s[us]) return s[us];
  let e = s.css.split(`
`), t = new Array(e.length), i = 0;
  for (let r = 0, n = e.length; r < n; r++)
    t[r] = i, i += e[r].length + 1;
  return s[us] = t, t;
}
let Ji = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, t = {}) {
    if (e === null || typeof e == "undefined" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!cn || /^\w+:\/\//.test(t.from) || Js(t.from) ? this.file = t.from : this.file = vs(t.from)), cn && wu) {
      let i = new Cu(this.css, t);
      if (i.text) {
        this.map = i;
        let r = i.consumer().file;
        !this.file && r && (this.file = this.mapResolve(r));
      }
    }
    this.file || (this.id = "<input css " + Vu(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, i, r = {}) {
    let n, o, a, l, u;
    if (t && typeof t == "object") {
      let h = t, p = i;
      if (typeof h.offset == "number") {
        l = h.offset;
        let d = this.fromOffset(l);
        t = d.line, i = d.col;
      } else
        t = h.line, i = h.column, l = this.fromLineAndColumn(t, i);
      if (typeof p.offset == "number") {
        a = p.offset;
        let d = this.fromOffset(a);
        o = d.line, n = d.col;
      } else
        o = p.line, n = p.column, a = this.fromLineAndColumn(p.line, p.column);
    } else if (i)
      l = this.fromLineAndColumn(t, i);
    else {
      l = t;
      let h = this.fromOffset(l);
      t = h.line, i = h.col;
    }
    let c = this.origin(t, i, o, n);
    return c ? u = new an(
      e,
      c.endLine === void 0 ? c.line : { column: c.column, line: c.line },
      c.endLine === void 0 ? c.column : { column: c.endColumn, line: c.endLine },
      c.source,
      c.file,
      r.plugin
    ) : u = new an(
      e,
      o === void 0 ? t : { column: i, line: t },
      o === void 0 ? i : { column: n, line: o },
      this.css,
      this.file,
      r.plugin
    ), u.input = { column: i, endColumn: n, endLine: o, endOffset: a, line: t, offset: l, source: this.css }, this.file && (ei && (u.input.url = ei(this.file).toString()), u.input.file = this.file), u;
  }
  fromLineAndColumn(e, t) {
    return un(this)[e - 1] + t - 1;
  }
  fromOffset(e) {
    let t = un(this), i = t[t.length - 1], r = 0;
    if (e >= i)
      r = t.length - 1;
    else {
      let n = t.length - 2, o;
      for (; r < n; )
        if (o = r + (n - r >> 1), e < t[o])
          n = o - 1;
        else if (e >= t[o + 1])
          r = o + 1;
        else {
          r = o;
          break;
        }
    }
    return {
      col: e - t[r] + 1,
      line: r + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : vs(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, i, r) {
    if (!this.map) return !1;
    let n = this.map.consumer(), o = n.originalPositionFor({ column: t, line: e });
    if (!o.source) return !1;
    let a;
    typeof i == "number" && (a = n.originalPositionFor({ column: r, line: i }));
    let l;
    Js(o.source) ? l = ei(o.source) : l = new URL(
      o.source,
      this.map.consumer().sourceRoot || ei(this.map.mapFile)
    );
    let u = {
      column: o.column,
      endColumn: a && a.column,
      endLine: a && a.line,
      line: o.line,
      url: l.toString()
    };
    if (l.protocol === "file:")
      if (on)
        u.file = on(l);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let c = n.sourceContentFor(o.source);
    return c && (u.source = c), u;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = x({}, this.map), e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var Qi = Ji;
Ji.default = Ji;
cs && cs.registerInput && cs.registerInput(Ji);
let Fl = _e, Ml, zl, ut = class extends Fl {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, i) {
    let r = super.normalize(e);
    if (t) {
      if (i === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let n of r)
          n.raws.before = t.raws.before;
    }
    return r;
  }
  removeChild(e, t) {
    let i = this.index(e);
    return !t && i === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[i].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new Ml(new zl(), this, e).stringify();
  }
};
ut.registerLazyResult = (s) => {
  Ml = s;
};
ut.registerProcessor = (s) => {
  zl = s;
};
var Et = ut;
ut.default = ut;
Fl.registerRoot(ut);
let Nt = {
  comma(s) {
    return Nt.split(s, [","], !0);
  },
  space(s) {
    let e = [" ", `
`, "	"];
    return Nt.split(s, e);
  },
  split(s, e, t) {
    let i = [], r = "", n = !1, o = 0, a = !1, l = "", u = !1;
    for (let c of s)
      u ? u = !1 : c === "\\" ? u = !0 : a ? c === l && (a = !1) : c === '"' || c === "'" ? (a = !0, l = c) : c === "(" ? o += 1 : c === ")" ? o > 0 && (o -= 1) : o === 0 && e.includes(c) && (n = !0), n ? (r !== "" && i.push(r.trim()), r = "", n = !1) : r += c;
    return (t || r !== "") && i.push(r.trim()), i;
  }
};
var Hl = Nt;
Nt.default = Nt;
let Ol = _e, xu = Hl, vi = class extends Ol {
  get selectors() {
    return xu.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, i = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(i);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var br = vi;
vi.default = vi;
Ol.registerRule(vi);
let Lu = mr, ku = Ei, Ju = Bi, vu = Qi, Yu = Kl, Nu = Et, Tu = br;
function Tt(s, e) {
  if (Array.isArray(s)) return s.map((o) => Tt(o));
  let r = s, { inputs: t } = r, i = Qe(r, ["inputs"]);
  if (t) {
    e = [];
    for (let o of t) {
      let a = re(x({}, o), { __proto__: vu.prototype });
      a.map && (a.map = re(x({}, a.map), {
        __proto__: Yu.prototype
      })), e.push(a);
    }
  }
  if (i.nodes && (i.nodes = s.nodes.map((o) => Tt(o, e))), i.source) {
    let n = i.source, { inputId: o } = n, a = Qe(n, ["inputId"]);
    i.source = a, o != null && (i.source.input = e[o]);
  }
  if (i.type === "root")
    return new Nu(i);
  if (i.type === "decl")
    return new Ju(i);
  if (i.type === "rule")
    return new Tu(i);
  if (i.type === "comment")
    return new ku(i);
  if (i.type === "atrule")
    return new Lu(i);
  throw new Error("Unknown node type: " + s.type);
}
var Uu = Tt;
Tt.default = Tt;
let { dirname: Gi, relative: Pl, resolve: El, sep: Bl } = Ge, { SourceMapConsumer: Ql, SourceMapGenerator: Si } = Ge, { pathToFileURL: hn } = Ge, Ku = Qi, Fu = !!(Ql && Si), Mu = !!(Gi && El && Pl && Bl), zu = class {
  constructor(e, t, i, r) {
    this.stringify = e, this.mapOpts = i.map || {}, this.root = t, this.opts = i, this.css = r, this.originalCSS = r, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), i = e.root || Gi(e.file), r;
      this.mapOpts.sourcesContent === !1 ? (r = new Ql(e.text), r.sourcesContent && (r.sourcesContent = null)) : r = e.consumer(), this.map.applySourceMap(r, t, this.toUrl(this.path(i)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), Mu && Fu && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = Si.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new Si({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new Si({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, i = "<no source>", r = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, n, o;
    this.stringify(this.root, (a, l, u) => {
      if (this.css += a, l && u !== "end" && (r.generated.line = e, r.generated.column = t - 1, l.source && l.source.start ? (r.source = this.sourcePath(l), r.original.line = l.source.start.line, r.original.column = l.source.start.column - 1, this.map.addMapping(r)) : (r.source = i, r.original.line = 1, r.original.column = 0, this.map.addMapping(r))), o = a.match(/\n/g), o ? (e += o.length, n = a.lastIndexOf(`
`), t = a.length - n) : t += a.length, l && u !== "start") {
        let c = l.parent || { raws: {} };
        (!(l.type === "decl" || l.type === "atrule" && !l.nodes) || l !== c.last || c.raws.semicolon) && (l.source && l.source.end ? (r.source = this.sourcePath(l), r.original.line = l.source.end.line, r.original.column = l.source.end.column - 1, r.generated.line = e, r.generated.column = t - 2, this.map.addMapping(r)) : (r.source = i, r.original.line = 1, r.original.column = 0, r.generated.line = e, r.generated.column = t - 1, this.map.addMapping(r)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation != "undefined" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline != "undefined")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e != "undefined" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map != "undefined" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent != "undefined" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let i = this.opts.to ? Gi(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (i = Gi(El(i, this.mapOpts.annotation)));
    let r = Pl(i, e);
    return this.memoizedPaths.set(e, r), r;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new Ku(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let i = t.source.input.from;
          if (i && !e[i]) {
            e[i] = !0;
            let r = this.usesFileUrls ? this.toFileUrl(i) : this.toUrl(this.path(i));
            this.map.setSourceContent(r, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (hn) {
      let i = hn(e).toString();
      return this.memoizedFileURLs.set(e, i), i;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    Bl === "\\" && (e = e.replace(/\\/g, "/"));
    let i = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, i), i;
  }
};
var Dl = zu;
const hs = 39, dn = 34, ti = 92, pn = 47, ii = 10, Gt = 32, si = 12, ri = 9, ni = 13, Hu = 91, Ou = 93, Pu = 40, Eu = 41, Bu = 123, Qu = 125, Du = 59, ju = 42, Au = 58, _u = 64, li = /[\t\n\f\r "#'()/;[\\\]{}]/g, oi = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, $u = /.[\r\n"'(/\\]/, mn = /[\da-f]/i;
var qu = function(e, t = {}) {
  let i = e.css.valueOf(), r = t.ignoreErrors, n, o, a, l, u, c, h, p, d, b, m = i.length, f = 0, V = [], G = [];
  function g() {
    return f;
  }
  function S(R) {
    throw e.error("Unclosed " + R, f);
  }
  function y() {
    return G.length === 0 && f >= m;
  }
  function W(R) {
    if (G.length) return G.pop();
    if (f >= m) return;
    let Z = R ? R.ignoreUnclosed : !1;
    switch (n = i.charCodeAt(f), n) {
      case ii:
      case Gt:
      case ri:
      case ni:
      case si: {
        l = f;
        do
          l += 1, n = i.charCodeAt(l);
        while (n === Gt || n === ii || n === ri || n === ni || n === si);
        c = ["space", i.slice(f, l)], f = l - 1;
        break;
      }
      case Hu:
      case Ou:
      case Bu:
      case Qu:
      case Au:
      case Du:
      case Eu: {
        let I = String.fromCharCode(n);
        c = [I, I, f];
        break;
      }
      case Pu: {
        if (b = V.length ? V.pop()[1] : "", d = i.charCodeAt(f + 1), b === "url" && d !== hs && d !== dn && d !== Gt && d !== ii && d !== ri && d !== si && d !== ni) {
          l = f;
          do {
            if (h = !1, l = i.indexOf(")", l + 1), l === -1)
              if (r || Z) {
                l = f;
                break;
              } else
                S("bracket");
            for (p = l; i.charCodeAt(p - 1) === ti; )
              p -= 1, h = !h;
          } while (h);
          c = ["brackets", i.slice(f, l + 1), f, l], f = l;
        } else
          l = i.indexOf(")", f + 1), o = i.slice(f, l + 1), l === -1 || $u.test(o) ? c = ["(", "(", f] : (c = ["brackets", o, f, l], f = l);
        break;
      }
      case hs:
      case dn: {
        u = n === hs ? "'" : '"', l = f;
        do {
          if (h = !1, l = i.indexOf(u, l + 1), l === -1)
            if (r || Z) {
              l = f + 1;
              break;
            } else
              S("string");
          for (p = l; i.charCodeAt(p - 1) === ti; )
            p -= 1, h = !h;
        } while (h);
        c = ["string", i.slice(f, l + 1), f, l], f = l;
        break;
      }
      case _u: {
        li.lastIndex = f + 1, li.test(i), li.lastIndex === 0 ? l = i.length - 1 : l = li.lastIndex - 2, c = ["at-word", i.slice(f, l + 1), f, l], f = l;
        break;
      }
      case ti: {
        for (l = f, a = !0; i.charCodeAt(l + 1) === ti; )
          l += 1, a = !a;
        if (n = i.charCodeAt(l + 1), a && n !== pn && n !== Gt && n !== ii && n !== ri && n !== ni && n !== si && (l += 1, mn.test(i.charAt(l)))) {
          for (; mn.test(i.charAt(l + 1)); )
            l += 1;
          i.charCodeAt(l + 1) === Gt && (l += 1);
        }
        c = ["word", i.slice(f, l + 1), f, l], f = l;
        break;
      }
      default: {
        n === pn && i.charCodeAt(f + 1) === ju ? (l = i.indexOf("*/", f + 2) + 1, l === 0 && (r || Z ? l = i.length : S("comment")), c = ["comment", i.slice(f, l + 1), f, l], f = l) : (oi.lastIndex = f + 1, oi.test(i), oi.lastIndex === 0 ? l = i.length - 1 : l = oi.lastIndex - 2, c = ["word", i.slice(f, l + 1), f, l], V.push(c), f = l);
        break;
      }
    }
    return f++, c;
  }
  function C(R) {
    G.push(R);
  }
  return {
    back: C,
    endOfFile: y,
    nextToken: W,
    position: g
  };
};
let eh = mr, th = Ei, ih = Bi, sh = Et, fn = br, rh = qu;
const bn = {
  empty: !0,
  space: !0
};
function nh(s) {
  for (let e = s.length - 1; e >= 0; e--) {
    let t = s[e], i = t[3] || t[2];
    if (i) return i;
  }
}
let lh = class {
  constructor(e) {
    this.input = e, this.root = new sh(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new eh();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let i, r, n, o = !1, a = !1, l = [], u = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), i = e[0], i === "(" || i === "[" ? u.push(i === "(" ? ")" : "]") : i === "{" && u.length > 0 ? u.push("}") : i === u[u.length - 1] && u.pop(), u.length === 0)
        if (i === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (i === "{") {
          a = !0;
          break;
        } else if (i === "}") {
          if (l.length > 0) {
            for (n = l.length - 1, r = l[n]; r && r[0] === "space"; )
              r = l[--n];
            r && (t.source.end = this.getPosition(r[3] || r[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          l.push(e);
      else
        l.push(e);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(l), l.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(l), this.raw(t, "params", l), o && (e = l[l.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), a && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let i = 0, r;
    for (let n = t - 1; n >= 0 && (r = e[n], !(r[0] !== "space" && (i += 1, i === 2))); n--)
      ;
    throw this.input.error(
      "Missed semicolon",
      r[0] === "word" ? r[3] + 1 : r[2]
    );
  }
  colon(e) {
    let t = 0, i, r, n;
    for (let [o, a] of e.entries()) {
      if (r = a, n = r[0], n === "(" && (t += 1), n === ")" && (t -= 1), t === 0 && n === ":")
        if (!i)
          this.doubleColon(r);
        else {
          if (i[0] === "word" && i[1] === "progid")
            continue;
          return o;
        }
      i = r;
    }
    return !1;
  }
  comment(e) {
    let t = new th();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let i = e[1].slice(2, -2);
    if (/^\s*$/.test(i))
      t.text = "", t.raws.left = i, t.raws.right = "";
    else {
      let r = i.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = r[2], t.raws.left = r[1], t.raws.right = r[3];
    }
  }
  createTokenizer() {
    this.tokenizer = rh(this.input);
  }
  decl(e, t) {
    let i = new ih();
    this.init(i, e[0][2]);
    let r = e[e.length - 1];
    for (r[0] === ";" && (this.semicolon = !0, e.pop()), i.source.end = this.getPosition(
      r[3] || r[2] || nh(e)
    ), i.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), i.raws.before += e.shift()[1];
    for (i.source.start = this.getPosition(e[0][2]), i.prop = ""; e.length; ) {
      let u = e[0][0];
      if (u === ":" || u === "space" || u === "comment")
        break;
      i.prop += e.shift()[1];
    }
    i.raws.between = "";
    let n;
    for (; e.length; )
      if (n = e.shift(), n[0] === ":") {
        i.raws.between += n[1];
        break;
      } else
        n[0] === "word" && /\w/.test(n[1]) && this.unknownWord([n]), i.raws.between += n[1];
    (i.prop[0] === "_" || i.prop[0] === "*") && (i.raws.before += i.prop[0], i.prop = i.prop.slice(1));
    let o = [], a;
    for (; e.length && (a = e[0][0], !(a !== "space" && a !== "comment")); )
      o.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let u = e.length - 1; u >= 0; u--) {
      if (n = e[u], n[1].toLowerCase() === "!important") {
        i.important = !0;
        let c = this.stringFrom(e, u);
        c = this.spacesFromEnd(e) + c, c !== " !important" && (i.raws.important = c);
        break;
      } else if (n[1].toLowerCase() === "important") {
        let c = e.slice(0), h = "";
        for (let p = u; p > 0; p--) {
          let d = c[p][0];
          if (h.trim().startsWith("!") && d !== "space")
            break;
          h = c.pop()[1] + h;
        }
        h.trim().startsWith("!") && (i.important = !0, i.raws.important = h, e = c);
      }
      if (n[0] !== "space" && n[0] !== "comment")
        break;
    }
    e.some((u) => u[0] !== "space" && u[0] !== "comment") && (i.raws.between += o.map((u) => u[1]).join(""), o = []), this.raw(i, "value", o.concat(e), t), i.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new fn();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "", t.source.end = this.getPosition(e[2]), t.source.end.offset += t.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, i = null, r = !1, n = null, o = [], a = e[1].startsWith("--"), l = [], u = e;
    for (; u; ) {
      if (i = u[0], l.push(u), i === "(" || i === "[")
        n || (n = u), o.push(i === "(" ? ")" : "]");
      else if (a && r && i === "{")
        n || (n = u), o.push("}");
      else if (o.length === 0)
        if (i === ";")
          if (r) {
            this.decl(l, a);
            return;
          } else
            break;
        else if (i === "{") {
          this.rule(l);
          return;
        } else if (i === "}") {
          this.tokenizer.back(l.pop()), t = !0;
          break;
        } else i === ":" && (r = !0);
      else i === o[o.length - 1] && (o.pop(), o.length === 0 && (n = null));
      u = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), o.length > 0 && this.unclosedBracket(n), t && r) {
      if (!a)
        for (; l.length && (u = l[l.length - 1][0], !(u !== "space" && u !== "comment")); )
          this.tokenizer.back(l.pop());
      this.decl(l, a);
    } else
      this.unknownWord(l);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, i, r) {
    let n, o, a = i.length, l = "", u = !0, c, h;
    for (let p = 0; p < a; p += 1)
      n = i[p], o = n[0], o === "space" && p === a - 1 && !r ? u = !1 : o === "comment" ? (h = i[p - 1] ? i[p - 1][0] : "empty", c = i[p + 1] ? i[p + 1][0] : "empty", !bn[h] && !bn[c] ? l.slice(-1) === "," ? u = !1 : l += n[1] : u = !1) : l += n[1];
    if (!u) {
      let p = i.reduce((d, b) => d + b[1], "");
      e.raws[t] = { raw: p, value: l };
    }
    e[t] = l;
  }
  rule(e) {
    e.pop();
    let t = new fn();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, i = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      i = e.pop()[1] + i;
    return i;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, i = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      i += e.shift()[1];
    return i;
  }
  spacesFromEnd(e) {
    let t, i = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      i = e.pop()[1] + i;
    return i;
  }
  stringFrom(e, t) {
    let i = "";
    for (let r = t; r < e.length; r++)
      i += e[r][1];
    return e.splice(t, e.length - t), i;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var oh = lh;
let ah = _e, ch = Qi, uh = oh;
function Yi(s, e) {
  let t = new ch(s, e), i = new uh(t);
  try {
    i.parse();
  } catch (r) {
    throw process.env.NODE_ENV !== "production" && r.name === "CssSyntaxError" && e && e.from && (/\.scss$/i.test(e.from) ? r.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(e.from) ? r.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(e.from) && (r.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), r;
  }
  return i.root;
}
var Zr = Yi;
Yi.default = Yi;
ah.registerParse(Yi);
let Ys = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let i = t.node.rangeBy(t);
      this.line = i.start.line, this.column = i.start.column, this.endLine = i.end.line, this.endColumn = i.end.column;
    }
    for (let i in t) this[i] = t[i];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var jl = Ys;
Ys.default = Ys;
let hh = jl, Ns = class {
  get content() {
    return this.css;
  }
  constructor(e, t, i) {
    this.processor = e, this.messages = [], this.root = t, this.opts = i, this.css = "", this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let i = new hh(e, t);
    return this.messages.push(i), i;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var yr = Ns;
Ns.default = Ns;
let Zn = {};
var Al = function(e) {
  Zn[e] || (Zn[e] = !0, typeof console != "undefined" && console.warn && console.warn(e));
};
let dh = _e, ph = fr, mh = Dl, fh = Zr, yn = yr, bh = Et, Zh = Oi, { isClean: Ve, my: yh } = Pt, gh = Al;
const Xh = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, Gh = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, Sh = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, ht = 0;
function St(s) {
  return typeof s == "object" && typeof s.then == "function";
}
function _l(s) {
  let e = !1, t = Xh[s.type];
  return s.type === "decl" ? e = s.prop.toLowerCase() : s.type === "atrule" && (e = s.name.toLowerCase()), e && s.append ? [
    t,
    t + "-" + e,
    ht,
    t + "Exit",
    t + "Exit-" + e
  ] : e ? [t, t + "-" + e, t + "Exit", t + "Exit-" + e] : s.append ? [t, ht, t + "Exit"] : [t, t + "Exit"];
}
function gn(s) {
  let e;
  return s.type === "document" ? e = ["Document", ht, "DocumentExit"] : s.type === "root" ? e = ["Root", ht, "RootExit"] : e = _l(s), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: s,
    visitorIndex: 0,
    visitors: []
  };
}
function Ts(s) {
  return s[Ve] = !1, s.nodes && s.nodes.forEach((e) => Ts(e)), s;
}
let Us = {}, dt = class $l {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(e, t, i) {
    this.stringified = !1, this.processed = !1;
    let r;
    if (typeof t == "object" && t !== null && (t.type === "root" || t.type === "document"))
      r = Ts(t);
    else if (t instanceof $l || t instanceof yn)
      r = Ts(t.root), t.map && (typeof i.map == "undefined" && (i.map = {}), i.map.inline || (i.map.inline = !1), i.map.prev = t.map);
    else {
      let n = fh;
      i.syntax && (n = i.syntax.parse), i.parser && (n = i.parser), n.parse && (n = n.parse);
      try {
        r = n(t, i);
      } catch (o) {
        this.processed = !0, this.error = o;
      }
      r && !r[yh] && dh.rebuild(r);
    }
    this.result = new yn(e, r, i), this.helpers = re(x({}, Us), { postcss: Us, result: this.result }), this.plugins = this.processor.plugins.map((n) => typeof n == "object" && n.prepare ? x(x({}, n), n.prepare(this.result)) : n);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, t) {
    let i = this.result.lastPlugin;
    try {
      if (t && t.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin)
        e.plugin = i.postcssPlugin, e.setMessage();
      else if (i.postcssVersion && process.env.NODE_ENV !== "production") {
        let r = i.postcssPlugin, n = i.postcssVersion, o = this.result.processor.version, a = n.split("."), l = o.split(".");
        (a[0] !== l[0] || parseInt(a[1]) > parseInt(l[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + o + ", but " + r + " uses " + n + ". Perhaps this is the source of the error below."
        );
      }
    } catch (r) {
      console && console.error && console.error(r);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (t, i, r) => {
      this.listeners[i] || (this.listeners[i] = []), this.listeners[i].push([t, r]);
    };
    for (let t of this.plugins)
      if (typeof t == "object")
        for (let i in t) {
          if (!Gh[i] && /^[A-Z]/.test(i))
            throw new Error(
              `Unknown event ${i} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!Sh[i])
            if (typeof t[i] == "object")
              for (let r in t[i])
                r === "*" ? e(t, i, t[i][r]) : e(
                  t,
                  i + "-" + r.toLowerCase(),
                  t[i][r]
                );
            else typeof t[i] == "function" && e(t, i, t[i]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  runAsync() {
    return ne(this, null, function* () {
      this.plugin = 0;
      for (let e = 0; e < this.plugins.length; e++) {
        let t = this.plugins[e], i = this.runOnRoot(t);
        if (St(i))
          try {
            yield i;
          } catch (r) {
            throw this.handleError(r);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let e = this.result.root;
        for (; !e[Ve]; ) {
          e[Ve] = !0;
          let t = [gn(e)];
          for (; t.length > 0; ) {
            let i = this.visitTick(t);
            if (St(i))
              try {
                yield i;
              } catch (r) {
                let n = t[t.length - 1].node;
                throw this.handleError(r, n);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [t, i] of this.listeners.OnceExit) {
            this.result.lastPlugin = t;
            try {
              if (e.type === "document") {
                let r = e.nodes.map(
                  (n) => i(n, this.helpers)
                );
                yield Promise.all(r);
              } else
                yield i(e, this.helpers);
            } catch (r) {
              throw this.handleError(r);
            }
          }
      }
      return this.processed = !0, this.stringify();
    });
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let t = this.result.root.nodes.map(
            (i) => e.Once(i, this.helpers)
          );
          return St(t[0]) ? Promise.all(t) : t;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (t) {
      throw this.handleError(t);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, t = Zh;
    e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
    let r = new mh(t, this.result.root, this.result.opts).generate();
    return this.result.css = r[0], this.result.map = r[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let t = this.runOnRoot(e);
      if (St(t))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[Ve]; )
        e[Ve] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let t of e.nodes)
            this.visitSync(this.listeners.OnceExit, t);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || gh(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this.css;
  }
  visitSync(e, t) {
    for (let [i, r] of e) {
      this.result.lastPlugin = i;
      let n;
      try {
        n = r(t, this.helpers);
      } catch (o) {
        throw this.handleError(o, t.proxyOf);
      }
      if (t.type !== "root" && t.type !== "document" && !t.parent)
        return !0;
      if (St(n))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let t = e[e.length - 1], { node: i, visitors: r } = t;
    if (i.type !== "root" && i.type !== "document" && !i.parent) {
      e.pop();
      return;
    }
    if (r.length > 0 && t.visitorIndex < r.length) {
      let [o, a] = r[t.visitorIndex];
      t.visitorIndex += 1, t.visitorIndex === r.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = o;
      try {
        return a(i.toProxy(), this.helpers);
      } catch (l) {
        throw this.handleError(l, i);
      }
    }
    if (t.iterator !== 0) {
      let o = t.iterator, a;
      for (; a = i.nodes[i.indexes[o]]; )
        if (i.indexes[o] += 1, !a[Ve]) {
          a[Ve] = !0, e.push(gn(a));
          return;
        }
      t.iterator = 0, delete i.indexes[o];
    }
    let n = t.events;
    for (; t.eventIndex < n.length; ) {
      let o = n[t.eventIndex];
      if (t.eventIndex += 1, o === ht) {
        i.nodes && i.nodes.length && (i[Ve] = !0, t.iterator = i.getIterator());
        return;
      } else if (this.listeners[o]) {
        t.visitors = this.listeners[o];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[Ve] = !0;
    let t = _l(e);
    for (let i of t)
      if (i === ht)
        e.nodes && e.each((r) => {
          r[Ve] || this.walkSync(r);
        });
      else {
        let r = this.listeners[i];
        if (r && this.visitSync(r, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
dt.registerPostcss = (s) => {
  Us = s;
};
var ql = dt;
dt.default = dt;
bh.registerLazyResult(dt);
ph.registerLazyResult(dt);
let Ih = Dl, Vh = Zr;
const Rh = yr;
let Wh = Oi, Ch = Al, Ks = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = Vh;
    try {
      e = t(this._css, this._opts);
    } catch (i) {
      this.error = i;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, t, i) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = i, this._map = void 0;
    let r, n = Wh;
    this.result = new Rh(this._processor, r, this._opts), this.result.css = t;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let a = new Ih(n, r, this._opts, t);
    if (a.isMap()) {
      let [l, u] = a.generate();
      l && (this.result.css = l), u && (this.result.map = u);
    } else
      a.clearAnnotation(), this.result.css = a.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || Ch(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var wh = Ks;
Ks.default = Ks;
let xh = fr, Lh = ql, kh = wh, Jh = Et, Ut = class {
  constructor(e = []) {
    this.version = "8.5.6", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let i of e)
      if (i.postcss === !0 ? i = i() : i.postcss && (i = i.postcss), typeof i == "object" && Array.isArray(i.plugins))
        t = t.concat(i.plugins);
      else if (typeof i == "object" && i.postcssPlugin)
        t.push(i);
      else if (typeof i == "function")
        t.push(i);
      else if (typeof i == "object" && (i.parse || i.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(i + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new kh(this, e, t) : new Lh(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var vh = Ut;
Ut.default = Ut;
Jh.registerProcessor(Ut);
xh.registerProcessor(Ut);
let eo = mr, to = Ei, Yh = _e, Nh = hr, io = Bi, so = fr, Th = Uu, Uh = Qi, Kh = ql, Fh = Hl, Mh = Pi, zh = Zr, gr = vh, Hh = yr, ro = Et, no = br, Oh = Oi, Ph = jl;
function M(...s) {
  return s.length === 1 && Array.isArray(s[0]) && (s = s[0]), new gr(s);
}
M.plugin = function(e, t) {
  let i = !1;
  function r(...o) {
    console && console.warn && !i && (i = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let a = t(...o);
    return a.postcssPlugin = e, a.postcssVersion = new gr().version, a;
  }
  let n;
  return Object.defineProperty(r, "postcss", {
    get() {
      return n || (n = r()), n;
    }
  }), r.process = function(o, a, l) {
    return M([r(l)]).process(o, a);
  }, r;
};
M.stringify = Oh;
M.parse = zh;
M.fromJSON = Th;
M.list = Fh;
M.comment = (s) => new to(s);
M.atRule = (s) => new eo(s);
M.decl = (s) => new io(s);
M.rule = (s) => new no(s);
M.root = (s) => new ro(s);
M.document = (s) => new so(s);
M.CssSyntaxError = Nh;
M.Declaration = io;
M.Container = Yh;
M.Processor = gr;
M.Document = so;
M.Comment = to;
M.Warning = Ph;
M.AtRule = eo;
M.Result = Hh;
M.Input = Uh;
M.Rule = no;
M.Root = ro;
M.Node = Mh;
Kh.registerPostcss(M);
M.default = M;
var Eh = Object.defineProperty, Bh = (s, e, t) => e in s ? Eh(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t, Ze = (s, e, t) => Bh(s, typeof e != "symbol" ? e + "" : e, t);
function Qh(s) {
  if (s.__esModule) return s;
  var e = s.default;
  if (typeof e == "function") {
    var t = function i() {
      return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    t.prototype = e.prototype;
  } else t = {};
  return Object.defineProperty(t, "__esModule", { value: !0 }), Object.keys(s).forEach(function(i) {
    var r = Object.getOwnPropertyDescriptor(s, i);
    Object.defineProperty(t, i, r.get ? r : {
      enumerable: !0,
      get: function() {
        return s[i];
      }
    });
  }), t;
}
var Xr = { exports: {} }, J = String, lo = function() {
  return { isColorSupported: !1, reset: J, bold: J, dim: J, italic: J, underline: J, inverse: J, hidden: J, strikethrough: J, black: J, red: J, green: J, yellow: J, blue: J, magenta: J, cyan: J, white: J, gray: J, bgBlack: J, bgRed: J, bgGreen: J, bgYellow: J, bgBlue: J, bgMagenta: J, bgCyan: J, bgWhite: J, blackBright: J, redBright: J, greenBright: J, yellowBright: J, blueBright: J, magentaBright: J, cyanBright: J, whiteBright: J, bgBlackBright: J, bgRedBright: J, bgGreenBright: J, bgYellowBright: J, bgBlueBright: J, bgMagentaBright: J, bgCyanBright: J, bgWhiteBright: J };
};
Xr.exports = lo();
Xr.exports.createColors = lo;
var Dh = Xr.exports;
const jh = {}, Ah = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jh
}, Symbol.toStringTag, { value: "Module" })), Se = /* @__PURE__ */ Qh(Ah);
let Xn = Dh, Gn = Se, Fs = class oo extends Error {
  constructor(e, t, i, r, n, o) {
    super(e), this.name = "CssSyntaxError", this.reason = e, n && (this.file = n), r && (this.source = r), o && (this.plugin = o), typeof t != "undefined" && typeof i != "undefined" && (typeof t == "number" ? (this.line = t, this.column = i) : (this.line = t.line, this.column = t.column, this.endLine = i.line, this.endColumn = i.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, oo);
  }
  setMessage() {
    this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", typeof this.line != "undefined" && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
  }
  showSourceCode(e) {
    if (!this.source) return "";
    let t = this.source;
    e == null && (e = Xn.isColorSupported);
    let i = (c) => c, r = (c) => c, n = (c) => c;
    if (e) {
      let { bold: c, gray: h, red: p } = Xn.createColors(!0);
      r = (d) => c(p(d)), i = (d) => h(d), Gn && (n = (d) => Gn(d));
    }
    let o = t.split(/\r?\n/), a = Math.max(this.line - 3, 0), l = Math.min(this.line + 2, o.length), u = String(l).length;
    return o.slice(a, l).map((c, h) => {
      let p = a + 1 + h, d = " " + (" " + p).slice(-u) + " | ";
      if (p === this.line) {
        if (c.length > 160) {
          let m = 20, f = Math.max(0, this.column - m), V = Math.max(
            this.column + m,
            this.endColumn + m
          ), G = c.slice(f, V), g = i(d.replace(/\d/g, " ")) + c.slice(0, Math.min(this.column - 1, m - 1)).replace(/[^\t]/g, " ");
          return r(">") + i(d) + n(G) + `
 ` + g + r("^");
        }
        let b = i(d.replace(/\d/g, " ")) + c.slice(0, this.column - 1).replace(/[^\t]/g, " ");
        return r(">") + i(d) + n(c) + `
 ` + b + r("^");
      }
      return " " + i(d) + n(c);
    }).join(`
`);
  }
  toString() {
    let e = this.showSourceCode();
    return e && (e = `

` + e + `
`), this.name + ": " + this.message + e;
  }
};
var Gr = Fs;
Fs.default = Fs;
const Sn = {
  after: `
`,
  beforeClose: `
`,
  beforeComment: `
`,
  beforeDecl: `
`,
  beforeOpen: " ",
  beforeRule: `
`,
  colon: ": ",
  commentLeft: " ",
  commentRight: " ",
  emptyBody: "",
  indent: "    ",
  semicolon: !1
};
function _h(s) {
  return s[0].toUpperCase() + s.slice(1);
}
let Ms = class {
  constructor(e) {
    this.builder = e;
  }
  atrule(e, t) {
    let i = "@" + e.name, r = e.params ? this.rawValue(e, "params") : "";
    if (typeof e.raws.afterName != "undefined" ? i += e.raws.afterName : r && (i += " "), e.nodes)
      this.block(e, i + r);
    else {
      let n = (e.raws.between || "") + (t ? ";" : "");
      this.builder(i + r + n, e);
    }
  }
  beforeAfter(e, t) {
    let i;
    e.type === "decl" ? i = this.raw(e, null, "beforeDecl") : e.type === "comment" ? i = this.raw(e, null, "beforeComment") : t === "before" ? i = this.raw(e, null, "beforeRule") : i = this.raw(e, null, "beforeClose");
    let r = e.parent, n = 0;
    for (; r && r.type !== "root"; )
      n += 1, r = r.parent;
    if (i.includes(`
`)) {
      let o = this.raw(e, null, "indent");
      if (o.length)
        for (let a = 0; a < n; a++) i += o;
    }
    return i;
  }
  block(e, t) {
    let i = this.raw(e, "between", "beforeOpen");
    this.builder(t + i + "{", e, "start");
    let r;
    e.nodes && e.nodes.length ? (this.body(e), r = this.raw(e, "after")) : r = this.raw(e, "after", "emptyBody"), r && this.builder(r), this.builder("}", e, "end");
  }
  body(e) {
    let t = e.nodes.length - 1;
    for (; t > 0 && e.nodes[t].type === "comment"; )
      t -= 1;
    let i = this.raw(e, "semicolon");
    for (let r = 0; r < e.nodes.length; r++) {
      let n = e.nodes[r], o = this.raw(n, "before");
      o && this.builder(o), this.stringify(n, t !== r || i);
    }
  }
  comment(e) {
    let t = this.raw(e, "left", "commentLeft"), i = this.raw(e, "right", "commentRight");
    this.builder("/*" + t + e.text + i + "*/", e);
  }
  decl(e, t) {
    let i = this.raw(e, "between", "colon"), r = e.prop + i + this.rawValue(e, "value");
    e.important && (r += e.raws.important || " !important"), t && (r += ";"), this.builder(r, e);
  }
  document(e) {
    this.body(e);
  }
  raw(e, t, i) {
    let r;
    if (i || (i = t), t && (r = e.raws[t], typeof r != "undefined"))
      return r;
    let n = e.parent;
    if (i === "before" && (!n || n.type === "root" && n.first === e || n && n.type === "document"))
      return "";
    if (!n) return Sn[i];
    let o = e.root();
    if (o.rawCache || (o.rawCache = {}), typeof o.rawCache[i] != "undefined")
      return o.rawCache[i];
    if (i === "before" || i === "after")
      return this.beforeAfter(e, i);
    {
      let a = "raw" + _h(i);
      this[a] ? r = this[a](o, e) : o.walk((l) => {
        if (r = l.raws[t], typeof r != "undefined") return !1;
      });
    }
    return typeof r == "undefined" && (r = Sn[i]), o.rawCache[i] = r, r;
  }
  rawBeforeClose(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length > 0 && typeof i.raws.after != "undefined")
        return t = i.raws.after, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawBeforeComment(e, t) {
    let i;
    return e.walkComments((r) => {
      if (typeof r.raws.before != "undefined")
        return i = r.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), typeof i == "undefined" ? i = this.raw(t, null, "beforeDecl") : i && (i = i.replace(/\S/g, "")), i;
  }
  rawBeforeDecl(e, t) {
    let i;
    return e.walkDecls((r) => {
      if (typeof r.raws.before != "undefined")
        return i = r.raws.before, i.includes(`
`) && (i = i.replace(/[^\n]+$/, "")), !1;
    }), typeof i == "undefined" ? i = this.raw(t, null, "beforeRule") : i && (i = i.replace(/\S/g, "")), i;
  }
  rawBeforeOpen(e) {
    let t;
    return e.walk((i) => {
      if (i.type !== "decl" && (t = i.raws.between, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawBeforeRule(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && (i.parent !== e || e.first !== i) && typeof i.raws.before != "undefined")
        return t = i.raws.before, t.includes(`
`) && (t = t.replace(/[^\n]+$/, "")), !1;
    }), t && (t = t.replace(/\S/g, "")), t;
  }
  rawColon(e) {
    let t;
    return e.walkDecls((i) => {
      if (typeof i.raws.between != "undefined")
        return t = i.raws.between.replace(/[^\s:]/g, ""), !1;
    }), t;
  }
  rawEmptyBody(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length === 0 && (t = i.raws.after, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawIndent(e) {
    if (e.raws.indent) return e.raws.indent;
    let t;
    return e.walk((i) => {
      let r = i.parent;
      if (r && r !== e && r.parent && r.parent === e && typeof i.raws.before != "undefined") {
        let n = i.raws.before.split(`
`);
        return t = n[n.length - 1], t = t.replace(/\S/g, ""), !1;
      }
    }), t;
  }
  rawSemicolon(e) {
    let t;
    return e.walk((i) => {
      if (i.nodes && i.nodes.length && i.last.type === "decl" && (t = i.raws.semicolon, typeof t != "undefined"))
        return !1;
    }), t;
  }
  rawValue(e, t) {
    let i = e[t], r = e.raws[t];
    return r && r.value === i ? r.raw : i;
  }
  root(e) {
    this.body(e), e.raws.after && this.builder(e.raws.after);
  }
  rule(e) {
    this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
  }
  stringify(e, t) {
    if (!this[e.type])
      throw new Error(
        "Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier."
      );
    this[e.type](e, t);
  }
};
var ao = Ms;
Ms.default = Ms;
let $h = ao;
function zs(s, e) {
  new $h(e).stringify(s);
}
var Di = zs;
zs.default = zs;
var Bt = {};
Bt.isClean = Symbol("isClean");
Bt.my = Symbol("my");
let qh = Gr, ed = ao, td = Di, { isClean: It, my: id } = Bt;
function Hs(s, e) {
  let t = new s.constructor();
  for (let i in s) {
    if (!Object.prototype.hasOwnProperty.call(s, i) || i === "proxyCache") continue;
    let r = s[i], n = typeof r;
    i === "parent" && n === "object" ? e && (t[i] = e) : i === "source" ? t[i] = r : Array.isArray(r) ? t[i] = r.map((o) => Hs(o, t)) : (n === "object" && r !== null && (r = Hs(r)), t[i] = r);
  }
  return t;
}
function ke(s, e) {
  if (e && typeof e.offset != "undefined")
    return e.offset;
  let t = 1, i = 1, r = 0;
  for (let n = 0; n < s.length; n++) {
    if (i === e.line && t === e.column) {
      r = n;
      break;
    }
    s[n] === `
` ? (t = 1, i += 1) : t += 1;
  }
  return r;
}
let Os = class {
  get proxyOf() {
    return this;
  }
  constructor(e = {}) {
    this.raws = {}, this[It] = !1, this[id] = !0;
    for (let t in e)
      if (t === "nodes") {
        this.nodes = [];
        for (let i of e[t])
          typeof i.clone == "function" ? this.append(i.clone()) : this.append(i);
      } else
        this[t] = e[t];
  }
  addToError(e) {
    if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
      let t = this.source;
      e.stack = e.stack.replace(
        /\n\s{4}at /,
        `$&${t.input.from}:${t.start.line}:${t.start.column}$&`
      );
    }
    return e;
  }
  after(e) {
    return this.parent.insertAfter(this, e), this;
  }
  assign(e = {}) {
    for (let t in e)
      this[t] = e[t];
    return this;
  }
  before(e) {
    return this.parent.insertBefore(this, e), this;
  }
  cleanRaws(e) {
    delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
  }
  clone(e = {}) {
    let t = Hs(this);
    for (let i in e)
      t[i] = e[i];
    return t;
  }
  cloneAfter(e = {}) {
    let t = this.clone(e);
    return this.parent.insertAfter(this, t), t;
  }
  cloneBefore(e = {}) {
    let t = this.clone(e);
    return this.parent.insertBefore(this, t), t;
  }
  error(e, t = {}) {
    if (this.source) {
      let { end: i, start: r } = this.rangeBy(t);
      return this.source.input.error(
        e,
        { column: r.column, line: r.line },
        { column: i.column, line: i.line },
        t
      );
    }
    return new qh(e);
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : t === "root" ? () => e.root().toProxy() : e[t];
      },
      set(e, t, i) {
        return e[t] === i || (e[t] = i, (t === "prop" || t === "value" || t === "name" || t === "params" || t === "important" || /* c8 ignore next */
        t === "text") && e.markDirty()), !0;
      }
    };
  }
  /* c8 ignore next 3 */
  markClean() {
    this[It] = !0;
  }
  markDirty() {
    if (this[It]) {
      this[It] = !1;
      let e = this;
      for (; e = e.parent; )
        e[It] = !1;
    }
  }
  next() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e + 1];
  }
  positionBy(e = {}) {
    let t = this.source.start;
    if (e.index)
      t = this.positionInside(e.index);
    else if (e.word) {
      let i = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = i.slice(
        ke(i, this.source.start),
        ke(i, this.source.end)
      ).indexOf(e.word);
      n !== -1 && (t = this.positionInside(n));
    }
    return t;
  }
  positionInside(e) {
    let t = this.source.start.column, i = this.source.start.line, r = "document" in this.source.input ? this.source.input.document : this.source.input.css, n = ke(r, this.source.start), o = n + e;
    for (let a = n; a < o; a++)
      r[a] === `
` ? (t = 1, i += 1) : t += 1;
    return { column: t, line: i, offset: o };
  }
  prev() {
    if (!this.parent) return;
    let e = this.parent.index(this);
    return this.parent.nodes[e - 1];
  }
  rangeBy(e = {}) {
    let t = "document" in this.source.input ? this.source.input.document : this.source.input.css, i = {
      column: this.source.start.column,
      line: this.source.start.line,
      offset: ke(t, this.source.start)
    }, r = this.source.end ? {
      column: this.source.end.column + 1,
      line: this.source.end.line,
      offset: typeof this.source.end.offset == "number" ? (
        // `source.end.offset` is exclusive, so we don't need to add 1
        this.source.end.offset
      ) : (
        // Since line/column in this.source.end is inclusive,
        // the `sourceOffset(... , this.source.end)` returns an inclusive offset.
        // So, we add 1 to convert it to exclusive.
        ke(t, this.source.end) + 1
      )
    } : {
      column: i.column + 1,
      line: i.line,
      offset: i.offset + 1
    };
    if (e.word) {
      let o = t.slice(
        ke(t, this.source.start),
        ke(t, this.source.end)
      ).indexOf(e.word);
      o !== -1 && (i = this.positionInside(o), r = this.positionInside(o + e.word.length));
    } else
      e.start ? i = {
        column: e.start.column,
        line: e.start.line,
        offset: ke(t, e.start)
      } : e.index && (i = this.positionInside(e.index)), e.end ? r = {
        column: e.end.column,
        line: e.end.line,
        offset: ke(t, e.end)
      } : typeof e.endIndex == "number" ? r = this.positionInside(e.endIndex) : e.index && (r = this.positionInside(e.index + 1));
    return (r.line < i.line || r.line === i.line && r.column <= i.column) && (r = {
      column: i.column + 1,
      line: i.line,
      offset: i.offset + 1
    }), { end: r, start: i };
  }
  raw(e, t) {
    return new ed().raw(this, e, t);
  }
  remove() {
    return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
  }
  replaceWith(...e) {
    if (this.parent) {
      let t = this, i = !1;
      for (let r of e)
        r === this ? i = !0 : i ? (this.parent.insertAfter(t, r), t = r) : this.parent.insertBefore(t, r);
      i || this.remove();
    }
    return this;
  }
  root() {
    let e = this;
    for (; e.parent && e.parent.type !== "document"; )
      e = e.parent;
    return e;
  }
  toJSON(e, t) {
    let i = {}, r = t == null;
    t = t || /* @__PURE__ */ new Map();
    let n = 0;
    for (let o in this) {
      if (!Object.prototype.hasOwnProperty.call(this, o) || o === "parent" || o === "proxyCache") continue;
      let a = this[o];
      if (Array.isArray(a))
        i[o] = a.map((l) => typeof l == "object" && l.toJSON ? l.toJSON(null, t) : l);
      else if (typeof a == "object" && a.toJSON)
        i[o] = a.toJSON(null, t);
      else if (o === "source") {
        if (a == null) continue;
        let l = t.get(a.input);
        l == null && (l = n, t.set(a.input, n), n++), i[o] = {
          end: a.end,
          inputId: l,
          start: a.start
        };
      } else
        i[o] = a;
    }
    return r && (i.inputs = [...t.keys()].map((o) => o.toJSON())), i;
  }
  toProxy() {
    return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
  }
  toString(e = td) {
    e.stringify && (e = e.stringify);
    let t = "";
    return e(this, (i) => {
      t += i;
    }), t;
  }
  warn(e, t, i = {}) {
    let r = { node: this };
    for (let n in i) r[n] = i[n];
    return e.warn(t, r);
  }
};
var ji = Os;
Os.default = Os;
let sd = ji, Ps = class extends sd {
  constructor(e) {
    super(e), this.type = "comment";
  }
};
var Ai = Ps;
Ps.default = Ps;
let rd = ji, Es = class extends rd {
  get variable() {
    return this.prop.startsWith("--") || this.prop[0] === "$";
  }
  constructor(e) {
    e && typeof e.value != "undefined" && typeof e.value != "string" && (e = re(x({}, e), { value: String(e.value) })), super(e), this.type = "decl";
  }
};
var _i = Es;
Es.default = Es;
let co = Ai, uo = _i, nd = ji, { isClean: ho, my: po } = Bt, Sr, mo, fo, Ir;
function bo(s) {
  return s.map((e) => (e.nodes && (e.nodes = bo(e.nodes)), delete e.source, e));
}
function Zo(s) {
  if (s[ho] = !1, s.proxyOf.nodes)
    for (let e of s.proxyOf.nodes)
      Zo(e);
}
let Te = class yo extends nd {
  get first() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[0];
  }
  get last() {
    if (this.proxyOf.nodes)
      return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
  }
  append(...e) {
    for (let t of e) {
      let i = this.normalize(t, this.last);
      for (let r of i) this.proxyOf.nodes.push(r);
    }
    return this.markDirty(), this;
  }
  cleanRaws(e) {
    if (super.cleanRaws(e), this.nodes)
      for (let t of this.nodes) t.cleanRaws(e);
  }
  each(e) {
    if (!this.proxyOf.nodes) return;
    let t = this.getIterator(), i, r;
    for (; this.indexes[t] < this.proxyOf.nodes.length && (i = this.indexes[t], r = e(this.proxyOf.nodes[i], i), r !== !1); )
      this.indexes[t] += 1;
    return delete this.indexes[t], r;
  }
  every(e) {
    return this.nodes.every(e);
  }
  getIterator() {
    this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
    let e = this.lastEach;
    return this.indexes[e] = 0, e;
  }
  getProxyProcessor() {
    return {
      get(e, t) {
        return t === "proxyOf" ? e : e[t] ? t === "each" || typeof t == "string" && t.startsWith("walk") ? (...i) => e[t](
          ...i.map((r) => typeof r == "function" ? (n, o) => r(n.toProxy(), o) : r)
        ) : t === "every" || t === "some" ? (i) => e[t](
          (r, ...n) => i(r.toProxy(), ...n)
        ) : t === "root" ? () => e.root().toProxy() : t === "nodes" ? e.nodes.map((i) => i.toProxy()) : t === "first" || t === "last" ? e[t].toProxy() : e[t] : e[t];
      },
      set(e, t, i) {
        return e[t] === i || (e[t] = i, (t === "name" || t === "params" || t === "selector") && e.markDirty()), !0;
      }
    };
  }
  index(e) {
    return typeof e == "number" ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
  }
  insertAfter(e, t) {
    let i = this.index(e), r = this.normalize(t, this.proxyOf.nodes[i]).reverse();
    i = this.index(e);
    for (let o of r) this.proxyOf.nodes.splice(i + 1, 0, o);
    let n;
    for (let o in this.indexes)
      n = this.indexes[o], i < n && (this.indexes[o] = n + r.length);
    return this.markDirty(), this;
  }
  insertBefore(e, t) {
    let i = this.index(e), r = i === 0 ? "prepend" : !1, n = this.normalize(
      t,
      this.proxyOf.nodes[i],
      r
    ).reverse();
    i = this.index(e);
    for (let a of n) this.proxyOf.nodes.splice(i, 0, a);
    let o;
    for (let a in this.indexes)
      o = this.indexes[a], i <= o && (this.indexes[a] = o + n.length);
    return this.markDirty(), this;
  }
  normalize(e, t) {
    if (typeof e == "string")
      e = bo(mo(e).nodes);
    else if (typeof e == "undefined")
      e = [];
    else if (Array.isArray(e)) {
      e = e.slice(0);
      for (let r of e)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (e.type === "root" && this.type !== "document") {
      e = e.nodes.slice(0);
      for (let r of e)
        r.parent && r.parent.removeChild(r, "ignore");
    } else if (e.type)
      e = [e];
    else if (e.prop) {
      if (typeof e.value == "undefined")
        throw new Error("Value field is missed in node creation");
      typeof e.value != "string" && (e.value = String(e.value)), e = [new uo(e)];
    } else if (e.selector || e.selectors)
      e = [new Ir(e)];
    else if (e.name)
      e = [new Sr(e)];
    else if (e.text)
      e = [new co(e)];
    else
      throw new Error("Unknown node type in node creation");
    return e.map((r) => (r[po] || yo.rebuild(r), r = r.proxyOf, r.parent && r.parent.removeChild(r), r[ho] && Zo(r), r.raws || (r.raws = {}), typeof r.raws.before == "undefined" && t && typeof t.raws.before != "undefined" && (r.raws.before = t.raws.before.replace(/\S/g, "")), r.parent = this.proxyOf, r));
  }
  prepend(...e) {
    e = e.reverse();
    for (let t of e) {
      let i = this.normalize(t, this.first, "prepend").reverse();
      for (let r of i) this.proxyOf.nodes.unshift(r);
      for (let r in this.indexes)
        this.indexes[r] = this.indexes[r] + i.length;
    }
    return this.markDirty(), this;
  }
  push(e) {
    return e.parent = this, this.proxyOf.nodes.push(e), this;
  }
  removeAll() {
    for (let e of this.proxyOf.nodes) e.parent = void 0;
    return this.proxyOf.nodes = [], this.markDirty(), this;
  }
  removeChild(e) {
    e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
    let t;
    for (let i in this.indexes)
      t = this.indexes[i], t >= e && (this.indexes[i] = t - 1);
    return this.markDirty(), this;
  }
  replaceValues(e, t, i) {
    return i || (i = t, t = {}), this.walkDecls((r) => {
      t.props && !t.props.includes(r.prop) || t.fast && !r.value.includes(t.fast) || (r.value = r.value.replace(e, i));
    }), this.markDirty(), this;
  }
  some(e) {
    return this.nodes.some(e);
  }
  walk(e) {
    return this.each((t, i) => {
      let r;
      try {
        r = e(t, i);
      } catch (n) {
        throw t.addToError(n);
      }
      return r !== !1 && t.walk && (r = t.walk(e)), r;
    });
  }
  walkAtRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "atrule" && e.test(i.name))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "atrule" && i.name === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "atrule")
        return t(i, r);
    }));
  }
  walkComments(e) {
    return this.walk((t, i) => {
      if (t.type === "comment")
        return e(t, i);
    });
  }
  walkDecls(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "decl" && e.test(i.prop))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "decl" && i.prop === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "decl")
        return t(i, r);
    }));
  }
  walkRules(e, t) {
    return t ? e instanceof RegExp ? this.walk((i, r) => {
      if (i.type === "rule" && e.test(i.selector))
        return t(i, r);
    }) : this.walk((i, r) => {
      if (i.type === "rule" && i.selector === e)
        return t(i, r);
    }) : (t = e, this.walk((i, r) => {
      if (i.type === "rule")
        return t(i, r);
    }));
  }
};
Te.registerParse = (s) => {
  mo = s;
};
Te.registerRule = (s) => {
  Ir = s;
};
Te.registerAtRule = (s) => {
  Sr = s;
};
Te.registerRoot = (s) => {
  fo = s;
};
var $e = Te;
Te.default = Te;
Te.rebuild = (s) => {
  s.type === "atrule" ? Object.setPrototypeOf(s, Sr.prototype) : s.type === "rule" ? Object.setPrototypeOf(s, Ir.prototype) : s.type === "decl" ? Object.setPrototypeOf(s, uo.prototype) : s.type === "comment" ? Object.setPrototypeOf(s, co.prototype) : s.type === "root" && Object.setPrototypeOf(s, fo.prototype), s[po] = !0, s.nodes && s.nodes.forEach((e) => {
    Te.rebuild(e);
  });
};
let go = $e, Ni = class extends go {
  constructor(e) {
    super(e), this.type = "atrule";
  }
  append(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
  }
  prepend(...e) {
    return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
  }
};
var Vr = Ni;
Ni.default = Ni;
go.registerAtRule(Ni);
let ld = $e, Xo, Go, Kt = class extends ld {
  constructor(e) {
    super(x({ type: "document" }, e)), this.nodes || (this.nodes = []);
  }
  toResult(e = {}) {
    return new Xo(new Go(), this, e).stringify();
  }
};
Kt.registerLazyResult = (s) => {
  Xo = s;
};
Kt.registerProcessor = (s) => {
  Go = s;
};
var Rr = Kt;
Kt.default = Kt;
let od = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", ad = (s = 21) => {
  let e = "", t = s | 0;
  for (; t--; )
    e += od[Math.random() * 64 | 0];
  return e;
};
var cd = { nanoid: ad };
let { existsSync: ud, readFileSync: hd } = Se, { dirname: ds, join: dd } = Se, { SourceMapConsumer: In, SourceMapGenerator: Vn } = Se;
function pd(s) {
  return Buffer ? Buffer.from(s, "base64").toString() : window.atob(s);
}
let Bs = class {
  constructor(e, t) {
    if (t.map === !1) return;
    this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
    let i = t.map ? t.map.prev : void 0, r = this.loadMap(t.from, i);
    !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = ds(this.mapFile)), r && (this.text = r);
  }
  consumer() {
    return this.consumerCache || (this.consumerCache = new In(this.text)), this.consumerCache;
  }
  decodeInline(e) {
    let t = /^data:application\/json;charset=utf-?8;base64,/, i = /^data:application\/json;base64,/, r = /^data:application\/json;charset=utf-?8,/, n = /^data:application\/json,/, o = e.match(r) || e.match(n);
    if (o)
      return decodeURIComponent(e.substr(o[0].length));
    let a = e.match(t) || e.match(i);
    if (a)
      return pd(e.substr(a[0].length));
    let l = e.match(/data:application\/json;([^,]+),/)[1];
    throw new Error("Unsupported source map encoding " + l);
  }
  getAnnotationURL(e) {
    return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
  }
  isMap(e) {
    return typeof e != "object" ? !1 : typeof e.mappings == "string" || typeof e._mappings == "string" || Array.isArray(e.sections);
  }
  loadAnnotation(e) {
    let t = e.match(/\/\*\s*# sourceMappingURL=/g);
    if (!t) return;
    let i = e.lastIndexOf(t.pop()), r = e.indexOf("*/", i);
    i > -1 && r > -1 && (this.annotation = this.getAnnotationURL(e.substring(i, r)));
  }
  loadFile(e) {
    if (this.root = ds(e), ud(e))
      return this.mapFile = e, hd(e, "utf-8").toString().trim();
  }
  loadMap(e, t) {
    if (t === !1) return !1;
    if (t) {
      if (typeof t == "string")
        return t;
      if (typeof t == "function") {
        let i = t(e);
        if (i) {
          let r = this.loadFile(i);
          if (!r)
            throw new Error(
              "Unable to load previous source map: " + i.toString()
            );
          return r;
        }
      } else {
        if (t instanceof In)
          return Vn.fromSourceMap(t).toString();
        if (t instanceof Vn)
          return t.toString();
        if (this.isMap(t))
          return JSON.stringify(t);
        throw new Error(
          "Unsupported previous source map format: " + t.toString()
        );
      }
    } else {
      if (this.inline)
        return this.decodeInline(this.annotation);
      if (this.annotation) {
        let i = this.annotation;
        return e && (i = dd(ds(e), i)), this.loadFile(i);
      }
    }
  }
  startWith(e, t) {
    return e ? e.substr(0, t.length) === t : !1;
  }
  withContent() {
    return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
  }
};
var So = Bs;
Bs.default = Bs;
let { nanoid: md } = cd, { isAbsolute: Qs, resolve: Ds } = Se, { SourceMapConsumer: fd, SourceMapGenerator: bd } = Se, { fileURLToPath: Rn, pathToFileURL: ai } = Se, Wn = Gr, Zd = So, ps = Se, ms = Symbol("lineToIndexCache"), yd = !!(fd && bd), Cn = !!(Ds && Qs);
function wn(s) {
  if (s[ms]) return s[ms];
  let e = s.css.split(`
`), t = new Array(e.length), i = 0;
  for (let r = 0, n = e.length; r < n; r++)
    t[r] = i, i += e[r].length + 1;
  return s[ms] = t, t;
}
let Ti = class {
  get from() {
    return this.file || this.id;
  }
  constructor(e, t = {}) {
    if (e === null || typeof e == "undefined" || typeof e == "object" && !e.toString)
      throw new Error(`PostCSS received ${e} instead of CSS string`);
    if (this.css = e.toString(), this.css[0] === "\uFEFF" || this.css[0] === "￾" ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, this.document = this.css, t.document && (this.document = t.document.toString()), t.from && (!Cn || /^\w+:\/\//.test(t.from) || Qs(t.from) ? this.file = t.from : this.file = Ds(t.from)), Cn && yd) {
      let i = new Zd(this.css, t);
      if (i.text) {
        this.map = i;
        let r = i.consumer().file;
        !this.file && r && (this.file = this.mapResolve(r));
      }
    }
    this.file || (this.id = "<input css " + md(6) + ">"), this.map && (this.map.file = this.from);
  }
  error(e, t, i, r = {}) {
    let n, o, a, l, u;
    if (t && typeof t == "object") {
      let h = t, p = i;
      if (typeof h.offset == "number") {
        l = h.offset;
        let d = this.fromOffset(l);
        t = d.line, i = d.col;
      } else
        t = h.line, i = h.column, l = this.fromLineAndColumn(t, i);
      if (typeof p.offset == "number") {
        a = p.offset;
        let d = this.fromOffset(a);
        o = d.line, n = d.col;
      } else
        o = p.line, n = p.column, a = this.fromLineAndColumn(p.line, p.column);
    } else if (i)
      l = this.fromLineAndColumn(t, i);
    else {
      l = t;
      let h = this.fromOffset(l);
      t = h.line, i = h.col;
    }
    let c = this.origin(t, i, o, n);
    return c ? u = new Wn(
      e,
      c.endLine === void 0 ? c.line : { column: c.column, line: c.line },
      c.endLine === void 0 ? c.column : { column: c.endColumn, line: c.endLine },
      c.source,
      c.file,
      r.plugin
    ) : u = new Wn(
      e,
      o === void 0 ? t : { column: i, line: t },
      o === void 0 ? i : { column: n, line: o },
      this.css,
      this.file,
      r.plugin
    ), u.input = { column: i, endColumn: n, endLine: o, endOffset: a, line: t, offset: l, source: this.css }, this.file && (ai && (u.input.url = ai(this.file).toString()), u.input.file = this.file), u;
  }
  fromLineAndColumn(e, t) {
    return wn(this)[e - 1] + t - 1;
  }
  fromOffset(e) {
    let t = wn(this), i = t[t.length - 1], r = 0;
    if (e >= i)
      r = t.length - 1;
    else {
      let n = t.length - 2, o;
      for (; r < n; )
        if (o = r + (n - r >> 1), e < t[o])
          n = o - 1;
        else if (e >= t[o + 1])
          r = o + 1;
        else {
          r = o;
          break;
        }
    }
    return {
      col: e - t[r] + 1,
      line: r + 1
    };
  }
  mapResolve(e) {
    return /^\w+:\/\//.test(e) ? e : Ds(this.map.consumer().sourceRoot || this.map.root || ".", e);
  }
  origin(e, t, i, r) {
    if (!this.map) return !1;
    let n = this.map.consumer(), o = n.originalPositionFor({ column: t, line: e });
    if (!o.source) return !1;
    let a;
    typeof i == "number" && (a = n.originalPositionFor({ column: r, line: i }));
    let l;
    Qs(o.source) ? l = ai(o.source) : l = new URL(
      o.source,
      this.map.consumer().sourceRoot || ai(this.map.mapFile)
    );
    let u = {
      column: o.column,
      endColumn: a && a.column,
      endLine: a && a.line,
      line: o.line,
      url: l.toString()
    };
    if (l.protocol === "file:")
      if (Rn)
        u.file = Rn(l);
      else
        throw new Error("file: protocol is not available in this PostCSS build");
    let c = n.sourceContentFor(o.source);
    return c && (u.source = c), u;
  }
  toJSON() {
    let e = {};
    for (let t of ["hasBOM", "css", "file", "id"])
      this[t] != null && (e[t] = this[t]);
    return this.map && (e.map = x({}, this.map), e.map.consumerCache && (e.map.consumerCache = void 0)), e;
  }
};
var $i = Ti;
Ti.default = Ti;
ps && ps.registerInput && ps.registerInput(Ti);
let Io = $e, Vo, Ro, pt = class extends Io {
  constructor(e) {
    super(e), this.type = "root", this.nodes || (this.nodes = []);
  }
  normalize(e, t, i) {
    let r = super.normalize(e);
    if (t) {
      if (i === "prepend")
        this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;
      else if (this.first !== t)
        for (let n of r)
          n.raws.before = t.raws.before;
    }
    return r;
  }
  removeChild(e, t) {
    let i = this.index(e);
    return !t && i === 0 && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[i].raws.before), super.removeChild(e);
  }
  toResult(e = {}) {
    return new Vo(new Ro(), this, e).stringify();
  }
};
pt.registerLazyResult = (s) => {
  Vo = s;
};
pt.registerProcessor = (s) => {
  Ro = s;
};
var Qt = pt;
pt.default = pt;
Io.registerRoot(pt);
let Ft = {
  comma(s) {
    return Ft.split(s, [","], !0);
  },
  space(s) {
    let e = [" ", `
`, "	"];
    return Ft.split(s, e);
  },
  split(s, e, t) {
    let i = [], r = "", n = !1, o = 0, a = !1, l = "", u = !1;
    for (let c of s)
      u ? u = !1 : c === "\\" ? u = !0 : a ? c === l && (a = !1) : c === '"' || c === "'" ? (a = !0, l = c) : c === "(" ? o += 1 : c === ")" ? o > 0 && (o -= 1) : o === 0 && e.includes(c) && (n = !0), n ? (r !== "" && i.push(r.trim()), r = "", n = !1) : r += c;
    return (t || r !== "") && i.push(r.trim()), i;
  }
};
var Wo = Ft;
Ft.default = Ft;
let Co = $e, gd = Wo, Ui = class extends Co {
  get selectors() {
    return gd.comma(this.selector);
  }
  set selectors(e) {
    let t = this.selector ? this.selector.match(/,\s*/) : null, i = t ? t[0] : "," + this.raw("between", "beforeOpen");
    this.selector = e.join(i);
  }
  constructor(e) {
    super(e), this.type = "rule", this.nodes || (this.nodes = []);
  }
};
var Wr = Ui;
Ui.default = Ui;
Co.registerRule(Ui);
let Xd = Vr, Gd = Ai, Sd = _i, Id = $i, Vd = So, Rd = Qt, Wd = Wr;
function Mt(s, e) {
  if (Array.isArray(s)) return s.map((o) => Mt(o));
  let r = s, { inputs: t } = r, i = Qe(r, ["inputs"]);
  if (t) {
    e = [];
    for (let o of t) {
      let a = re(x({}, o), { __proto__: Id.prototype });
      a.map && (a.map = re(x({}, a.map), {
        __proto__: Vd.prototype
      })), e.push(a);
    }
  }
  if (i.nodes && (i.nodes = s.nodes.map((o) => Mt(o, e))), i.source) {
    let n = i.source, { inputId: o } = n, a = Qe(n, ["inputId"]);
    i.source = a, o != null && (i.source.input = e[o]);
  }
  if (i.type === "root")
    return new Rd(i);
  if (i.type === "decl")
    return new Sd(i);
  if (i.type === "rule")
    return new Wd(i);
  if (i.type === "comment")
    return new Gd(i);
  if (i.type === "atrule")
    return new Xd(i);
  throw new Error("Unknown node type: " + s.type);
}
var Cd = Mt;
Mt.default = Mt;
let { dirname: Ii, relative: wo, resolve: xo, sep: Lo } = Se, { SourceMapConsumer: ko, SourceMapGenerator: Vi } = Se, { pathToFileURL: xn } = Se, wd = $i, xd = !!(ko && Vi), Ld = !!(Ii && xo && wo && Lo), kd = class {
  constructor(e, t, i, r) {
    this.stringify = e, this.mapOpts = i.map || {}, this.root = t, this.opts = i, this.css = r, this.originalCSS = r, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = /* @__PURE__ */ new Map(), this.memoizedPaths = /* @__PURE__ */ new Map(), this.memoizedURLs = /* @__PURE__ */ new Map();
  }
  addAnnotation() {
    let e;
    this.isInline() ? e = "data:application/json;base64," + this.toBase64(this.map.toString()) : typeof this.mapOpts.annotation == "string" ? e = this.mapOpts.annotation : typeof this.mapOpts.annotation == "function" ? e = this.mapOpts.annotation(this.opts.to, this.root) : e = this.outputFile() + ".map";
    let t = `
`;
    this.css.includes(`\r
`) && (t = `\r
`), this.css += t + "/*# sourceMappingURL=" + e + " */";
  }
  applyPrevMaps() {
    for (let e of this.previous()) {
      let t = this.toUrl(this.path(e.file)), i = e.root || Ii(e.file), r;
      this.mapOpts.sourcesContent === !1 ? (r = new ko(e.text), r.sourcesContent && (r.sourcesContent = null)) : r = e.consumer(), this.map.applySourceMap(r, t, this.toUrl(this.path(i)));
    }
  }
  clearAnnotation() {
    if (this.mapOpts.annotation !== !1)
      if (this.root) {
        let e;
        for (let t = this.root.nodes.length - 1; t >= 0; t--)
          e = this.root.nodes[t], e.type === "comment" && e.text.startsWith("# sourceMappingURL=") && this.root.removeChild(t);
      } else this.css && (this.css = this.css.replace(/\n*\/\*#[\S\s]*?\*\/$/gm, ""));
  }
  generate() {
    if (this.clearAnnotation(), Ld && xd && this.isMap())
      return this.generateMap();
    {
      let e = "";
      return this.stringify(this.root, (t) => {
        e += t;
      }), [e];
    }
  }
  generateMap() {
    if (this.root)
      this.generateString();
    else if (this.previous().length === 1) {
      let e = this.previous()[0].consumer();
      e.file = this.outputFile(), this.map = Vi.fromSourceMap(e, {
        ignoreInvalidMapping: !0
      });
    } else
      this.map = new Vi({
        file: this.outputFile(),
        ignoreInvalidMapping: !0
      }), this.map.addMapping({
        generated: { column: 0, line: 1 },
        original: { column: 0, line: 1 },
        source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
      });
    return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
  }
  generateString() {
    this.css = "", this.map = new Vi({
      file: this.outputFile(),
      ignoreInvalidMapping: !0
    });
    let e = 1, t = 1, i = "<no source>", r = {
      generated: { column: 0, line: 0 },
      original: { column: 0, line: 0 },
      source: ""
    }, n, o;
    this.stringify(this.root, (a, l, u) => {
      if (this.css += a, l && u !== "end" && (r.generated.line = e, r.generated.column = t - 1, l.source && l.source.start ? (r.source = this.sourcePath(l), r.original.line = l.source.start.line, r.original.column = l.source.start.column - 1, this.map.addMapping(r)) : (r.source = i, r.original.line = 1, r.original.column = 0, this.map.addMapping(r))), o = a.match(/\n/g), o ? (e += o.length, n = a.lastIndexOf(`
`), t = a.length - n) : t += a.length, l && u !== "start") {
        let c = l.parent || { raws: {} };
        (!(l.type === "decl" || l.type === "atrule" && !l.nodes) || l !== c.last || c.raws.semicolon) && (l.source && l.source.end ? (r.source = this.sourcePath(l), r.original.line = l.source.end.line, r.original.column = l.source.end.column - 1, r.generated.line = e, r.generated.column = t - 2, this.map.addMapping(r)) : (r.source = i, r.original.line = 1, r.original.column = 0, r.generated.line = e, r.generated.column = t - 1, this.map.addMapping(r)));
      }
    });
  }
  isAnnotation() {
    return this.isInline() ? !0 : typeof this.mapOpts.annotation != "undefined" ? this.mapOpts.annotation : this.previous().length ? this.previous().some((e) => e.annotation) : !0;
  }
  isInline() {
    if (typeof this.mapOpts.inline != "undefined")
      return this.mapOpts.inline;
    let e = this.mapOpts.annotation;
    return typeof e != "undefined" && e !== !0 ? !1 : this.previous().length ? this.previous().some((t) => t.inline) : !0;
  }
  isMap() {
    return typeof this.opts.map != "undefined" ? !!this.opts.map : this.previous().length > 0;
  }
  isSourcesContent() {
    return typeof this.mapOpts.sourcesContent != "undefined" ? this.mapOpts.sourcesContent : this.previous().length ? this.previous().some((e) => e.withContent()) : !0;
  }
  outputFile() {
    return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
  }
  path(e) {
    if (this.mapOpts.absolute || e.charCodeAt(0) === 60 || /^\w+:\/\//.test(e)) return e;
    let t = this.memoizedPaths.get(e);
    if (t) return t;
    let i = this.opts.to ? Ii(this.opts.to) : ".";
    typeof this.mapOpts.annotation == "string" && (i = Ii(xo(i, this.mapOpts.annotation)));
    let r = wo(i, e);
    return this.memoizedPaths.set(e, r), r;
  }
  previous() {
    if (!this.previousMaps)
      if (this.previousMaps = [], this.root)
        this.root.walk((e) => {
          if (e.source && e.source.input.map) {
            let t = e.source.input.map;
            this.previousMaps.includes(t) || this.previousMaps.push(t);
          }
        });
      else {
        let e = new wd(this.originalCSS, this.opts);
        e.map && this.previousMaps.push(e.map);
      }
    return this.previousMaps;
  }
  setSourcesContent() {
    let e = {};
    if (this.root)
      this.root.walk((t) => {
        if (t.source) {
          let i = t.source.input.from;
          if (i && !e[i]) {
            e[i] = !0;
            let r = this.usesFileUrls ? this.toFileUrl(i) : this.toUrl(this.path(i));
            this.map.setSourceContent(r, t.source.input.css);
          }
        }
      });
    else if (this.css) {
      let t = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
      this.map.setSourceContent(t, this.css);
    }
  }
  sourcePath(e) {
    return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
  }
  toBase64(e) {
    return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
  }
  toFileUrl(e) {
    let t = this.memoizedFileURLs.get(e);
    if (t) return t;
    if (xn) {
      let i = xn(e).toString();
      return this.memoizedFileURLs.set(e, i), i;
    } else
      throw new Error(
        "`map.absolute` option is not available in this PostCSS build"
      );
  }
  toUrl(e) {
    let t = this.memoizedURLs.get(e);
    if (t) return t;
    Lo === "\\" && (e = e.replace(/\\/g, "/"));
    let i = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
    return this.memoizedURLs.set(e, i), i;
  }
};
var Jo = kd;
const fs = 39, Ln = 34, ci = 92, kn = 47, ui = 10, Vt = 32, hi = 12, di = 9, pi = 13, Jd = 91, vd = 93, Yd = 40, Nd = 41, Td = 123, Ud = 125, Kd = 59, Fd = 42, Md = 58, zd = 64, mi = /[\t\n\f\r "#'()/;[\\\]{}]/g, fi = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g, Hd = /.[\r\n"'(/\\]/, Jn = /[\da-f]/i;
var Od = function(e, t = {}) {
  let i = e.css.valueOf(), r = t.ignoreErrors, n, o, a, l, u, c, h, p, d, b, m = i.length, f = 0, V = [], G = [];
  function g() {
    return f;
  }
  function S(R) {
    throw e.error("Unclosed " + R, f);
  }
  function y() {
    return G.length === 0 && f >= m;
  }
  function W(R) {
    if (G.length) return G.pop();
    if (f >= m) return;
    let Z = R ? R.ignoreUnclosed : !1;
    switch (n = i.charCodeAt(f), n) {
      case ui:
      case Vt:
      case di:
      case pi:
      case hi: {
        l = f;
        do
          l += 1, n = i.charCodeAt(l);
        while (n === Vt || n === ui || n === di || n === pi || n === hi);
        c = ["space", i.slice(f, l)], f = l - 1;
        break;
      }
      case Jd:
      case vd:
      case Td:
      case Ud:
      case Md:
      case Kd:
      case Nd: {
        let I = String.fromCharCode(n);
        c = [I, I, f];
        break;
      }
      case Yd: {
        if (b = V.length ? V.pop()[1] : "", d = i.charCodeAt(f + 1), b === "url" && d !== fs && d !== Ln && d !== Vt && d !== ui && d !== di && d !== hi && d !== pi) {
          l = f;
          do {
            if (h = !1, l = i.indexOf(")", l + 1), l === -1)
              if (r || Z) {
                l = f;
                break;
              } else
                S("bracket");
            for (p = l; i.charCodeAt(p - 1) === ci; )
              p -= 1, h = !h;
          } while (h);
          c = ["brackets", i.slice(f, l + 1), f, l], f = l;
        } else
          l = i.indexOf(")", f + 1), o = i.slice(f, l + 1), l === -1 || Hd.test(o) ? c = ["(", "(", f] : (c = ["brackets", o, f, l], f = l);
        break;
      }
      case fs:
      case Ln: {
        u = n === fs ? "'" : '"', l = f;
        do {
          if (h = !1, l = i.indexOf(u, l + 1), l === -1)
            if (r || Z) {
              l = f + 1;
              break;
            } else
              S("string");
          for (p = l; i.charCodeAt(p - 1) === ci; )
            p -= 1, h = !h;
        } while (h);
        c = ["string", i.slice(f, l + 1), f, l], f = l;
        break;
      }
      case zd: {
        mi.lastIndex = f + 1, mi.test(i), mi.lastIndex === 0 ? l = i.length - 1 : l = mi.lastIndex - 2, c = ["at-word", i.slice(f, l + 1), f, l], f = l;
        break;
      }
      case ci: {
        for (l = f, a = !0; i.charCodeAt(l + 1) === ci; )
          l += 1, a = !a;
        if (n = i.charCodeAt(l + 1), a && n !== kn && n !== Vt && n !== ui && n !== di && n !== pi && n !== hi && (l += 1, Jn.test(i.charAt(l)))) {
          for (; Jn.test(i.charAt(l + 1)); )
            l += 1;
          i.charCodeAt(l + 1) === Vt && (l += 1);
        }
        c = ["word", i.slice(f, l + 1), f, l], f = l;
        break;
      }
      default: {
        n === kn && i.charCodeAt(f + 1) === Fd ? (l = i.indexOf("*/", f + 2) + 1, l === 0 && (r || Z ? l = i.length : S("comment")), c = ["comment", i.slice(f, l + 1), f, l], f = l) : (fi.lastIndex = f + 1, fi.test(i), fi.lastIndex === 0 ? l = i.length - 1 : l = fi.lastIndex - 2, c = ["word", i.slice(f, l + 1), f, l], V.push(c), f = l);
        break;
      }
    }
    return f++, c;
  }
  function C(R) {
    G.push(R);
  }
  return {
    back: C,
    endOfFile: y,
    nextToken: W,
    position: g
  };
};
let Pd = Vr, Ed = Ai, Bd = _i, Qd = Qt, vn = Wr, Dd = Od;
const Yn = {
  empty: !0,
  space: !0
};
function jd(s) {
  for (let e = s.length - 1; e >= 0; e--) {
    let t = s[e], i = t[3] || t[2];
    if (i) return i;
  }
}
let Ad = class {
  constructor(e) {
    this.input = e, this.root = new Qd(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = { input: e, start: { column: 1, line: 1, offset: 0 } };
  }
  atrule(e) {
    let t = new Pd();
    t.name = e[1].slice(1), t.name === "" && this.unnamedAtrule(t, e), this.init(t, e[2]);
    let i, r, n, o = !1, a = !1, l = [], u = [];
    for (; !this.tokenizer.endOfFile(); ) {
      if (e = this.tokenizer.nextToken(), i = e[0], i === "(" || i === "[" ? u.push(i === "(" ? ")" : "]") : i === "{" && u.length > 0 ? u.push("}") : i === u[u.length - 1] && u.pop(), u.length === 0)
        if (i === ";") {
          t.source.end = this.getPosition(e[2]), t.source.end.offset++, this.semicolon = !0;
          break;
        } else if (i === "{") {
          a = !0;
          break;
        } else if (i === "}") {
          if (l.length > 0) {
            for (n = l.length - 1, r = l[n]; r && r[0] === "space"; )
              r = l[--n];
            r && (t.source.end = this.getPosition(r[3] || r[2]), t.source.end.offset++);
          }
          this.end(e);
          break;
        } else
          l.push(e);
      else
        l.push(e);
      if (this.tokenizer.endOfFile()) {
        o = !0;
        break;
      }
    }
    t.raws.between = this.spacesAndCommentsFromEnd(l), l.length ? (t.raws.afterName = this.spacesAndCommentsFromStart(l), this.raw(t, "params", l), o && (e = l[l.length - 1], t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++, this.spaces = t.raws.between, t.raws.between = "")) : (t.raws.afterName = "", t.params = ""), a && (t.nodes = [], this.current = t);
  }
  checkMissedSemicolon(e) {
    let t = this.colon(e);
    if (t === !1) return;
    let i = 0, r;
    for (let n = t - 1; n >= 0 && (r = e[n], !(r[0] !== "space" && (i += 1, i === 2))); n--)
      ;
    throw this.input.error(
      "Missed semicolon",
      r[0] === "word" ? r[3] + 1 : r[2]
    );
  }
  colon(e) {
    let t = 0, i, r, n;
    for (let [o, a] of e.entries()) {
      if (r = a, n = r[0], n === "(" && (t += 1), n === ")" && (t -= 1), t === 0 && n === ":")
        if (!i)
          this.doubleColon(r);
        else {
          if (i[0] === "word" && i[1] === "progid")
            continue;
          return o;
        }
      i = r;
    }
    return !1;
  }
  comment(e) {
    let t = new Ed();
    this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
    let i = e[1].slice(2, -2);
    if (/^\s*$/.test(i))
      t.text = "", t.raws.left = i, t.raws.right = "";
    else {
      let r = i.match(/^(\s*)([^]*\S)(\s*)$/);
      t.text = r[2], t.raws.left = r[1], t.raws.right = r[3];
    }
  }
  createTokenizer() {
    this.tokenizer = Dd(this.input);
  }
  decl(e, t) {
    let i = new Bd();
    this.init(i, e[0][2]);
    let r = e[e.length - 1];
    for (r[0] === ";" && (this.semicolon = !0, e.pop()), i.source.end = this.getPosition(
      r[3] || r[2] || jd(e)
    ), i.source.end.offset++; e[0][0] !== "word"; )
      e.length === 1 && this.unknownWord(e), i.raws.before += e.shift()[1];
    for (i.source.start = this.getPosition(e[0][2]), i.prop = ""; e.length; ) {
      let u = e[0][0];
      if (u === ":" || u === "space" || u === "comment")
        break;
      i.prop += e.shift()[1];
    }
    i.raws.between = "";
    let n;
    for (; e.length; )
      if (n = e.shift(), n[0] === ":") {
        i.raws.between += n[1];
        break;
      } else
        n[0] === "word" && /\w/.test(n[1]) && this.unknownWord([n]), i.raws.between += n[1];
    (i.prop[0] === "_" || i.prop[0] === "*") && (i.raws.before += i.prop[0], i.prop = i.prop.slice(1));
    let o = [], a;
    for (; e.length && (a = e[0][0], !(a !== "space" && a !== "comment")); )
      o.push(e.shift());
    this.precheckMissedSemicolon(e);
    for (let u = e.length - 1; u >= 0; u--) {
      if (n = e[u], n[1].toLowerCase() === "!important") {
        i.important = !0;
        let c = this.stringFrom(e, u);
        c = this.spacesFromEnd(e) + c, c !== " !important" && (i.raws.important = c);
        break;
      } else if (n[1].toLowerCase() === "important") {
        let c = e.slice(0), h = "";
        for (let p = u; p > 0; p--) {
          let d = c[p][0];
          if (h.trim().startsWith("!") && d !== "space")
            break;
          h = c.pop()[1] + h;
        }
        h.trim().startsWith("!") && (i.important = !0, i.raws.important = h, e = c);
      }
      if (n[0] !== "space" && n[0] !== "comment")
        break;
    }
    e.some((u) => u[0] !== "space" && u[0] !== "comment") && (i.raws.between += o.map((u) => u[1]).join(""), o = []), this.raw(i, "value", o.concat(e), t), i.value.includes(":") && !t && this.checkMissedSemicolon(e);
  }
  doubleColon(e) {
    throw this.input.error(
      "Double colon",
      { offset: e[2] },
      { offset: e[2] + e[1].length }
    );
  }
  emptyRule(e) {
    let t = new vn();
    this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
  }
  end(e) {
    this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
  }
  endFile() {
    this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
  }
  freeSemicolon(e) {
    if (this.spaces += e[1], this.current.nodes) {
      let t = this.current.nodes[this.current.nodes.length - 1];
      t && t.type === "rule" && !t.raws.ownSemicolon && (t.raws.ownSemicolon = this.spaces, this.spaces = "", t.source.end = this.getPosition(e[2]), t.source.end.offset += t.raws.ownSemicolon.length);
    }
  }
  // Helpers
  getPosition(e) {
    let t = this.input.fromOffset(e);
    return {
      column: t.col,
      line: t.line,
      offset: e
    };
  }
  init(e, t) {
    this.current.push(e), e.source = {
      input: this.input,
      start: this.getPosition(t)
    }, e.raws.before = this.spaces, this.spaces = "", e.type !== "comment" && (this.semicolon = !1);
  }
  other(e) {
    let t = !1, i = null, r = !1, n = null, o = [], a = e[1].startsWith("--"), l = [], u = e;
    for (; u; ) {
      if (i = u[0], l.push(u), i === "(" || i === "[")
        n || (n = u), o.push(i === "(" ? ")" : "]");
      else if (a && r && i === "{")
        n || (n = u), o.push("}");
      else if (o.length === 0)
        if (i === ";")
          if (r) {
            this.decl(l, a);
            return;
          } else
            break;
        else if (i === "{") {
          this.rule(l);
          return;
        } else if (i === "}") {
          this.tokenizer.back(l.pop()), t = !0;
          break;
        } else i === ":" && (r = !0);
      else i === o[o.length - 1] && (o.pop(), o.length === 0 && (n = null));
      u = this.tokenizer.nextToken();
    }
    if (this.tokenizer.endOfFile() && (t = !0), o.length > 0 && this.unclosedBracket(n), t && r) {
      if (!a)
        for (; l.length && (u = l[l.length - 1][0], !(u !== "space" && u !== "comment")); )
          this.tokenizer.back(l.pop());
      this.decl(l, a);
    } else
      this.unknownWord(l);
  }
  parse() {
    let e;
    for (; !this.tokenizer.endOfFile(); )
      switch (e = this.tokenizer.nextToken(), e[0]) {
        case "space":
          this.spaces += e[1];
          break;
        case ";":
          this.freeSemicolon(e);
          break;
        case "}":
          this.end(e);
          break;
        case "comment":
          this.comment(e);
          break;
        case "at-word":
          this.atrule(e);
          break;
        case "{":
          this.emptyRule(e);
          break;
        default:
          this.other(e);
          break;
      }
    this.endFile();
  }
  precheckMissedSemicolon() {
  }
  raw(e, t, i, r) {
    let n, o, a = i.length, l = "", u = !0, c, h;
    for (let p = 0; p < a; p += 1)
      n = i[p], o = n[0], o === "space" && p === a - 1 && !r ? u = !1 : o === "comment" ? (h = i[p - 1] ? i[p - 1][0] : "empty", c = i[p + 1] ? i[p + 1][0] : "empty", !Yn[h] && !Yn[c] ? l.slice(-1) === "," ? u = !1 : l += n[1] : u = !1) : l += n[1];
    if (!u) {
      let p = i.reduce((d, b) => d + b[1], "");
      e.raws[t] = { raw: p, value: l };
    }
    e[t] = l;
  }
  rule(e) {
    e.pop();
    let t = new vn();
    this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
  }
  spacesAndCommentsFromEnd(e) {
    let t, i = "";
    for (; e.length && (t = e[e.length - 1][0], !(t !== "space" && t !== "comment")); )
      i = e.pop()[1] + i;
    return i;
  }
  // Errors
  spacesAndCommentsFromStart(e) {
    let t, i = "";
    for (; e.length && (t = e[0][0], !(t !== "space" && t !== "comment")); )
      i += e.shift()[1];
    return i;
  }
  spacesFromEnd(e) {
    let t, i = "";
    for (; e.length && (t = e[e.length - 1][0], t === "space"); )
      i = e.pop()[1] + i;
    return i;
  }
  stringFrom(e, t) {
    let i = "";
    for (let r = t; r < e.length; r++)
      i += e[r][1];
    return e.splice(t, e.length - t), i;
  }
  unclosedBlock() {
    let e = this.current.source.start;
    throw this.input.error("Unclosed block", e.line, e.column);
  }
  unclosedBracket(e) {
    throw this.input.error(
      "Unclosed bracket",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unexpectedClose(e) {
    throw this.input.error(
      "Unexpected }",
      { offset: e[2] },
      { offset: e[2] + 1 }
    );
  }
  unknownWord(e) {
    throw this.input.error(
      "Unknown word " + e[0][1],
      { offset: e[0][2] },
      { offset: e[0][2] + e[0][1].length }
    );
  }
  unnamedAtrule(e, t) {
    throw this.input.error(
      "At-rule without name",
      { offset: t[2] },
      { offset: t[2] + t[1].length }
    );
  }
};
var _d = Ad;
let $d = $e, qd = $i, ep = _d;
function Ki(s, e) {
  let t = new qd(s, e), i = new ep(t);
  try {
    i.parse();
  } catch (r) {
    throw process.env.NODE_ENV !== "production" && r.name === "CssSyntaxError" && e && e.from && (/\.scss$/i.test(e.from) ? r.message += `
You tried to parse SCSS with the standard CSS parser; try again with the postcss-scss parser` : /\.sass/i.test(e.from) ? r.message += `
You tried to parse Sass with the standard CSS parser; try again with the postcss-sass parser` : /\.less$/i.test(e.from) && (r.message += `
You tried to parse Less with the standard CSS parser; try again with the postcss-less parser`)), r;
  }
  return i.root;
}
var Cr = Ki;
Ki.default = Ki;
$d.registerParse(Ki);
let js = class {
  constructor(e, t = {}) {
    if (this.type = "warning", this.text = e, t.node && t.node.source) {
      let i = t.node.rangeBy(t);
      this.line = i.start.line, this.column = i.start.column, this.endLine = i.end.line, this.endColumn = i.end.column;
    }
    for (let i in t) this[i] = t[i];
  }
  toString() {
    return this.node ? this.node.error(this.text, {
      index: this.index,
      plugin: this.plugin,
      word: this.word
    }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
  }
};
var vo = js;
js.default = js;
let tp = vo, As = class {
  get content() {
    return this.css;
  }
  constructor(e, t, i) {
    this.processor = e, this.messages = [], this.root = t, this.opts = i, this.css = "", this.map = void 0;
  }
  toString() {
    return this.css;
  }
  warn(e, t = {}) {
    t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
    let i = new tp(e, t);
    return this.messages.push(i), i;
  }
  warnings() {
    return this.messages.filter((e) => e.type === "warning");
  }
};
var wr = As;
As.default = As;
let Nn = {};
var Yo = function(e) {
  Nn[e] || (Nn[e] = !0, typeof console != "undefined" && console.warn && console.warn(e));
};
let ip = $e, sp = Rr, rp = Jo, np = Cr, Tn = wr, lp = Qt, op = Di, { isClean: Re, my: ap } = Bt, cp = Yo;
const up = {
  atrule: "AtRule",
  comment: "Comment",
  decl: "Declaration",
  document: "Document",
  root: "Root",
  rule: "Rule"
}, hp = {
  AtRule: !0,
  AtRuleExit: !0,
  Comment: !0,
  CommentExit: !0,
  Declaration: !0,
  DeclarationExit: !0,
  Document: !0,
  DocumentExit: !0,
  Once: !0,
  OnceExit: !0,
  postcssPlugin: !0,
  prepare: !0,
  Root: !0,
  RootExit: !0,
  Rule: !0,
  RuleExit: !0
}, dp = {
  Once: !0,
  postcssPlugin: !0,
  prepare: !0
}, mt = 0;
function Rt(s) {
  return typeof s == "object" && typeof s.then == "function";
}
function No(s) {
  let e = !1, t = up[s.type];
  return s.type === "decl" ? e = s.prop.toLowerCase() : s.type === "atrule" && (e = s.name.toLowerCase()), e && s.append ? [
    t,
    t + "-" + e,
    mt,
    t + "Exit",
    t + "Exit-" + e
  ] : e ? [t, t + "-" + e, t + "Exit", t + "Exit-" + e] : s.append ? [t, mt, t + "Exit"] : [t, t + "Exit"];
}
function Un(s) {
  let e;
  return s.type === "document" ? e = ["Document", mt, "DocumentExit"] : s.type === "root" ? e = ["Root", mt, "RootExit"] : e = No(s), {
    eventIndex: 0,
    events: e,
    iterator: 0,
    node: s,
    visitorIndex: 0,
    visitors: []
  };
}
function _s(s) {
  return s[Re] = !1, s.nodes && s.nodes.forEach((e) => _s(e)), s;
}
let $s = {}, ft = class To {
  get content() {
    return this.stringify().content;
  }
  get css() {
    return this.stringify().css;
  }
  get map() {
    return this.stringify().map;
  }
  get messages() {
    return this.sync().messages;
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    return this.sync().root;
  }
  get [Symbol.toStringTag]() {
    return "LazyResult";
  }
  constructor(e, t, i) {
    this.stringified = !1, this.processed = !1;
    let r;
    if (typeof t == "object" && t !== null && (t.type === "root" || t.type === "document"))
      r = _s(t);
    else if (t instanceof To || t instanceof Tn)
      r = _s(t.root), t.map && (typeof i.map == "undefined" && (i.map = {}), i.map.inline || (i.map.inline = !1), i.map.prev = t.map);
    else {
      let n = np;
      i.syntax && (n = i.syntax.parse), i.parser && (n = i.parser), n.parse && (n = n.parse);
      try {
        r = n(t, i);
      } catch (o) {
        this.processed = !0, this.error = o;
      }
      r && !r[ap] && ip.rebuild(r);
    }
    this.result = new Tn(e, r, i), this.helpers = re(x({}, $s), { postcss: $s, result: this.result }), this.plugins = this.processor.plugins.map((n) => typeof n == "object" && n.prepare ? x(x({}, n), n.prepare(this.result)) : n);
  }
  async() {
    return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  getAsyncError() {
    throw new Error("Use process(css).then(cb) to work with async plugins");
  }
  handleError(e, t) {
    let i = this.result.lastPlugin;
    try {
      if (t && t.addToError(e), this.error = e, e.name === "CssSyntaxError" && !e.plugin)
        e.plugin = i.postcssPlugin, e.setMessage();
      else if (i.postcssVersion && process.env.NODE_ENV !== "production") {
        let r = i.postcssPlugin, n = i.postcssVersion, o = this.result.processor.version, a = n.split("."), l = o.split(".");
        (a[0] !== l[0] || parseInt(a[1]) > parseInt(l[1])) && console.error(
          "Unknown error from PostCSS plugin. Your current PostCSS version is " + o + ", but " + r + " uses " + n + ". Perhaps this is the source of the error below."
        );
      }
    } catch (r) {
      console && console.error && console.error(r);
    }
    return e;
  }
  prepareVisitors() {
    this.listeners = {};
    let e = (t, i, r) => {
      this.listeners[i] || (this.listeners[i] = []), this.listeners[i].push([t, r]);
    };
    for (let t of this.plugins)
      if (typeof t == "object")
        for (let i in t) {
          if (!hp[i] && /^[A-Z]/.test(i))
            throw new Error(
              `Unknown event ${i} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`
            );
          if (!dp[i])
            if (typeof t[i] == "object")
              for (let r in t[i])
                r === "*" ? e(t, i, t[i][r]) : e(
                  t,
                  i + "-" + r.toLowerCase(),
                  t[i][r]
                );
            else typeof t[i] == "function" && e(t, i, t[i]);
        }
    this.hasListener = Object.keys(this.listeners).length > 0;
  }
  runAsync() {
    return ne(this, null, function* () {
      this.plugin = 0;
      for (let e = 0; e < this.plugins.length; e++) {
        let t = this.plugins[e], i = this.runOnRoot(t);
        if (Rt(i))
          try {
            yield i;
          } catch (r) {
            throw this.handleError(r);
          }
      }
      if (this.prepareVisitors(), this.hasListener) {
        let e = this.result.root;
        for (; !e[Re]; ) {
          e[Re] = !0;
          let t = [Un(e)];
          for (; t.length > 0; ) {
            let i = this.visitTick(t);
            if (Rt(i))
              try {
                yield i;
              } catch (r) {
                let n = t[t.length - 1].node;
                throw this.handleError(r, n);
              }
          }
        }
        if (this.listeners.OnceExit)
          for (let [t, i] of this.listeners.OnceExit) {
            this.result.lastPlugin = t;
            try {
              if (e.type === "document") {
                let r = e.nodes.map(
                  (n) => i(n, this.helpers)
                );
                yield Promise.all(r);
              } else
                yield i(e, this.helpers);
            } catch (r) {
              throw this.handleError(r);
            }
          }
      }
      return this.processed = !0, this.stringify();
    });
  }
  runOnRoot(e) {
    this.result.lastPlugin = e;
    try {
      if (typeof e == "object" && e.Once) {
        if (this.result.root.type === "document") {
          let t = this.result.root.nodes.map(
            (i) => e.Once(i, this.helpers)
          );
          return Rt(t[0]) ? Promise.all(t) : t;
        }
        return e.Once(this.result.root, this.helpers);
      } else if (typeof e == "function")
        return e(this.result.root, this.result);
    } catch (t) {
      throw this.handleError(t);
    }
  }
  stringify() {
    if (this.error) throw this.error;
    if (this.stringified) return this.result;
    this.stringified = !0, this.sync();
    let e = this.result.opts, t = op;
    e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
    let r = new rp(t, this.result.root, this.result.opts).generate();
    return this.result.css = r[0], this.result.map = r[1], this.result;
  }
  sync() {
    if (this.error) throw this.error;
    if (this.processed) return this.result;
    if (this.processed = !0, this.processing)
      throw this.getAsyncError();
    for (let e of this.plugins) {
      let t = this.runOnRoot(e);
      if (Rt(t))
        throw this.getAsyncError();
    }
    if (this.prepareVisitors(), this.hasListener) {
      let e = this.result.root;
      for (; !e[Re]; )
        e[Re] = !0, this.walkSync(e);
      if (this.listeners.OnceExit)
        if (e.type === "document")
          for (let t of e.nodes)
            this.visitSync(this.listeners.OnceExit, t);
        else
          this.visitSync(this.listeners.OnceExit, e);
    }
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this.opts || cp(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this.css;
  }
  visitSync(e, t) {
    for (let [i, r] of e) {
      this.result.lastPlugin = i;
      let n;
      try {
        n = r(t, this.helpers);
      } catch (o) {
        throw this.handleError(o, t.proxyOf);
      }
      if (t.type !== "root" && t.type !== "document" && !t.parent)
        return !0;
      if (Rt(n))
        throw this.getAsyncError();
    }
  }
  visitTick(e) {
    let t = e[e.length - 1], { node: i, visitors: r } = t;
    if (i.type !== "root" && i.type !== "document" && !i.parent) {
      e.pop();
      return;
    }
    if (r.length > 0 && t.visitorIndex < r.length) {
      let [o, a] = r[t.visitorIndex];
      t.visitorIndex += 1, t.visitorIndex === r.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = o;
      try {
        return a(i.toProxy(), this.helpers);
      } catch (l) {
        throw this.handleError(l, i);
      }
    }
    if (t.iterator !== 0) {
      let o = t.iterator, a;
      for (; a = i.nodes[i.indexes[o]]; )
        if (i.indexes[o] += 1, !a[Re]) {
          a[Re] = !0, e.push(Un(a));
          return;
        }
      t.iterator = 0, delete i.indexes[o];
    }
    let n = t.events;
    for (; t.eventIndex < n.length; ) {
      let o = n[t.eventIndex];
      if (t.eventIndex += 1, o === mt) {
        i.nodes && i.nodes.length && (i[Re] = !0, t.iterator = i.getIterator());
        return;
      } else if (this.listeners[o]) {
        t.visitors = this.listeners[o];
        return;
      }
    }
    e.pop();
  }
  walkSync(e) {
    e[Re] = !0;
    let t = No(e);
    for (let i of t)
      if (i === mt)
        e.nodes && e.each((r) => {
          r[Re] || this.walkSync(r);
        });
      else {
        let r = this.listeners[i];
        if (r && this.visitSync(r, e.toProxy()))
          return;
      }
  }
  warnings() {
    return this.sync().warnings();
  }
};
ft.registerPostcss = (s) => {
  $s = s;
};
var Uo = ft;
ft.default = ft;
lp.registerLazyResult(ft);
sp.registerLazyResult(ft);
let pp = Jo, mp = Cr;
const fp = wr;
let bp = Di, Zp = Yo, qs = class {
  get content() {
    return this.result.css;
  }
  get css() {
    return this.result.css;
  }
  get map() {
    return this.result.map;
  }
  get messages() {
    return [];
  }
  get opts() {
    return this.result.opts;
  }
  get processor() {
    return this.result.processor;
  }
  get root() {
    if (this._root)
      return this._root;
    let e, t = mp;
    try {
      e = t(this._css, this._opts);
    } catch (i) {
      this.error = i;
    }
    if (this.error)
      throw this.error;
    return this._root = e, e;
  }
  get [Symbol.toStringTag]() {
    return "NoWorkResult";
  }
  constructor(e, t, i) {
    t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = i, this._map = void 0;
    let r, n = bp;
    this.result = new fp(this._processor, r, this._opts), this.result.css = t;
    let o = this;
    Object.defineProperty(this.result, "root", {
      get() {
        return o.root;
      }
    });
    let a = new pp(n, r, this._opts, t);
    if (a.isMap()) {
      let [l, u] = a.generate();
      l && (this.result.css = l), u && (this.result.map = u);
    } else
      a.clearAnnotation(), this.result.css = a.css;
  }
  async() {
    return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
  }
  catch(e) {
    return this.async().catch(e);
  }
  finally(e) {
    return this.async().then(e, e);
  }
  sync() {
    if (this.error) throw this.error;
    return this.result;
  }
  then(e, t) {
    return process.env.NODE_ENV !== "production" && ("from" in this._opts || Zp(
      "Without `from` option PostCSS could generate wrong source map and will not find Browserslist config. Set it to CSS file path or to `undefined` to prevent this warning."
    )), this.async().then(e, t);
  }
  toString() {
    return this._css;
  }
  warnings() {
    return [];
  }
};
var yp = qs;
qs.default = qs;
let gp = Rr, Xp = Uo, Gp = yp, Sp = Qt, zt = class {
  constructor(e = []) {
    this.version = "8.5.6", this.plugins = this.normalize(e);
  }
  normalize(e) {
    let t = [];
    for (let i of e)
      if (i.postcss === !0 ? i = i() : i.postcss && (i = i.postcss), typeof i == "object" && Array.isArray(i.plugins))
        t = t.concat(i.plugins);
      else if (typeof i == "object" && i.postcssPlugin)
        t.push(i);
      else if (typeof i == "function")
        t.push(i);
      else if (typeof i == "object" && (i.parse || i.stringify)) {
        if (process.env.NODE_ENV !== "production")
          throw new Error(
            "PostCSS syntaxes cannot be used as plugins. Instead, please use one of the syntax/parser/stringifier options as outlined in your PostCSS runner documentation."
          );
      } else
        throw new Error(i + " is not a PostCSS plugin");
    return t;
  }
  process(e, t = {}) {
    return !this.plugins.length && !t.parser && !t.stringifier && !t.syntax ? new Gp(this, e, t) : new Xp(this, e, t);
  }
  use(e) {
    return this.plugins = this.plugins.concat(this.normalize([e])), this;
  }
};
var Ip = zt;
zt.default = zt;
Sp.registerProcessor(zt);
gp.registerProcessor(zt);
let Ko = Vr, Fo = Ai, Vp = $e, Rp = Gr, Mo = _i, zo = Rr, Wp = Cd, Cp = $i, wp = Uo, xp = Wo, Lp = ji, kp = Cr, xr = Ip, Jp = wr, Ho = Qt, Oo = Wr, vp = Di, Yp = vo;
function z(...s) {
  return s.length === 1 && Array.isArray(s[0]) && (s = s[0]), new xr(s);
}
z.plugin = function(e, t) {
  let i = !1;
  function r(...o) {
    console && console.warn && !i && (i = !0, console.warn(
      e + `: postcss.plugin was deprecated. Migration guide:
https://evilmartians.com/chronicles/postcss-8-plugin-migration`
    ), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(
      e + `: 里面 postcss.plugin 被弃用. 迁移指南:
https://www.w3ctech.com/topic/2226`
    ));
    let a = t(...o);
    return a.postcssPlugin = e, a.postcssVersion = new xr().version, a;
  }
  let n;
  return Object.defineProperty(r, "postcss", {
    get() {
      return n || (n = r()), n;
    }
  }), r.process = function(o, a, l) {
    return z([r(l)]).process(o, a);
  }, r;
};
z.stringify = vp;
z.parse = kp;
z.fromJSON = Wp;
z.list = xp;
z.comment = (s) => new Fo(s);
z.atRule = (s) => new Ko(s);
z.decl = (s) => new Mo(s);
z.rule = (s) => new Oo(s);
z.root = (s) => new Ho(s);
z.document = (s) => new zo(s);
z.CssSyntaxError = Rp;
z.Declaration = Mo;
z.Container = Vp;
z.Processor = xr;
z.Document = zo;
z.Comment = Fo;
z.Warning = Yp;
z.AtRule = Ko;
z.Result = Jp;
z.Input = Cp;
z.Rule = Oo;
z.Root = Ho;
z.Node = Lp;
wp.registerPostcss(z);
z.default = z;
class Lr {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  constructor(...e) {
    Ze(this, "parentElement", null), Ze(this, "parentNode", null), Ze(this, "ownerDocument"), Ze(this, "firstChild", null), Ze(this, "lastChild", null), Ze(this, "previousSibling", null), Ze(this, "nextSibling", null), Ze(this, "ELEMENT_NODE", 1), Ze(this, "TEXT_NODE", 3), Ze(this, "nodeType"), Ze(this, "nodeName"), Ze(this, "RRNodeType");
  }
  get childNodes() {
    const e = [];
    let t = this.firstChild;
    for (; t; )
      e.push(t), t = t.nextSibling;
    return e;
  }
  contains(e) {
    if (e instanceof Lr) {
      if (e.ownerDocument !== this.ownerDocument) return !1;
      if (e === this) return !0;
    } else return !1;
    for (; e.parentNode; ) {
      if (e.parentNode === this) return !0;
      e = e.parentNode;
    }
    return !1;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  appendChild(e) {
    throw new Error(
      "RRDomException: Failed to execute 'appendChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  insertBefore(e, t) {
    throw new Error(
      "RRDomException: Failed to execute 'insertBefore' on 'RRNode': This RRNode type does not support this method."
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  removeChild(e) {
    throw new Error(
      "RRDomException: Failed to execute 'removeChild' on 'RRNode': This RRNode type does not support this method."
    );
  }
  toString() {
    return "RRNode";
  }
}
const bi = /* @__PURE__ */ new Map(), Kn = /* @__PURE__ */ new WeakSet();
function Fn(s) {
  return s !== null && typeof s == "object" && "complete" in s && "naturalWidth" in s && "naturalHeight" in s && "src" in s && "onload" in s;
}
function Np(s) {
  if (Kn.has(s))
    return;
  Kn.add(s);
  const e = s.drawImage.bind(s);
  s.drawImage = function(t, ...i) {
    const r = bi.get(s);
    r && (r.cancelled = !0);
    const n = () => {
      i.length === 2 && Fn(t) && i.push(t.naturalWidth || t.width, t.naturalHeight || t.height), e(t, ...i);
    };
    if (Fn(t) && !t.complete) {
      const o = { cancelled: !1 };
      bi.set(s, o);
      const a = () => {
        o.cancelled || (bi.delete(s), n());
      }, l = () => {
        if (!o.cancelled) {
          bi.delete(s);
          try {
            n();
          } catch (u) {
          }
        }
      };
      t.onload = a, t.onerror = l;
    } else
      n();
  };
}
const Mn = {
  Node: ["childNodes", "parentNode", "parentElement", "textContent"],
  ShadowRoot: ["host", "styleSheets"],
  Element: ["shadowRoot", "querySelector", "querySelectorAll"],
  MutationObserver: []
}, zn = {
  Node: ["contains", "getRootNode"],
  ShadowRoot: ["getSelection"],
  Element: [],
  MutationObserver: ["constructor"]
}, Zi = {}, Tp = () => !!globalThis.Zone;
function kr(s) {
  if (Zi[s])
    return Zi[s];
  const e = globalThis[s], t = e.prototype, i = s in Mn ? Mn[s] : void 0, r = !!(i && // @ts-expect-error 2345
  i.every(
    (a) => {
      var l, u;
      return !!((u = (l = Object.getOwnPropertyDescriptor(t, a)) == null ? void 0 : l.get) != null && u.toString().includes("[native code]"));
    }
  )), n = s in zn ? zn[s] : void 0, o = !!(n && n.every(
    // @ts-expect-error 2345
    (a) => {
      var l;
      return typeof t[a] == "function" && ((l = t[a]) == null ? void 0 : l.toString().includes("[native code]"));
    }
  ));
  if (r && o && !Tp())
    return Zi[s] = e.prototype, e.prototype;
  try {
    const a = document.createElement("iframe");
    document.body.appendChild(a);
    const l = a.contentWindow;
    if (!l) return e.prototype;
    const u = l[s].prototype;
    return document.body.removeChild(a), u ? Zi[s] = u : t;
  } catch (a) {
    return t;
  }
}
const bs = {};
function Oe(s, e, t) {
  var i;
  const r = `${s}.${String(t)}`;
  if (bs[r])
    return bs[r].call(
      e
    );
  const n = kr(s), o = (i = Object.getOwnPropertyDescriptor(
    n,
    t
  )) == null ? void 0 : i.get;
  return o ? (bs[r] = o, o.call(e)) : e[t];
}
const Zs = {};
function Po(s, e, t) {
  const i = `${s}.${String(t)}`;
  if (Zs[i])
    return Zs[i].bind(
      e
    );
  const n = kr(s)[t];
  return typeof n != "function" ? e[t] : (Zs[i] = n, n.bind(e));
}
function Up(s) {
  return Oe("Node", s, "childNodes");
}
function Kp(s) {
  return Oe("Node", s, "parentNode");
}
function Fp(s) {
  return Oe("Node", s, "parentElement");
}
function Mp(s) {
  return Oe("Node", s, "textContent");
}
function zp(s, e) {
  return Po("Node", s, "contains")(e);
}
function Hp(s) {
  return Po("Node", s, "getRootNode")();
}
function Op(s) {
  return !s || !("host" in s) ? null : Oe("ShadowRoot", s, "host");
}
function Pp(s) {
  return s.styleSheets;
}
function Ep(s) {
  return !s || !("shadowRoot" in s) ? null : Oe("Element", s, "shadowRoot");
}
function Bp(s, e) {
  return Oe("Element", s, "querySelector")(e);
}
function Qp(s, e) {
  return Oe("Element", s, "querySelectorAll")(e);
}
function Eo() {
  return kr("MutationObserver").constructor;
}
function qe(s, e, t) {
  try {
    if (!(e in s))
      return () => {
      };
    const i = s[e], r = t(i);
    return typeof r == "function" && (r.prototype = r.prototype || {}, Object.defineProperties(r, {
      __rrweb_original__: {
        enumerable: !1,
        value: i
      }
    })), s[e] = r, () => {
      s[e] = i;
    };
  } catch (i) {
    return () => {
    };
  }
}
const N = {
  childNodes: Up,
  parentNode: Kp,
  parentElement: Fp,
  textContent: Mp,
  contains: zp,
  getRootNode: Hp,
  host: Op,
  styleSheets: Pp,
  shadowRoot: Ep,
  querySelector: Bp,
  querySelectorAll: Qp,
  mutationObserver: Eo,
  patch: qe,
  wrapCanvasContextDrawImage: Np
};
function he(s, e, t = document) {
  const i = { capture: !0 };
  return t.addEventListener(s, e, i), () => t.removeEventListener(s, e, i);
}
const rt = `Please stop import mirror directly. Instead of that,\r
now you can use replayer.getMirror() to access the mirror instance of a replayer,\r
or you can use record.mirror to access the mirror instance during recording.`;
let Hn = {
  map: {},
  getId() {
    return console.error(rt), -1;
  },
  getNode() {
    return console.error(rt), null;
  },
  removeNodeFromMap() {
    console.error(rt);
  },
  has() {
    return console.error(rt), !1;
  },
  reset() {
    console.error(rt);
  }
};
typeof window != "undefined" && window.Proxy && window.Reflect && (Hn = new Proxy(Hn, {
  get(s, e, t) {
    return e === "map" && console.error(rt), Reflect.get(s, e, t);
  }
}));
function Ht(s, e, t = {}) {
  let i = null, r = 0;
  return function(...n) {
    const o = Date.now();
    !r && t.leading === !1 && (r = o);
    const a = e - (o - r), l = this;
    a <= 0 || a > e ? (i && (clearTimeout(i), i = null), r = o, s.apply(l, n)) : !i && t.trailing !== !1 && (i = setTimeout(() => {
      r = t.leading === !1 ? 0 : Date.now(), i = null, s.apply(l, n);
    }, a));
  };
}
function qi(s, e, t, i, r = window) {
  const n = r.Object.getOwnPropertyDescriptor(s, e);
  return r.Object.defineProperty(
    s,
    e,
    i ? t : {
      set(o) {
        setTimeout(() => {
          t.set.call(this, o);
        }, 0), n && n.set && n.set.call(this, o);
      }
    }
  ), () => qi(s, e, n || {}, !0);
}
let Fi = Date.now;
/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString()) || (Fi = () => (/* @__PURE__ */ new Date()).getTime());
function Bo(s) {
  var e, t, i, r;
  const n = s.document;
  return {
    left: n.scrollingElement ? n.scrollingElement.scrollLeft : s.pageXOffset !== void 0 ? s.pageXOffset : n.documentElement.scrollLeft || (n == null ? void 0 : n.body) && ((e = N.parentElement(n.body)) == null ? void 0 : e.scrollLeft) || ((t = n == null ? void 0 : n.body) == null ? void 0 : t.scrollLeft) || 0,
    top: n.scrollingElement ? n.scrollingElement.scrollTop : s.pageYOffset !== void 0 ? s.pageYOffset : (n == null ? void 0 : n.documentElement.scrollTop) || (n == null ? void 0 : n.body) && ((i = N.parentElement(n.body)) == null ? void 0 : i.scrollTop) || ((r = n == null ? void 0 : n.body) == null ? void 0 : r.scrollTop) || 0
  };
}
function Qo() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function Do() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function jo(s) {
  return s ? s.nodeType === s.ELEMENT_NODE ? s : N.parentElement(s) : null;
}
const Dp = (s) => {
  try {
    if (s instanceof HTMLElement)
      return s.tagName === "CANVAS";
  } catch (e) {
    return !1;
  }
  return !1;
};
function oe(s, e, t, i) {
  if (!s)
    return !1;
  const r = jo(s);
  if (!r)
    return !1;
  try {
    if (typeof e == "string") {
      if (r.classList.contains(e) || i && r.closest("." + e) !== null) return !0;
    } else if (Li(r, e, i)) return !0;
  } catch (n) {
  }
  return !!(t && (r.matches(t) || i && r.closest(t) !== null));
}
function jp(s, e) {
  return e.getId(s) !== -1;
}
function ys(s, e, t) {
  return s.tagName === "TITLE" && t.headTitleMutations ? !0 : e.getId(s) === vt;
}
function Ao(s, e) {
  if (wt(s))
    return !1;
  const t = e.getId(s);
  if (!e.has(t))
    return !0;
  const i = N.parentNode(s);
  return i && i.nodeType === s.DOCUMENT_NODE ? !1 : i ? Ao(i, e) : !0;
}
function er(s) {
  return !!s.changedTouches;
}
function Ap(s = window) {
  "NodeList" in s && !s.NodeList.prototype.forEach && (s.NodeList.prototype.forEach = Array.prototype.forEach), "DOMTokenList" in s && !s.DOMTokenList.prototype.forEach && (s.DOMTokenList.prototype.forEach = Array.prototype.forEach);
}
function _o(s, e) {
  return !!(s.nodeName === "IFRAME" && e.getMeta(s));
}
function $o(s, e) {
  return !!(s.nodeName === "LINK" && s.nodeType === s.ELEMENT_NODE && s.getAttribute && s.getAttribute("rel") === "stylesheet" && e.getMeta(s));
}
function tr(s) {
  return s ? s instanceof Lr && "shadowRoot" in s ? !!s.shadowRoot : !!N.shadowRoot(s) : !1;
}
class _p {
  constructor() {
    X(this, "id", 1), X(this, "styleIDMap", /* @__PURE__ */ new WeakMap()), X(this, "idStyleMap", /* @__PURE__ */ new Map());
  }
  getId(e) {
    var t;
    return (t = this.styleIDMap.get(e)) != null ? t : -1;
  }
  has(e) {
    return this.styleIDMap.has(e);
  }
  /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */
  add(e, t) {
    if (this.has(e)) return this.getId(e);
    let i;
    return t === void 0 ? i = this.id++ : i = t, this.styleIDMap.set(e, i), this.idStyleMap.set(i, e), i;
  }
  getStyle(e) {
    return this.idStyleMap.get(e) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap(), this.idStyleMap = /* @__PURE__ */ new Map(), this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function qo(s) {
  var e;
  let t = null;
  return "getRootNode" in s && ((e = N.getRootNode(s)) == null ? void 0 : e.nodeType) === Node.DOCUMENT_FRAGMENT_NODE && N.host(N.getRootNode(s)) && (t = N.host(N.getRootNode(s))), t;
}
function $p(s) {
  let e = s, t;
  for (; t = qo(e); )
    e = t;
  return e;
}
function qp(s) {
  const e = s.ownerDocument;
  if (!e) return !1;
  const t = $p(s);
  return N.contains(e, t);
}
function ea(s) {
  const e = s.ownerDocument;
  return e ? N.contains(e, s) || qp(s) : !1;
}
var K = /* @__PURE__ */ ((s) => (s[s.DomContentLoaded = 0] = "DomContentLoaded", s[s.Load = 1] = "Load", s[s.FullSnapshot = 2] = "FullSnapshot", s[s.IncrementalSnapshot = 3] = "IncrementalSnapshot", s[s.Meta = 4] = "Meta", s[s.Custom = 5] = "Custom", s[s.Plugin = 6] = "Plugin", s))(K || {}), T = /* @__PURE__ */ ((s) => (s[s.Mutation = 0] = "Mutation", s[s.MouseMove = 1] = "MouseMove", s[s.MouseInteraction = 2] = "MouseInteraction", s[s.Scroll = 3] = "Scroll", s[s.ViewportResize = 4] = "ViewportResize", s[s.Input = 5] = "Input", s[s.TouchMove = 6] = "TouchMove", s[s.MediaInteraction = 7] = "MediaInteraction", s[s.StyleSheetRule = 8] = "StyleSheetRule", s[s.CanvasMutation = 9] = "CanvasMutation", s[s.Font = 10] = "Font", s[s.Log = 11] = "Log", s[s.Drag = 12] = "Drag", s[s.StyleDeclaration = 13] = "StyleDeclaration", s[s.Selection = 14] = "Selection", s[s.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", s[s.CustomElement = 16] = "CustomElement", s))(T || {}), de = /* @__PURE__ */ ((s) => (s[s.MouseUp = 0] = "MouseUp", s[s.MouseDown = 1] = "MouseDown", s[s.Click = 2] = "Click", s[s.ContextMenu = 3] = "ContextMenu", s[s.DblClick = 4] = "DblClick", s[s.Focus = 5] = "Focus", s[s.Blur = 6] = "Blur", s[s.TouchStart = 7] = "TouchStart", s[s.TouchMove_Departed = 8] = "TouchMove_Departed", s[s.TouchEnd = 9] = "TouchEnd", s[s.TouchCancel = 10] = "TouchCancel", s))(de || {}), Me = /* @__PURE__ */ ((s) => (s[s.Mouse = 0] = "Mouse", s[s.Pen = 1] = "Pen", s[s.Touch = 2] = "Touch", s))(Me || {}), bt = /* @__PURE__ */ ((s) => (s[s["2D"] = 0] = "2D", s[s.WebGL = 1] = "WebGL", s[s.WebGL2 = 2] = "WebGL2", s))(bt || {}), nt = /* @__PURE__ */ ((s) => (s[s.Play = 0] = "Play", s[s.Pause = 1] = "Pause", s[s.Seeked = 2] = "Seeked", s[s.VolumeChange = 3] = "VolumeChange", s[s.RateChange = 4] = "RateChange", s))(nt || {}), ta = /* @__PURE__ */ ((s) => (s[s.Document = 0] = "Document", s[s.DocumentType = 1] = "DocumentType", s[s.Element = 2] = "Element", s[s.Text = 3] = "Text", s[s.CDATA = 4] = "CDATA", s[s.Comment = 5] = "Comment", s))(ta || {});
function On(s) {
  return "__ln" in s;
}
class em {
  constructor() {
    X(this, "length", 0), X(this, "head", null), X(this, "tail", null);
  }
  get(e) {
    if (e >= this.length)
      throw new Error("Position outside of list range");
    let t = this.head;
    for (let i = 0; i < e; i++)
      t = (t == null ? void 0 : t.next) || null;
    return t;
  }
  addNode(e) {
    const t = {
      value: e,
      previous: null,
      next: null
    };
    if (e.__ln = t, e.previousSibling && On(e.previousSibling)) {
      const i = e.previousSibling.__ln.next;
      t.next = i, t.previous = e.previousSibling.__ln, e.previousSibling.__ln.next = t, i && (i.previous = t);
    } else if (e.nextSibling && On(e.nextSibling) && e.nextSibling.__ln.previous) {
      const i = e.nextSibling.__ln.previous;
      t.previous = i, t.next = e.nextSibling.__ln, e.nextSibling.__ln.previous = t, i && (i.next = t);
    } else
      this.head && (this.head.previous = t), t.next = this.head, this.head = t;
    t.next === null && (this.tail = t), this.length++;
  }
  removeNode(e) {
    const t = e.__ln;
    this.head && (t.previous ? (t.previous.next = t.next, t.next ? t.next.previous = t.previous : this.tail = t.previous) : (this.head = t.next, this.head ? this.head.previous = null : this.tail = null), e.__ln && delete e.__ln, this.length--);
  }
}
const Pn = (s, e) => `${s}@${e}`;
class tm {
  constructor() {
    X(this, "frozen", !1), X(this, "locked", !1), X(this, "texts", []), X(this, "attributes", []), X(this, "attributeMap", /* @__PURE__ */ new WeakMap()), X(this, "removes", []), X(this, "mapRemoves", []), X(this, "movedMap", {}), X(this, "addedSet", /* @__PURE__ */ new Set()), X(this, "movedSet", /* @__PURE__ */ new Set()), X(this, "droppedSet", /* @__PURE__ */ new Set()), X(this, "removesSubTreeCache", /* @__PURE__ */ new Set()), X(this, "mutationCb"), X(this, "blockClass"), X(this, "blockSelector"), X(this, "maskTextClass"), X(this, "maskTextSelector"), X(this, "inlineStylesheet"), X(this, "maskInputOptions"), X(this, "maskTextFn"), X(this, "maskInputFn"), X(this, "keepIframeSrcFn"), X(this, "recordCanvas"), X(this, "inlineImages"), X(this, "inlineVideos"), X(this, "privacySetting"), X(this, "slimDOMOptions"), X(this, "dataURLOptions"), X(this, "doc"), X(this, "mirror"), X(this, "iframeManager"), X(this, "stylesheetManager"), X(this, "shadowDomManager"), X(this, "canvasManager"), X(this, "processedNodeManager"), X(this, "unattachedDoc"), X(this, "processMutations", (e) => {
      e.forEach(this.processMutation), this.emit();
    }), X(this, "emit", () => {
      if (this.frozen || this.locked)
        return;
      const e = [], t = /* @__PURE__ */ new Set(), i = new em(), r = (l) => {
        let u = l, c = vt;
        for (; c === vt; )
          u = u && u.nextSibling, c = u && this.mirror.getId(u);
        return c;
      }, n = (l) => {
        const u = N.parentNode(l);
        if (!u || !ea(l))
          return;
        let c = !1;
        if (l.nodeType === Node.TEXT_NODE) {
          const b = u.tagName;
          if (b === "TEXTAREA")
            return;
          b === "STYLE" && this.addedSet.has(u) && (c = !0);
        }
        const h = wt(u) ? this.mirror.getId(qo(l)) : this.mirror.getId(u), p = r(l);
        if (h === -1 || p === -1)
          return i.addNode(l);
        const d = ot(l, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskTextClass: this.maskTextClass,
          maskTextSelector: this.maskTextSelector,
          skipChild: !0,
          newlyAddedElement: !0,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          inlineVideos: this.inlineVideos,
          privacySetting: this.privacySetting,
          onSerialize: (b) => {
            _o(b, this.mirror) && this.iframeManager.addIframe(b), $o(b, this.mirror) && this.stylesheetManager.trackLinkElement(
              b
            ), tr(l) && this.shadowDomManager.addShadowRoot(N.shadowRoot(l), this.doc);
          },
          onIframeLoad: (b, m) => {
            this.iframeManager.attachIframe(b, m), this.shadowDomManager.observeAttachShadow(b);
          },
          onStylesheetLoad: (b, m) => {
            this.stylesheetManager.attachLinkElement(b, m);
          },
          cssCaptured: c
        });
        d && (e.push({
          parentId: h,
          nextId: p,
          node: d
        }), t.add(d.id));
      };
      for (; this.mapRemoves.length; )
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      for (const l of this.movedSet)
        En(this.removesSubTreeCache, l) && !this.movedSet.has(N.parentNode(l)) || n(l);
      for (const l of this.addedSet)
        !Bn(this.droppedSet, l) && !En(this.removesSubTreeCache, l) || Bn(this.movedSet, l) ? n(l) : this.droppedSet.add(l);
      let o = null;
      for (; i.length; ) {
        let l = null;
        if (o) {
          const u = this.mirror.getId(N.parentNode(o.value)), c = r(o.value);
          u !== -1 && c !== -1 && (l = o);
        }
        if (!l) {
          let u = i.tail;
          for (; u; ) {
            const c = u;
            if (u = u.previous, c) {
              const h = this.mirror.getId(N.parentNode(c.value));
              if (r(c.value) === -1) continue;
              if (h !== -1) {
                l = c;
                break;
              } else {
                const d = c.value, b = N.parentNode(d);
                if (b && b.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const m = N.host(b);
                  if (this.mirror.getId(m) !== -1) {
                    l = c;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!l) {
          for (; i.head; )
            i.removeNode(i.head.value);
          break;
        }
        o = l.previous, i.removeNode(l.value), n(l.value);
      }
      const a = {
        texts: this.texts.map((l) => {
          var u, c;
          const h = l.node, p = N.parentNode(h);
          p && p.tagName === "TEXTAREA" && this.genTextAreaValueMutation(p);
          let d = l.value;
          const b = this.privacySetting === "strict", m = this.privacySetting === "default" && Zl(d), f = (c = (u = l.node) == null ? void 0 : u.parentElement) == null ? void 0 : c.getAttribute("data-hl-record");
          return (b || m) && !f && d && (d = ar(d)), {
            id: this.mirror.getId(h),
            value: d
          };
        }).filter((l) => !t.has(l.id)).filter((l) => this.mirror.has(l.id)),
        attributes: this.attributes.map((l) => {
          const { attributes: u } = l;
          if (typeof u.style == "string") {
            const c = JSON.stringify(l.styleDiff), h = JSON.stringify(l._unchangedStyles);
            c.length < u.style.length && (c + h).split("var(").length === u.style.split("var(").length && (u.style = l.styleDiff);
          }
          return {
            id: this.mirror.getId(l.node),
            attributes: u
          };
        }).filter((l) => !t.has(l.id)).filter((l) => this.mirror.has(l.id)),
        removes: this.removes,
        adds: e
      };
      !a.texts.length && !a.attributes.length && !a.removes.length && !a.adds.length || (this.texts = [], this.attributes = [], this.attributeMap = /* @__PURE__ */ new WeakMap(), this.removes = [], this.addedSet = /* @__PURE__ */ new Set(), this.movedSet = /* @__PURE__ */ new Set(), this.droppedSet = /* @__PURE__ */ new Set(), this.removesSubTreeCache = /* @__PURE__ */ new Set(), this.movedMap = {}, this.mutationCb(a));
    }), X(this, "genTextAreaValueMutation", (e) => {
      let t = this.attributeMap.get(e);
      t || (t = {
        node: e,
        attributes: {},
        styleDiff: {},
        _unchangedStyles: {}
      }, this.attributes.push(t), this.attributeMap.set(e, t));
      const i = Array.from(
        N.childNodes(e),
        (r) => N.textContent(r) || ""
      ).join("");
      t.attributes.value = Ci({
        overwriteRecord: null,
        element: e,
        maskInputOptions: this.maskInputOptions,
        tagName: e.tagName,
        type: wi(e),
        value: i,
        maskInputFn: this.maskInputFn
      });
    }), X(this, "processMutation", (e) => {
      if (!ys(e.target, this.mirror, this.slimDOMOptions))
        switch (e.type) {
          case "characterData": {
            const t = N.textContent(e.target);
            !oe(e.target, this.blockClass, this.blockSelector, !1) && t !== e.oldValue && this.texts.push({
              value: Sl(
                e.target,
                this.maskTextClass,
                this.maskTextSelector,
                !0
                // checkAncestors
              ) && t ? this.maskTextFn ? this.maskTextFn(t, jo(e.target)) : t.replace(/[\S]/g, "*") : t,
              node: e.target
            });
            break;
          }
          case "attributes": {
            const t = e.target;
            let i = e.attributeName, r = e.target.getAttribute(i);
            if (i === "value") {
              const o = wi(t);
              r = Ci({
                element: t,
                maskInputOptions: this.maskInputOptions,
                tagName: t.tagName,
                type: o,
                value: r,
                overwriteRecord: t.getAttribute("data-hl-record"),
                maskInputFn: this.maskInputFn
              });
            }
            if (oe(e.target, this.blockClass, this.blockSelector, !1) || r === e.oldValue)
              return;
            let n = this.attributeMap.get(e.target);
            if (t.tagName === "IFRAME" && i === "src" && !this.keepIframeSrcFn(r))
              if (!t.contentDocument)
                i = "rr_src";
              else
                return;
            if (n || (n = {
              node: e.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            }, this.attributes.push(n), this.attributeMap.set(e.target, n)), i === "type" && t.tagName === "INPUT" && (e.oldValue || "").toLowerCase() === "password" && t.setAttribute("data-rr-is-password", "true"), !Gl(t.tagName, i)) {
              if (e.target.tagName === "INPUT") {
                const a = e.target;
                if (a.type === "password") {
                  n.attributes.value = "*".repeat(a.value.length);
                  break;
                }
              }
              if (n.attributes[i] = Xl(
                this.doc,
                ct(t.tagName),
                ct(i),
                r
              ), i === "style") {
                if (!this.unattachedDoc)
                  try {
                    this.unattachedDoc = document.implementation.createHTMLDocument();
                  } catch (l) {
                    this.unattachedDoc = this.doc;
                  }
                const a = this.unattachedDoc.createElement("span");
                e.oldValue && a.setAttribute("style", e.oldValue);
                for (const l of Array.from(t.style)) {
                  const u = t.style.getPropertyValue(l), c = t.style.getPropertyPriority(l);
                  u !== a.style.getPropertyValue(l) || c !== a.style.getPropertyPriority(l) ? c === "" ? n.styleDiff[l] = u : n.styleDiff[l] = [u, c] : n._unchangedStyles[l] = [u, c];
                }
                for (const l of Array.from(a.style))
                  t.style.getPropertyValue(l) === "" && (n.styleDiff[l] = !1);
              } else i === "open" && t.tagName === "DIALOG" && (t.matches("dialog:modal") ? n.attributes.rr_open_mode = "modal" : n.attributes.rr_open_mode = "non-modal");
            }
            break;
          }
          case "childList": {
            if (oe(e.target, this.blockClass, this.blockSelector, !0))
              return;
            if (e.target.tagName === "TEXTAREA") {
              this.genTextAreaValueMutation(e.target);
              return;
            }
            e.addedNodes.forEach((t) => this.genAdds(t, e.target)), e.removedNodes.forEach((t) => {
              const i = this.mirror.getId(t), r = wt(e.target) ? this.mirror.getId(N.host(e.target)) : this.mirror.getId(e.target);
              oe(e.target, this.blockClass, this.blockSelector, !1) || ys(t, this.mirror, this.slimDOMOptions) || !jp(t, this.mirror) || (this.addedSet.has(t) ? (ir(this.addedSet, t), this.droppedSet.add(t)) : this.addedSet.has(e.target) && i === -1 || Ao(e.target, this.mirror) || (this.movedSet.has(t) && this.movedMap[Pn(i, r)] ? ir(this.movedSet, t) : (this.removes.push({
                parentId: r,
                id: i,
                isShadow: wt(e.target) && xt(e.target) ? !0 : void 0
              }), im(t, this.removesSubTreeCache))), this.mapRemoves.push(t));
            });
            break;
          }
        }
    }), X(this, "genAdds", (e, t) => {
      if (!this.processedNodeManager.inOtherBuffer(e, this) && !(this.addedSet.has(e) || this.movedSet.has(e))) {
        if (this.mirror.hasNode(e)) {
          if (ys(e, this.mirror, this.slimDOMOptions))
            return;
          this.movedSet.add(e);
          let i = null;
          t && this.mirror.hasNode(t) && (i = this.mirror.getId(t)), i && i !== -1 && (this.movedMap[Pn(this.mirror.getId(e), i)] = !0);
        } else
          this.addedSet.add(e), this.droppedSet.delete(e);
        oe(e, this.blockClass, this.blockSelector, !1) || (N.childNodes(e).forEach((i) => this.genAdds(i)), tr(e) && N.childNodes(N.shadowRoot(e)).forEach((i) => {
          this.processedNodeManager.add(i, this), this.genAdds(i, e);
        }));
      }
    });
  }
  init(e) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "maskTextClass",
      "maskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "inlineVideos",
      "privacySetting",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager"
    ].forEach((t) => {
      this[t] = e[t];
    });
  }
  freeze() {
    this.frozen = !0, this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = !1, this.canvasManager.unfreeze(), this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = !0, this.canvasManager.lock();
  }
  unlock() {
    this.locked = !1, this.canvasManager.unlock(), this.emit();
  }
  reset() {
    this.shadowDomManager.reset(), this.canvasManager.reset();
  }
}
function ir(s, e) {
  s.delete(e), N.childNodes(e).forEach((t) => ir(s, t));
}
function im(s, e) {
  const t = [s];
  for (; t.length; ) {
    const i = t.pop();
    e.has(i) || (e.add(i), N.childNodes(i).forEach((r) => t.push(r)));
  }
}
function En(s, e, t) {
  return s.size === 0 ? !1 : sm(s, e);
}
function sm(s, e, t) {
  const i = N.parentNode(e);
  return i ? s.has(i) : !1;
}
function Bn(s, e) {
  return s.size === 0 ? !1 : ia(s, e);
}
function ia(s, e) {
  const t = N.parentNode(e);
  return t ? s.has(t) ? !0 : ia(s, t) : !1;
}
let Lt;
function rm(s) {
  Lt = s;
}
function nm() {
  Lt = void 0;
}
const U = (s) => Lt ? (...t) => {
  try {
    return s(...t);
  } catch (i) {
    if (Lt && Lt(i) === !0)
      return;
    throw i;
  }
} : s, De = [];
function Dt(s) {
  try {
    if ("composedPath" in s) {
      const e = s.composedPath();
      if (e.length)
        return e[0];
    } else if ("path" in s && s.path.length)
      return s.path[0];
  } catch (e) {
  }
  return s && s.target;
}
function sa(s, e) {
  const t = new tm();
  De.push(t), t.init(s);
  const i = new (Eo())(
    U(t.processMutations.bind(t))
  );
  return i.observe(e, {
    attributes: !0,
    attributeOldValue: !0,
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
  }), i;
}
function lm({
  mousemoveCb: s,
  sampling: e,
  doc: t,
  mirror: i
}) {
  if (e.mousemove === !1)
    return () => {
    };
  const r = typeof e.mousemove == "number" ? e.mousemove : 50, n = typeof e.mousemoveCallback == "number" ? e.mousemoveCallback : 500;
  let o = [], a;
  const l = Ht(
    U(
      (h) => {
        const p = Date.now() - a;
        s(
          o.map((d) => (d.timeOffset -= p, d)),
          h
        ), o = [], a = null;
      }
    ),
    n
  ), u = U(
    Ht(
      U((h) => {
        const p = Dt(h), { clientX: d, clientY: b } = er(h) ? h.changedTouches[0] : h;
        a || (a = Fi()), o.push({
          x: d,
          y: b,
          id: i.getId(p),
          timeOffset: Fi() - a
        }), l(
          typeof DragEvent != "undefined" && h instanceof DragEvent ? T.Drag : h instanceof MouseEvent ? T.MouseMove : T.TouchMove
        );
      }),
      r,
      {
        trailing: !1
      }
    )
  ), c = [
    he("mousemove", u, t),
    he("touchmove", u, t),
    he("drag", u, t)
  ];
  return U(() => {
    c.forEach((h) => h());
  });
}
function om({
  mouseInteractionCb: s,
  doc: e,
  mirror: t,
  blockClass: i,
  blockSelector: r,
  sampling: n
}) {
  if (n.mouseInteraction === !1)
    return () => {
    };
  const o = n.mouseInteraction === !0 || n.mouseInteraction === void 0 ? {} : n.mouseInteraction, a = [];
  let l = null;
  const u = (c) => (h) => {
    const p = Dt(h);
    if (oe(p, i, r, !0) || // We ignore canvas elements for rage click detection because we cannot infer what inside the canvas is getting interacted with.
    Dp(p))
      return;
    let d = null, b = c;
    if ("pointerType" in h) {
      switch (h.pointerType) {
        case "mouse":
          d = Me.Mouse;
          break;
        case "touch":
          d = Me.Touch;
          break;
        case "pen":
          d = Me.Pen;
          break;
      }
      d === Me.Touch && (de[c] === de.MouseDown ? b = "TouchStart" : de[c] === de.MouseUp && (b = "TouchEnd"));
    } else er(h) && (d = Me.Touch);
    d !== null ? (l = d, (b.startsWith("Touch") && d === Me.Touch || b.startsWith("Mouse") && d === Me.Mouse) && (d = null)) : de[c] === de.Click && (d = l, l = null);
    const m = er(h) ? h.changedTouches[0] : h;
    if (!m)
      return;
    const f = t.getId(p), { clientX: V, clientY: G } = m;
    U(s)(x({
      type: de[b],
      id: f,
      x: V,
      y: G
    }, d !== null && { pointerType: d }));
  };
  return Object.keys(de).filter(
    (c) => Number.isNaN(Number(c)) && !c.endsWith("_Departed") && o[c] !== !1
  ).forEach((c) => {
    let h = ct(c);
    const p = u(c);
    if (window.PointerEvent)
      switch (de[c]) {
        case de.MouseDown:
        case de.MouseUp:
          h = h.replace(
            "mouse",
            "pointer"
          );
          break;
        case de.TouchStart:
        case de.TouchEnd:
          return;
      }
    a.push(he(h, p, e));
  }), U(() => {
    a.forEach((c) => c());
  });
}
function ra({
  scrollCb: s,
  doc: e,
  mirror: t,
  blockClass: i,
  blockSelector: r,
  sampling: n
}) {
  const o = U(
    Ht(
      U((a) => {
        const l = Dt(a);
        if (!l || oe(l, i, r, !0))
          return;
        const u = t.getId(l);
        if (l === e && e.defaultView) {
          const c = Bo(e.defaultView);
          s({
            id: u,
            x: c.left,
            y: c.top
          });
        } else
          s({
            id: u,
            x: l.scrollLeft,
            y: l.scrollTop
          });
      }),
      n.scroll || 100
    )
  );
  return he("scroll", o, e);
}
function am({ viewportResizeCb: s }, { win: e }) {
  let t = -1, i = -1;
  const r = U(
    Ht(
      U(() => {
        const n = Qo(), o = Do();
        (t !== n || i !== o) && (s({
          width: Number(o),
          height: Number(n)
        }), t = n, i = o);
      }),
      200
    )
  );
  return he("resize", r, e);
}
const cm = ["INPUT", "TEXTAREA", "SELECT"], Qn = /* @__PURE__ */ new WeakMap();
function um({
  inputCb: s,
  doc: e,
  mirror: t,
  blockClass: i,
  blockSelector: r,
  ignoreClass: n,
  ignoreSelector: o,
  maskInputOptions: a,
  maskInputFn: l,
  sampling: u,
  userTriggeredOnInput: c
}) {
  function h(G) {
    let g = Dt(G);
    const S = G.isTrusted, y = g && g.tagName;
    if (g && y === "OPTION" && (g = N.parentElement(g)), !g || !y || cm.indexOf(y) < 0 || oe(g, i, r, !0) || g.classList.contains(n) || o && g.matches(o))
      return;
    let W = g.value, C = !1;
    const R = wi(g) || "", Z = g.getAttribute("data-hl-record");
    R === "radio" || R === "checkbox" ? C = g.checked : yl({
      maskInputOptions: a,
      type: R,
      tagName: y,
      overwriteRecord: Z
    }) && (W = Ci({
      element: g,
      maskInputOptions: a,
      tagName: y,
      type: R,
      value: W,
      overwriteRecord: Z,
      maskInputFn: l
    })), p(
      g,
      c ? { text: W, isChecked: C, userTriggered: S } : { text: W, isChecked: C }
    );
    const I = g.name;
    R === "radio" && I && C && e.querySelectorAll(`input[type="radio"][name="${I}"]`).forEach((Y) => {
      if (Y !== g) {
        const v = Y.value;
        p(
          Y,
          c ? { text: v, isChecked: !C, userTriggered: !1 } : { text: v, isChecked: !C }
        );
      }
    });
  }
  function p(G, g) {
    const S = Qn.get(G);
    if (!S || S.text !== g.text || S.isChecked !== g.isChecked) {
      Qn.set(G, g);
      const y = t.getId(G);
      U(s)(re(x({}, g), {
        id: y
      }));
    }
  }
  const b = (u.input === "last" ? ["change"] : ["input", "change"]).map(
    (G) => he(G, U(h), e)
  ), m = e.defaultView;
  if (!m)
    return () => {
      b.forEach((G) => G());
    };
  const f = m.Object.getOwnPropertyDescriptor(
    m.HTMLInputElement.prototype,
    "value"
  ), V = [
    [m.HTMLInputElement.prototype, "value"],
    [m.HTMLInputElement.prototype, "checked"],
    [m.HTMLSelectElement.prototype, "value"],
    [m.HTMLTextAreaElement.prototype, "value"],
    // Some UI library use selectedIndex to set select value
    [m.HTMLSelectElement.prototype, "selectedIndex"],
    [m.HTMLOptionElement.prototype, "selected"]
  ];
  return f && f.set && b.push(
    ...V.map(
      (G) => qi(
        G[0],
        G[1],
        {
          set() {
            U(h)({
              target: this,
              isTrusted: !1
              // userTriggered to false as this could well be programmatic
            });
          }
        },
        !1,
        m
      )
    )
  ), U(() => {
    b.forEach((G) => G());
  });
}
function Mi(s) {
  const e = [];
  function t(i, r) {
    if (yi("CSSGroupingRule") && i.parentRule instanceof CSSGroupingRule || yi("CSSMediaRule") && i.parentRule instanceof CSSMediaRule || yi("CSSSupportsRule") && i.parentRule instanceof CSSSupportsRule || yi("CSSConditionRule") && i.parentRule instanceof CSSConditionRule) {
      const o = Array.from(
        i.parentRule.cssRules
      ).indexOf(i);
      r.unshift(o);
    } else if (i.parentStyleSheet) {
      const o = Array.from(i.parentStyleSheet.cssRules).indexOf(i);
      r.unshift(o);
    }
    return r;
  }
  return t(s, e);
}
function ze(s, e, t) {
  let i, r;
  return s ? (s.ownerNode ? i = e.getId(s.ownerNode) : r = t.getId(s), {
    styleId: r,
    id: i
  }) : {};
}
function hm({ styleSheetRuleCb: s, mirror: e, stylesheetManager: t }, { win: i }) {
  if (!i.CSSStyleSheet || !i.CSSStyleSheet.prototype)
    return () => {
    };
  const r = i.CSSStyleSheet.prototype.insertRule;
  i.CSSStyleSheet.prototype.insertRule = new Proxy(r, {
    apply: U(
      (c, h, p) => {
        const [d, b] = p, { id: m, styleId: f } = ze(
          h,
          e,
          t.styleMirror
        );
        return (m && m !== -1 || f && f !== -1) && s({
          id: m,
          styleId: f,
          adds: [{ rule: d, index: b }]
        }), c.apply(h, p);
      }
    )
  }), i.CSSStyleSheet.prototype.addRule = function(c, h, p = this.cssRules.length) {
    const d = `${c} { ${h} }`;
    return i.CSSStyleSheet.prototype.insertRule.apply(this, [d, p]);
  };
  const n = i.CSSStyleSheet.prototype.deleteRule;
  i.CSSStyleSheet.prototype.deleteRule = new Proxy(n, {
    apply: U(
      (c, h, p) => {
        const [d] = p, { id: b, styleId: m } = ze(
          h,
          e,
          t.styleMirror
        );
        return (b && b !== -1 || m && m !== -1) && s({
          id: b,
          styleId: m,
          removes: [{ index: d }]
        }), c.apply(h, p);
      }
    )
  }), i.CSSStyleSheet.prototype.removeRule = function(c) {
    return i.CSSStyleSheet.prototype.deleteRule.apply(this, [c]);
  };
  let o;
  i.CSSStyleSheet.prototype.replace && (o = i.CSSStyleSheet.prototype.replace, i.CSSStyleSheet.prototype.replace = new Proxy(o, {
    apply: U(
      (c, h, p) => {
        const [d] = p, { id: b, styleId: m } = ze(
          h,
          e,
          t.styleMirror
        );
        return (b && b !== -1 || m && m !== -1) && s({
          id: b,
          styleId: m,
          replace: d
        }), c.apply(h, p);
      }
    )
  }));
  let a;
  i.CSSStyleSheet.prototype.replaceSync && (a = i.CSSStyleSheet.prototype.replaceSync, i.CSSStyleSheet.prototype.replaceSync = new Proxy(a, {
    apply: U(
      (c, h, p) => {
        const [d] = p, { id: b, styleId: m } = ze(
          h,
          e,
          t.styleMirror
        );
        return (b && b !== -1 || m && m !== -1) && s({
          id: b,
          styleId: m,
          replaceSync: d
        }), c.apply(h, p);
      }
    )
  }));
  const l = {};
  gi("CSSGroupingRule") ? l.CSSGroupingRule = i.CSSGroupingRule : (gi("CSSMediaRule") && (l.CSSMediaRule = i.CSSMediaRule), gi("CSSConditionRule") && (l.CSSConditionRule = i.CSSConditionRule), gi("CSSSupportsRule") && (l.CSSSupportsRule = i.CSSSupportsRule));
  const u = {};
  return Object.entries(l).forEach(([c, h]) => {
    u[c] = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      insertRule: h.prototype.insertRule,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      deleteRule: h.prototype.deleteRule
    }, h.prototype.insertRule = new Proxy(
      u[c].insertRule,
      {
        apply: U(
          (p, d, b) => {
            const [m, f] = b, { id: V, styleId: G } = ze(
              d.parentStyleSheet,
              e,
              t.styleMirror
            );
            return (V && V !== -1 || G && G !== -1) && s({
              id: V,
              styleId: G,
              adds: [
                {
                  rule: m,
                  index: [
                    ...Mi(d),
                    f || 0
                    // defaults to 0
                  ]
                }
              ]
            }), p.apply(d, b);
          }
        )
      }
    ), h.prototype.deleteRule = new Proxy(
      u[c].deleteRule,
      {
        apply: U(
          (p, d, b) => {
            const [m] = b, { id: f, styleId: V } = ze(
              d.parentStyleSheet,
              e,
              t.styleMirror
            );
            return (f && f !== -1 || V && V !== -1) && s({
              id: f,
              styleId: V,
              removes: [
                { index: [...Mi(d), m] }
              ]
            }), p.apply(d, b);
          }
        )
      }
    );
  }), U(() => {
    i.CSSStyleSheet.prototype.insertRule = r, i.CSSStyleSheet.prototype.deleteRule = n, o && (i.CSSStyleSheet.prototype.replace = o), a && (i.CSSStyleSheet.prototype.replaceSync = a), Object.entries(l).forEach(([c, h]) => {
      h.prototype.insertRule = u[c].insertRule, h.prototype.deleteRule = u[c].deleteRule;
    });
  });
}
function na({
  mirror: s,
  stylesheetManager: e
}, t) {
  var i, r, n;
  let o = null;
  t.nodeName === "#document" ? o = s.getId(t) : o = s.getId(N.host(t));
  const a = t.nodeName === "#document" ? (i = t.defaultView) == null ? void 0 : i.Document : (n = (r = t.ownerDocument) == null ? void 0 : r.defaultView) == null ? void 0 : n.ShadowRoot, l = a != null && a.prototype ? Object.getOwnPropertyDescriptor(
    a == null ? void 0 : a.prototype,
    "adoptedStyleSheets"
  ) : void 0;
  return o === null || o === -1 || !a || !l ? () => {
  } : (Object.defineProperty(t, "adoptedStyleSheets", {
    configurable: l.configurable,
    enumerable: l.enumerable,
    get() {
      var u;
      return (u = l.get) == null ? void 0 : u.call(this);
    },
    set(u) {
      var c;
      const h = (c = l.set) == null ? void 0 : c.call(this, u);
      if (o !== null && o !== -1)
        try {
          e.adoptStyleSheets(u, o);
        } catch (p) {
        }
      return h;
    }
  }), U(() => {
    Object.defineProperty(t, "adoptedStyleSheets", {
      configurable: l.configurable,
      enumerable: l.enumerable,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      get: l.get,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      set: l.set
    });
  }));
}
function dm({
  styleDeclarationCb: s,
  mirror: e,
  ignoreCSSAttributes: t,
  stylesheetManager: i
}, { win: r }) {
  const n = r.CSSStyleDeclaration.prototype.setProperty;
  r.CSSStyleDeclaration.prototype.setProperty = new Proxy(n, {
    apply: U(
      (a, l, u) => {
        var c;
        const [h, p, d] = u;
        if (t.has(h))
          return n.apply(l, [h, p, d]);
        const { id: b, styleId: m } = ze(
          (c = l.parentRule) == null ? void 0 : c.parentStyleSheet,
          e,
          i.styleMirror
        );
        return (b && b !== -1 || m && m !== -1) && s({
          id: b,
          styleId: m,
          set: {
            property: h,
            value: p,
            priority: d
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: Mi(l.parentRule)
        }), a.apply(l, u);
      }
    )
  });
  const o = r.CSSStyleDeclaration.prototype.removeProperty;
  return r.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
    apply: U(
      (a, l, u) => {
        var c;
        const [h] = u;
        if (t.has(h))
          return o.apply(l, [h]);
        const { id: p, styleId: d } = ze(
          (c = l.parentRule) == null ? void 0 : c.parentStyleSheet,
          e,
          i.styleMirror
        );
        return (p && p !== -1 || d && d !== -1) && s({
          id: p,
          styleId: d,
          remove: {
            property: h
          },
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          index: Mi(l.parentRule)
        }), a.apply(l, u);
      }
    )
  }), U(() => {
    r.CSSStyleDeclaration.prototype.setProperty = n, r.CSSStyleDeclaration.prototype.removeProperty = o;
  });
}
function pm({
  mediaInteractionCb: s,
  blockClass: e,
  blockSelector: t,
  mirror: i,
  sampling: r,
  doc: n
}) {
  const o = U(
    (l) => Ht(
      U((u) => {
        const c = Dt(u);
        if (!c || oe(c, e, t, !0))
          return;
        const { currentTime: h, volume: p, muted: d, playbackRate: b, loop: m } = c;
        s({
          type: l,
          id: i.getId(c),
          currentTime: h,
          volume: p,
          muted: d,
          playbackRate: b,
          loop: m
        });
      }),
      r.media || 500
    )
  ), a = [
    he("play", o(nt.Play), n),
    he("pause", o(nt.Pause), n),
    he("seeked", o(nt.Seeked), n),
    he("volumechange", o(nt.VolumeChange), n),
    he("ratechange", o(nt.RateChange), n)
  ];
  return U(() => {
    a.forEach((l) => l());
  });
}
function mm({ fontCb: s, doc: e }) {
  const t = e.defaultView;
  if (!t)
    return () => {
    };
  const i = [], r = /* @__PURE__ */ new WeakMap(), n = t.FontFace;
  t.FontFace = function(l, u, c) {
    const h = new n(
      l,
      u,
      c
    );
    return r.set(h, {
      family: l,
      buffer: typeof u != "string",
      descriptors: c,
      fontSource: typeof u == "string" ? u : JSON.stringify(Array.from(new Uint8Array(u)))
    }), h;
  };
  const o = qe(
    e.fonts,
    "add",
    function(a) {
      return function(l) {
        return setTimeout(
          U(() => {
            const u = r.get(l);
            u && (s(u), r.delete(l));
          }),
          0
        ), a.apply(this, [l]);
      };
    }
  );
  return i.push(() => {
    t.FontFace = n;
  }), i.push(o), U(() => {
    i.forEach((a) => a());
  });
}
function fm(s) {
  const { doc: e, mirror: t, blockClass: i, blockSelector: r, selectionCb: n } = s;
  let o = !0;
  const a = U(() => {
    const l = e.getSelection();
    if (!l || o && (l != null && l.isCollapsed)) return;
    o = l.isCollapsed || !1;
    const u = [], c = l.rangeCount || 0;
    for (let h = 0; h < c; h++) {
      const p = l.getRangeAt(h), { startContainer: d, startOffset: b, endContainer: m, endOffset: f } = p;
      oe(d, i, r, !0) || oe(m, i, r, !0) || u.push({
        start: t.getId(d),
        startOffset: b,
        end: t.getId(m),
        endOffset: f
      });
    }
    n({ ranges: u });
  });
  return a(), he("selectionchange", a);
}
function bm({
  doc: s,
  customElementCb: e
}) {
  const t = s.defaultView;
  return !t || !t.customElements ? () => {
  } : qe(
    t.customElements,
    "define",
    function(r) {
      return function(n, o, a) {
        try {
          e({
            define: {
              name: n
            }
          });
        } catch (l) {
          console.warn(`Custom element callback failed for ${n}`);
        }
        return r.apply(this, [n, o, a]);
      };
    }
  );
}
function Zm(s, e) {
  const {
    mutationCb: t,
    mousemoveCb: i,
    mouseInteractionCb: r,
    scrollCb: n,
    viewportResizeCb: o,
    inputCb: a,
    mediaInteractionCb: l,
    styleSheetRuleCb: u,
    styleDeclarationCb: c,
    canvasMutationCb: h,
    fontCb: p,
    selectionCb: d,
    customElementCb: b
  } = s;
  s.mutationCb = (...m) => {
    e.mutation && e.mutation(...m), t(...m);
  }, s.mousemoveCb = (...m) => {
    e.mousemove && e.mousemove(...m), i(...m);
  }, s.mouseInteractionCb = (...m) => {
    e.mouseInteraction && e.mouseInteraction(...m), r(...m);
  }, s.scrollCb = (...m) => {
    e.scroll && e.scroll(...m), n(...m);
  }, s.viewportResizeCb = (...m) => {
    e.viewportResize && e.viewportResize(...m), o(...m);
  }, s.inputCb = (...m) => {
    e.input && e.input(...m), a(...m);
  }, s.mediaInteractionCb = (...m) => {
    e.mediaInteaction && e.mediaInteaction(...m), l(...m);
  }, s.styleSheetRuleCb = (...m) => {
    e.styleSheetRule && e.styleSheetRule(...m), u(...m);
  }, s.styleDeclarationCb = (...m) => {
    e.styleDeclaration && e.styleDeclaration(...m), c(...m);
  }, s.canvasMutationCb = (...m) => {
    e.canvasMutation && e.canvasMutation(...m), h(...m);
  }, s.fontCb = (...m) => {
    e.font && e.font(...m), p(...m);
  }, s.selectionCb = (...m) => {
    e.selection && e.selection(...m), d(...m);
  }, s.customElementCb = (...m) => {
    e.customElement && e.customElement(...m), b(...m);
  };
}
function ym(s, e = {}) {
  const t = s.doc.defaultView;
  if (!t)
    return () => {
    };
  Zm(s, e);
  let i;
  s.recordDOM && (i = sa(s, s.doc));
  const r = lm(s), n = om(s), o = ra(s), a = am(s, {
    win: t
  }), l = um(s), u = pm(s);
  let c = () => {
  }, h = () => {
  }, p = () => {
  }, d = () => {
  };
  s.recordDOM && (c = hm(s, { win: t }), h = na(s, s.doc), p = dm(s, {
    win: t
  }), s.collectFonts && (d = mm(s)));
  const b = fm(s), m = bm(s), f = [];
  for (const V of s.plugins)
    f.push(
      V.observer(V.callback, t, V.options)
    );
  return U(() => {
    De.forEach((V) => V.reset()), i == null || i.disconnect(), r(), n(), o(), a(), l(), u(), c(), h(), p(), d(), b(), m(), f.forEach((V) => V());
  });
}
function yi(s) {
  return typeof window[s] != "undefined";
}
function gi(s) {
  return !!(typeof window[s] != "undefined" && // Note: Generally, this check _shouldn't_ be necessary
  // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
  window[s].prototype && "insertRule" in window[s].prototype && "deleteRule" in window[s].prototype);
}
class Dn {
  constructor(e) {
    X(this, "iframeIdToRemoteIdMap", /* @__PURE__ */ new WeakMap()), X(this, "iframeRemoteIdToIdMap", /* @__PURE__ */ new WeakMap()), this.generateIdFn = e;
  }
  getId(e, t, i, r) {
    const n = i || this.getIdToRemoteIdMap(e), o = r || this.getRemoteIdToIdMap(e);
    let a = n.get(t);
    return a || (a = this.generateIdFn(), n.set(t, a), o.set(a, t)), a;
  }
  getIds(e, t) {
    const i = this.getIdToRemoteIdMap(e), r = this.getRemoteIdToIdMap(e);
    return t.map(
      (n) => this.getId(e, n, i, r)
    );
  }
  getRemoteId(e, t, i) {
    const r = i || this.getRemoteIdToIdMap(e);
    if (typeof t != "number") return t;
    const n = r.get(t);
    return n || -1;
  }
  getRemoteIds(e, t) {
    const i = this.getRemoteIdToIdMap(e);
    return t.map((r) => this.getRemoteId(e, r, i));
  }
  reset(e) {
    if (!e) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap(), this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(e), this.iframeRemoteIdToIdMap.delete(e);
  }
  getIdToRemoteIdMap(e) {
    let t = this.iframeIdToRemoteIdMap.get(e);
    return t || (t = /* @__PURE__ */ new Map(), this.iframeIdToRemoteIdMap.set(e, t)), t;
  }
  getRemoteIdToIdMap(e) {
    let t = this.iframeRemoteIdToIdMap.get(e);
    return t || (t = /* @__PURE__ */ new Map(), this.iframeRemoteIdToIdMap.set(e, t)), t;
  }
}
class gm {
  constructor(e) {
    X(this, "iframes", /* @__PURE__ */ new WeakMap()), X(this, "crossOriginIframeMap", /* @__PURE__ */ new WeakMap()), X(this, "crossOriginIframeMirror", new Dn(gl)), X(this, "crossOriginIframeStyleMirror"), X(this, "crossOriginIframeRootIdMap", /* @__PURE__ */ new WeakMap()), X(this, "mirror"), X(this, "mutationCb"), X(this, "wrappedEmit"), X(this, "loadListener"), X(this, "stylesheetManager"), X(this, "recordCrossOriginIframes"), this.mutationCb = e.mutationCb, this.wrappedEmit = e.wrappedEmit, this.stylesheetManager = e.stylesheetManager, this.recordCrossOriginIframes = e.recordCrossOriginIframes, this.crossOriginIframeStyleMirror = new Dn(
      this.stylesheetManager.styleMirror.generateId.bind(
        this.stylesheetManager.styleMirror
      )
    ), this.mirror = e.mirror, this.recordCrossOriginIframes && window.addEventListener("message", this.handleMessage.bind(this));
  }
  addIframe(e) {
    this.iframes.set(e, !0), e.contentWindow && this.crossOriginIframeMap.set(e.contentWindow, e);
  }
  addLoadListener(e) {
    this.loadListener = e;
  }
  attachIframe(e, t) {
    var i, r;
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(e),
          nextId: null,
          node: t
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: !0
    }), this.recordCrossOriginIframes && ((i = e.contentWindow) == null || i.addEventListener(
      "message",
      this.handleMessage.bind(this)
    )), (r = this.loadListener) == null || r.call(this, e), e.contentDocument && e.contentDocument.adoptedStyleSheets && e.contentDocument.adoptedStyleSheets.length > 0 && this.stylesheetManager.adoptStyleSheets(
      e.contentDocument.adoptedStyleSheets,
      this.mirror.getId(e.contentDocument)
    );
  }
  handleMessage(e) {
    const t = e;
    if (t.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
    t.origin !== t.data.origin)
      return;
    const i = e.source;
    if (!i) return;
    const r = this.crossOriginIframeMap.get(i);
    if (!r) return;
    const n = this.transformCrossOriginEvent(
      r,
      t.data.event
    );
    n && this.wrappedEmit(
      n,
      t.data.isCheckout
    );
  }
  transformCrossOriginEvent(e, t) {
    var i;
    switch (t.type) {
      case K.FullSnapshot: {
        this.crossOriginIframeMirror.reset(e), this.crossOriginIframeStyleMirror.reset(e), this.replaceIdOnNode(t.data.node, e);
        const r = t.data.node.id;
        return this.crossOriginIframeRootIdMap.set(e, r), this.patchRootIdOnNode(t.data.node, r), {
          timestamp: t.timestamp,
          type: K.IncrementalSnapshot,
          data: {
            source: T.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(e),
                nextId: null,
                node: t.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: !0
          }
        };
      }
      case K.Meta:
      case K.Load:
      case K.DomContentLoaded:
        return !1;
      case K.Plugin:
        return t;
      case K.Custom:
        return this.replaceIds(
          t.data.payload,
          e,
          ["id", "parentId", "previousId", "nextId"]
        ), t;
      case K.IncrementalSnapshot:
        switch (t.data.source) {
          case T.Mutation:
            return t.data.adds.forEach((r) => {
              this.replaceIds(r, e, [
                "parentId",
                "nextId",
                "previousId"
              ]), this.replaceIdOnNode(r.node, e);
              const n = this.crossOriginIframeRootIdMap.get(e);
              n && this.patchRootIdOnNode(r.node, n);
            }), t.data.removes.forEach((r) => {
              this.replaceIds(r, e, ["parentId", "id"]);
            }), t.data.attributes.forEach((r) => {
              this.replaceIds(r, e, ["id"]);
            }), t.data.texts.forEach((r) => {
              this.replaceIds(r, e, ["id"]);
            }), t;
          case T.Drag:
          case T.TouchMove:
          case T.MouseMove:
            return t.data.positions.forEach((r) => {
              this.replaceIds(r, e, ["id"]);
            }), t;
          case T.ViewportResize:
            return !1;
          case T.MediaInteraction:
          case T.MouseInteraction:
          case T.Scroll:
          case T.CanvasMutation:
          case T.Input:
            return this.replaceIds(t.data, e, ["id"]), t;
          case T.StyleSheetRule:
          case T.StyleDeclaration:
            return this.replaceIds(t.data, e, ["id"]), this.replaceStyleIds(t.data, e, ["styleId"]), t;
          case T.Font:
            return t;
          case T.Selection:
            return t.data.ranges.forEach((r) => {
              this.replaceIds(r, e, ["start", "end"]);
            }), t;
          case T.AdoptedStyleSheet:
            return this.replaceIds(t.data, e, ["id"]), this.replaceStyleIds(t.data, e, ["styleIds"]), (i = t.data.styles) == null || i.forEach((r) => {
              this.replaceStyleIds(r, e, ["styleId"]);
            }), t;
        }
    }
    return !1;
  }
  replace(e, t, i, r) {
    for (const n of r)
      !Array.isArray(t[n]) && typeof t[n] != "number" || (Array.isArray(t[n]) ? t[n] = e.getIds(
        i,
        t[n]
      ) : t[n] = e.getId(i, t[n]));
    return t;
  }
  replaceIds(e, t, i) {
    return this.replace(this.crossOriginIframeMirror, e, t, i);
  }
  replaceStyleIds(e, t, i) {
    return this.replace(this.crossOriginIframeStyleMirror, e, t, i);
  }
  replaceIdOnNode(e, t) {
    this.replaceIds(e, t, ["id", "rootId"]), "childNodes" in e && e.childNodes.forEach((i) => {
      this.replaceIdOnNode(i, t);
    });
  }
  patchRootIdOnNode(e, t) {
    e.type !== ta.Document && !e.rootId && (e.rootId = t), "childNodes" in e && e.childNodes.forEach((i) => {
      this.patchRootIdOnNode(i, t);
    });
  }
}
class Xm {
  constructor(e) {
    X(this, "shadowDoms", /* @__PURE__ */ new WeakSet()), X(this, "mutationCb"), X(this, "scrollCb"), X(this, "bypassOptions"), X(this, "mirror"), X(this, "restoreHandlers", []), this.mutationCb = e.mutationCb, this.scrollCb = e.scrollCb, this.bypassOptions = e.bypassOptions, this.mirror = e.mirror, this.init();
  }
  init() {
    this.reset(), this.patchAttachShadow(Element, document);
  }
  addShadowRoot(e, t) {
    if (!xt(e) || this.shadowDoms.has(e)) return;
    this.shadowDoms.add(e);
    const i = sa(
      re(x({}, this.bypassOptions), {
        doc: t,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      }),
      e
    );
    this.restoreHandlers.push(() => i.disconnect()), this.restoreHandlers.push(
      ra(re(x({}, this.bypassOptions), {
        scrollCb: this.scrollCb,
        // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
        // scroll is not allowed to pass the boundary, so we need to listen the shadow document
        doc: e,
        mirror: this.mirror
      }))
    ), setTimeout(() => {
      e.adoptedStyleSheets && e.adoptedStyleSheets.length > 0 && this.bypassOptions.stylesheetManager.adoptStyleSheets(
        e.adoptedStyleSheets,
        this.mirror.getId(N.host(e))
      ), this.restoreHandlers.push(
        na(
          {
            mirror: this.mirror,
            stylesheetManager: this.bypassOptions.stylesheetManager
          },
          e
        )
      );
    }, 0);
  }
  /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */
  observeAttachShadow(e) {
    !e.contentWindow || !e.contentDocument || this.patchAttachShadow(
      e.contentWindow.Element,
      e.contentDocument
    );
  }
  /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */
  patchAttachShadow(e, t) {
    const i = this;
    this.restoreHandlers.push(
      qe(
        e.prototype,
        "attachShadow",
        function(r) {
          return function(n) {
            const o = r.call(this, n), a = N.shadowRoot(this);
            return a && ea(this) && i.addShadowRoot(a, t), o;
          };
        }
      )
    );
  }
  reset() {
    this.restoreHandlers.forEach((e) => {
      try {
        e();
      } catch (t) {
      }
    }), this.restoreHandlers = [], this.shadowDoms = /* @__PURE__ */ new WeakSet();
  }
}
var at = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Gm = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256);
for (var Xi = 0; Xi < at.length; Xi++)
  Gm[at.charCodeAt(Xi)] = Xi;
var Sm = function(s) {
  var e = new Uint8Array(s), t, i = e.length, r = "";
  for (t = 0; t < i; t += 3)
    r += at[e[t] >> 2], r += at[(e[t] & 3) << 4 | e[t + 1] >> 4], r += at[(e[t + 1] & 15) << 2 | e[t + 2] >> 6], r += at[e[t + 2] & 63];
  return i % 3 === 2 ? r = r.substring(0, r.length - 1) + "=" : i % 3 === 1 && (r = r.substring(0, r.length - 2) + "=="), r;
};
const jn = /* @__PURE__ */ new Map();
function Im(s, e) {
  let t = jn.get(s);
  return t || (t = /* @__PURE__ */ new Map(), jn.set(s, t)), t.has(e) || t.set(e, []), t.get(e);
}
const la = (s, e, t) => {
  if (!s || !(aa(s, e) || typeof s == "object"))
    return;
  const i = s.constructor.name, r = Im(t, i);
  let n = r.indexOf(s);
  return n === -1 && (n = r.length, r.push(s)), n;
};
function Ri(s, e, t) {
  if (s instanceof Array)
    return s.map((i) => Ri(i, e, t));
  if (s === null)
    return s;
  if (s instanceof Float32Array || s instanceof Float64Array || s instanceof Int32Array || s instanceof Uint32Array || s instanceof Uint8Array || s instanceof Uint16Array || s instanceof Int16Array || s instanceof Int8Array || s instanceof Uint8ClampedArray)
    return {
      rr_type: s.constructor.name,
      args: [Object.values(s)]
    };
  if (
    // SharedArrayBuffer disabled on most browsers due to spectre.
    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/SharedArrayBuffer/SharedArrayBuffer
    // value instanceof SharedArrayBuffer ||
    s instanceof ArrayBuffer
  ) {
    const i = s.constructor.name, r = Sm(s);
    return {
      rr_type: i,
      base64: r
    };
  } else {
    if (s instanceof DataView)
      return {
        rr_type: s.constructor.name,
        args: [
          Ri(s.buffer, e, t),
          s.byteOffset,
          s.byteLength
        ]
      };
    if (s instanceof HTMLImageElement) {
      const i = s.constructor.name, { src: r } = s;
      return {
        rr_type: i,
        src: r
      };
    } else if (s instanceof HTMLCanvasElement) {
      const i = "HTMLImageElement", r = s.toDataURL();
      return {
        rr_type: i,
        src: r
      };
    } else {
      if (s instanceof ImageData)
        return {
          rr_type: s.constructor.name,
          args: [Ri(s.data, e, t), s.width, s.height]
        };
      if (aa(s, e) || typeof s == "object") {
        const i = s.constructor.name, r = la(s, e, t);
        return {
          rr_type: i,
          index: r
        };
      }
    }
  }
  return s;
}
const oa = (s, e, t) => s.map((i) => Ri(i, e, t)), aa = (s, e) => !![
  "WebGLActiveInfo",
  "WebGLBuffer",
  "WebGLFramebuffer",
  "WebGLProgram",
  "WebGLRenderbuffer",
  "WebGLShader",
  "WebGLShaderPrecisionFormat",
  "WebGLTexture",
  "WebGLUniformLocation",
  "WebGLVertexArrayObject",
  // In old Chrome versions, value won't be an instanceof WebGLVertexArrayObject.
  "WebGLVertexArrayObjectOES"
].filter(
  (r) => typeof e[r] == "function"
).find(
  (r) => s instanceof e[r]
);
function Vm(s, e, t, i) {
  const r = [], n = Object.getOwnPropertyNames(
    e.CanvasRenderingContext2D.prototype
  );
  for (const o of n)
    try {
      if (typeof e.CanvasRenderingContext2D.prototype[o] != "function")
        continue;
      const a = qe(
        e.CanvasRenderingContext2D.prototype,
        o,
        function(l) {
          return function(...u) {
            return oe(this.canvas, t, i, !0) || setTimeout(() => {
              const c = oa(u, e, this);
              s(this.canvas, {
                type: bt["2D"],
                property: o,
                args: c
              });
            }, 0), l.apply(this, u);
          };
        }
      );
      r.push(a);
    } catch (a) {
      const l = qi(
        e.CanvasRenderingContext2D.prototype,
        o,
        {
          set(u) {
            s(this.canvas, {
              type: bt["2D"],
              property: o,
              args: [u],
              setter: !0
            });
          }
        }
      );
      r.push(l);
    }
  return () => {
    r.forEach((o) => o());
  };
}
function Rm(s) {
  return s === "experimental-webgl" ? "webgl" : s;
}
function An(s, e, t, i) {
  const r = [];
  try {
    const n = qe(
      s.HTMLCanvasElement.prototype,
      "getContext",
      function(o) {
        return function(a, ...l) {
          if (!oe(this, e, t, !0)) {
            const u = Rm(a);
            if ("__context" in this || (this.__context = u), i && ["webgl", "webgl2"].includes(u))
              if (l[0] && typeof l[0] == "object") {
                const c = l[0];
                c.preserveDrawingBuffer || (c.preserveDrawingBuffer = !0);
              } else
                l.splice(0, 1, {
                  preserveDrawingBuffer: !0
                });
          }
          return o.apply(this, [a, ...l]);
        };
      }
    );
    r.push(n);
  } catch (n) {
    console.error("failed to patch HTMLCanvasElement.prototype.getContext");
  }
  return () => {
    r.forEach((n) => n());
  };
}
function _n(s, e, t, i, r, n) {
  const o = [], a = Object.getOwnPropertyNames(s);
  for (const l of a)
    if (
      //prop.startsWith('get') ||  // e.g. getProgramParameter, but too risky
      ![
        "isContextLost",
        "canvas",
        "drawingBufferWidth",
        "drawingBufferHeight"
      ].includes(l)
    )
      try {
        if (typeof s[l] != "function")
          continue;
        const u = qe(
          s,
          l,
          function(c) {
            return function(...h) {
              const p = c.apply(this, h);
              if (la(p, n, this), "tagName" in this.canvas && !oe(
                this.canvas,
                i,
                r,
                !0
              )) {
                const d = oa(h, n, this), b = {
                  type: e,
                  property: l,
                  args: d
                };
                t(this.canvas, b);
              }
              return p;
            };
          }
        );
        o.push(u);
      } catch (u) {
        const c = qi(s, l, {
          set(h) {
            t(this.canvas, {
              type: e,
              property: l,
              args: [h],
              setter: !0
            });
          }
        });
        o.push(c);
      }
  return o;
}
function Wm(s, e, t, i) {
  const r = [];
  return r.push(
    ..._n(
      e.WebGLRenderingContext.prototype,
      bt.WebGL,
      s,
      t,
      i,
      e
    )
  ), typeof e.WebGL2RenderingContext != "undefined" && r.push(
    ..._n(
      e.WebGL2RenderingContext.prototype,
      bt.WebGL2,
      s,
      t,
      i,
      e
    )
  ), () => {
    r.forEach((n) => n());
  };
}
const ca = "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", Cm = (s) => Uint8Array.from(atob(s), (e) => e.charCodeAt(0)), $n = typeof self != "undefined" && self.Blob && new Blob([Cm(ca)], { type: "text/javascript;charset=utf-8" });
function wm(s) {
  let e;
  try {
    if (e = $n && (self.URL || self.webkitURL).createObjectURL($n), !e) throw "";
    const t = new Worker(e, {
      name: s == null ? void 0 : s.name
    });
    return t.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(e);
    }), t;
  } catch (t) {
    return new Worker(
      "data:text/javascript;base64," + ca,
      {
        name: s == null ? void 0 : s.name
      }
    );
  } finally {
    e && (self.URL || self.webkitURL).revokeObjectURL(e);
  }
}
class xm {
  constructor(e) {
    X(this, "pendingCanvasMutations", /* @__PURE__ */ new Map()), X(this, "rafStamps", { latestId: 0, invokeId: null }), X(this, "mirror"), X(this, "logger"), X(this, "worker"), X(this, "snapshotInProgressMap", /* @__PURE__ */ new Map()), X(this, "lastSnapshotTime", /* @__PURE__ */ new Map()), X(this, "options"), X(this, "mutationCb"), X(this, "resetObservers"), X(this, "frozen", !1), X(this, "locked", !1), X(this, "processMutation", (h, p) => {
      (this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId || !this.rafStamps.invokeId) && (this.rafStamps.invokeId = this.rafStamps.latestId), this.pendingCanvasMutations.has(h) || this.pendingCanvasMutations.set(h, []), this.pendingCanvasMutations.get(h).push(p);
    });
    const {
      sampling: t,
      win: i,
      blockClass: r,
      blockSelector: n,
      recordCanvas: o,
      recordLocalVideos: a,
      recordRemoteVideos: l,
      initialSnapshotDelay: u,
      dataURLOptions: c
    } = e;
    this.mutationCb = e.mutationCb, this.mirror = e.mirror, this.logger = e.logger, this.worker = new wm(), this.worker.onmessage = (h) => {
      const { id: p } = h.data;
      if (this.snapshotInProgressMap.set(p, !1), !("base64" in h.data)) {
        this.debug(null, "canvas worker received empty message", {
          id: p,
          data: h.data,
          status: h.data.status
        });
        return;
      }
      const { base64: d, type: b, dx: m, dy: f, dw: V, dh: G } = h.data, g = {
        id: p,
        type: bt["2D"],
        commands: [
          {
            property: "clearRect",
            // wipe canvas
            args: [m, f, V, G]
          },
          {
            property: "drawImage",
            // draws (semi-transparent) image
            args: [
              {
                rr_type: "ImageBitmap",
                args: [
                  {
                    rr_type: "Blob",
                    data: [{ rr_type: "ArrayBuffer", base64: d }],
                    type: b
                  }
                ]
              },
              m,
              f,
              V,
              G
            ]
          }
        ]
      };
      this.debug(null, "canvas worker recording mutation", g), this.mutationCb(g);
    }, this.options = e, o && t === "all" ? (this.debug(null, "initializing canvas mutation observer", { sampling: t }), this.initCanvasMutationObserver(i, r, n)) : o && typeof t == "number" && (this.debug(null, "initializing canvas fps observer", { sampling: t }), this.initCanvasFPSObserver(
      a,
      l,
      t,
      i,
      r,
      n,
      {
        initialSnapshotDelay: u,
        dataURLOptions: c
      },
      e.resizeFactor,
      e.maxSnapshotDimension
    ));
  }
  reset() {
    this.pendingCanvasMutations.clear(), this.resetObservers && this.resetObservers();
  }
  freeze() {
    this.frozen = !0;
  }
  unfreeze() {
    this.frozen = !1;
  }
  lock() {
    this.locked = !0;
  }
  unlock() {
    this.locked = !1;
  }
  debug(e, ...t) {
    if (!this.logger) return;
    const i = this.mirror.getId(e);
    let r = "[highlight-canvas-manager]";
    e && (r = `[highlight-canvas] [id:${i}]`, e.tagName.toLowerCase() === "canvas" && (r += ` [ctx:${e.__context}]`)), this.logger.debug(r, e, ...t);
  }
  snapshot(e) {
    return ne(this, null, function* () {
      var t;
      const i = this.mirror.getId(e);
      if (this.snapshotInProgressMap.get(i)) {
        this.debug(e, "snapshotting already in progress for", i);
        return;
      }
      const r = 1e3 / (typeof this.options.samplingManual == "number" ? this.options.samplingManual : 1), n = this.lastSnapshotTime.get(i);
      if (!(n && (/* @__PURE__ */ new Date()).getTime() - n < r)) {
        if (this.debug(e, "starting snapshotting"), e.width === 0 || e.height === 0) {
          this.debug(e, "not yet ready", {
            width: e.width,
            height: e.height
          });
          return;
        }
        this.lastSnapshotTime.set(i, (/* @__PURE__ */ new Date()).getTime()), this.snapshotInProgressMap.set(i, !0);
        try {
          if (this.options.clearWebGLBuffer !== !1 && ["webgl", "webgl2"].includes(e.__context)) {
            const c = e.getContext(e.__context);
            ((t = c == null ? void 0 : c.getContextAttributes()) == null ? void 0 : t.preserveDrawingBuffer) === !1 && (c.clear(c.COLOR_BUFFER_BIT), this.debug(e, "cleared webgl canvas to load it into memory", {
              attributes: c == null ? void 0 : c.getContextAttributes()
            }));
          }
          if (e.width === 0 || e.height === 0) {
            this.debug(e, "not yet ready", {
              width: e.width,
              height: e.height
            });
            return;
          }
          let o = this.options.resizeFactor || 1;
          if (this.options.maxSnapshotDimension) {
            const c = Math.max(e.width, e.height);
            o = Math.min(o, this.options.maxSnapshotDimension / c);
          }
          const a = e.width * o, l = e.height * o, u = yield createImageBitmap(e, {
            resizeWidth: a,
            resizeHeight: l
          });
          this.debug(e, "created image bitmap", {
            width: u.width,
            height: u.height
          }), this.worker.postMessage(
            {
              id: i,
              bitmap: u,
              width: a,
              height: l,
              dx: 0,
              dy: 0,
              dw: e.width,
              dh: e.height,
              dataURLOptions: this.options.dataURLOptions,
              logDebug: !!this.logger
            },
            [u]
          ), this.debug(e, "sent message");
        } catch (o) {
          this.debug(e, "failed to snapshot", o);
        } finally {
          this.snapshotInProgressMap.set(i, !1);
        }
      }
    });
  }
  initCanvasFPSObserver(e, t, i, r, n, o, a, l, u) {
    const c = An(
      r,
      n,
      o,
      !0
    ), h = 1e3 / i;
    let p = 0, d;
    const b = /* @__PURE__ */ new Map(), m = (g, S) => {
      const y = [];
      g.querySelectorAll(S).forEach((R) => y.push(R));
      const W = document.createNodeIterator(g, Node.ELEMENT_NODE);
      let C;
      for (; C = W.nextNode(); )
        C != null && C.shadowRoot && y.push(...m(C.shadowRoot, S));
      return y;
    }, f = (g) => {
      const S = [];
      return m(r.document, "canvas").forEach((y) => {
        if (!oe(y, n, o, !0)) {
          this.debug(y, "discovered canvas"), S.push(y);
          const W = this.mirror.getId(y);
          b.has(W) || b.set(W, g);
        }
      }), S;
    }, V = (g) => {
      const S = [];
      return (e || t) && m(r.document, "video").forEach((y) => {
        if (!(!t && y.src !== "" && y.src.indexOf("blob:") === -1) && !(!e && (y.src === "" || y.src.indexOf("blob:") !== -1)) && !oe(y, n, o, !0)) {
          S.push(y);
          const W = this.mirror.getId(y);
          b.has(W) || b.set(W, g);
        }
      }), S;
    }, G = (g) => ne(this, null, function* () {
      if (p && g - p < h) {
        d = requestAnimationFrame(G);
        return;
      }
      p = g;
      const S = (W) => {
        const C = this.mirror.getId(W), R = b.get(C), Z = !a.initialSnapshotDelay || g - R > a.initialSnapshotDelay;
        return this.debug(W, {
          delay: a.initialSnapshotDelay,
          delta: g - R,
          hadLoadingTime: Z
        }), Z;
      }, y = [];
      y.push(
        ...f(g).filter(S).map((W) => this.snapshot(W))
      ), y.push(
        ...V(g).filter(S).map((W) => ne(this, null, function* () {
          this.debug(W, "starting video snapshotting");
          const C = this.mirror.getId(W);
          if (this.snapshotInProgressMap.get(C)) {
            this.debug(
              W,
              "video snapshotting already in progress for",
              C
            );
            return;
          }
          this.snapshotInProgressMap.set(C, !0);
          try {
            const { width: R, height: Z } = W.getBoundingClientRect(), { actualWidth: I, actualHeight: Y } = {
              actualWidth: W.videoWidth,
              actualHeight: W.videoHeight
            }, v = Math.max(I, Y);
            if (v === 0) {
              this.debug(W, "not yet ready", {
                width: W.width,
                height: W.height,
                actualWidth: I,
                actualHeight: Y,
                boxWidth: R,
                boxHeight: Z
              });
              return;
            }
            let Q = l || 1;
            u && (Q = Math.min(Q, u / v));
            const A = I * Q, w = Y * Q, te = yield createImageBitmap(W, {
              resizeWidth: A,
              resizeHeight: w
            }), H = Math.max(R, Z) / v, D = I * H, ee = Y * H, E = (R - D) / 2, O = (Z - ee) / 2;
            this.debug(W, "created image bitmap", {
              actualWidth: I,
              actualHeight: Y,
              boxWidth: R,
              boxHeight: Z,
              outputWidth: D,
              outputHeight: ee,
              resizeWidth: A,
              resizeHeight: w,
              scale: Q,
              outputScale: H,
              offsetX: E,
              offsetY: O
            }), this.worker.postMessage(
              {
                id: C,
                bitmap: te,
                width: A,
                height: w,
                dx: E,
                dy: O,
                dw: D,
                dh: ee,
                dataURLOptions: a.dataURLOptions,
                logDebug: !!this.logger
              },
              [te]
            ), this.debug(W, "send message");
          } catch (R) {
            this.debug(W, "failed to snapshot", R);
          } finally {
            this.snapshotInProgressMap.set(C, !1);
          }
        }))
      ), yield Promise.all(y).catch(console.error), d = requestAnimationFrame(G);
    });
    d = requestAnimationFrame(G), this.resetObservers = () => {
      c(), d && cancelAnimationFrame(d);
    };
  }
  initCanvasMutationObserver(e, t, i) {
    this.startRAFTimestamping(), this.startPendingCanvasMutationFlusher();
    const r = An(
      e,
      t,
      i,
      !1
    ), n = Vm(
      this.processMutation.bind(this),
      e,
      t,
      i
    ), o = Wm(
      this.processMutation.bind(this),
      e,
      t,
      i
    );
    this.resetObservers = () => {
      r(), n(), o();
    };
  }
  startPendingCanvasMutationFlusher() {
    requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  startRAFTimestamping() {
    const e = (t) => {
      this.rafStamps.latestId = t, requestAnimationFrame(e);
    };
    requestAnimationFrame(e);
  }
  flushPendingCanvasMutations() {
    this.pendingCanvasMutations.forEach(
      (e, t) => {
        const i = this.mirror.getId(t);
        this.flushPendingCanvasMutationFor(t, i);
      }
    ), requestAnimationFrame(() => this.flushPendingCanvasMutations());
  }
  flushPendingCanvasMutationFor(e, t) {
    if (this.frozen || this.locked)
      return;
    const i = this.pendingCanvasMutations.get(e);
    if (!i || t === -1) return;
    const r = i.map((o) => {
      const u = o, { type: a } = u;
      return Qe(u, ["type"]);
    }), { type: n } = i[0];
    this.mutationCb({ id: t, type: n, commands: r }), this.pendingCanvasMutations.delete(e);
  }
}
class Lm {
  constructor(e) {
    X(this, "trackedLinkElements", /* @__PURE__ */ new WeakSet()), X(this, "mutationCb"), X(this, "adoptedStyleSheetCb"), X(this, "styleMirror", new _p()), this.mutationCb = e.mutationCb, this.adoptedStyleSheetCb = e.adoptedStyleSheetCb;
  }
  attachLinkElement(e, t) {
    "_cssText" in t.attributes && this.mutationCb({
      adds: [],
      removes: [],
      texts: [],
      attributes: [
        {
          id: t.id,
          attributes: t.attributes
        }
      ]
    }), this.trackLinkElement(e);
  }
  trackLinkElement(e) {
    this.trackedLinkElements.has(e) || (this.trackedLinkElements.add(e), this.trackStylesheetInLinkElement(e));
  }
  adoptStyleSheets(e, t) {
    if (e.length === 0) return;
    const i = {
      id: t,
      styleIds: []
    }, r = [];
    for (const n of e) {
      let o;
      this.styleMirror.has(n) ? o = this.styleMirror.getId(n) : (o = this.styleMirror.add(n), r.push({
        styleId: o,
        rules: Array.from(n.rules || CSSRule, (a, l) => ({
          rule: ml(a, n.href),
          index: l
        }))
      })), i.styleIds.push(o);
    }
    r.length > 0 && (i.styles = r), this.adoptedStyleSheetCb(i);
  }
  reset() {
    this.styleMirror.reset(), this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  // TODO: take snapshot on stylesheet reload by applying event listener
  trackStylesheetInLinkElement(e) {
  }
}
class km {
  constructor() {
    X(this, "nodeMap", /* @__PURE__ */ new WeakMap()), X(this, "active", !1);
  }
  inOtherBuffer(e, t) {
    const i = this.nodeMap.get(e);
    return i && Array.from(i).some((r) => r !== t);
  }
  add(e, t) {
    this.active || (this.active = !0, requestAnimationFrame(() => {
      this.nodeMap = /* @__PURE__ */ new WeakMap(), this.active = !1;
    })), this.nodeMap.set(e, (this.nodeMap.get(e) || /* @__PURE__ */ new Set()).add(t));
  }
  destroy() {
  }
}
let q, Wi, kt, zi = !1;
try {
  if (Array.from([1], (s) => s * 2)[0] !== 2) {
    const s = document.createElement("iframe");
    document.body.appendChild(s), Array.from = ((Er = s.contentWindow) == null ? void 0 : Er.Array.from) || Array.from, document.body.removeChild(s);
  }
} catch (s) {
  console.debug("Unable to override Array.from", s);
}
const Xe = Rc();
function Ye(s = {}) {
  var e, t, i, r, n, o, a, l;
  const {
    emit: u,
    checkoutEveryNms: c,
    checkoutEveryNth: h,
    blockClass: p = "highlight-block",
    blockSelector: d = null,
    ignoreClass: b = "highlight-ignore",
    ignoreSelector: m = null,
    maskTextClass: f = "highlight-mask",
    maskTextSelector: V = null,
    inlineStylesheet: G = !0,
    maskAllInputs: g,
    maskInputOptions: S,
    slimDOMOptions: y,
    maskInputFn: W,
    maskTextFn: C = ar,
    hooks: R,
    packFn: Z,
    sampling: I = {},
    mousemoveWait: Y,
    recordDOM: v = !0,
    recordCanvas: Q = !1,
    recordCrossOriginIframes: A = !1,
    recordAfter: w = s.recordAfter === "DOMContentLoaded" ? s.recordAfter : "load",
    userTriggeredOnInput: te = !1,
    collectFonts: H = !1,
    inlineImages: D = !1,
    inlineVideos: ee = !1,
    plugins: E,
    keepIframeSrcFn: O = () => !1,
    privacySetting: pe = "default",
    ignoreCSSAttributes: ae = /* @__PURE__ */ new Set([]),
    errorHandler: be,
    logger: se
  } = s, ye = x(x({}, s.dataURLOptions), (t = (e = s.sampling) == null ? void 0 : e.canvas) == null ? void 0 : t.dataURLOptions);
  rm(be);
  const Pe = A ? window.parent === window : !0;
  let xe = !1;
  if (!Pe)
    try {
      window.parent.document && (xe = !1);
    } catch (F) {
      xe = !0;
    }
  if (Pe && !u)
    throw new Error("emit function is required");
  if (!Pe && !xe)
    return () => {
    };
  Y !== void 0 && I.mousemove === void 0 && (I.mousemove = Y), Xe.reset();
  const Zt = g === !0 ? {
    color: !0,
    date: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
    textarea: !0,
    select: !0,
    password: !0
  } : S !== void 0 ? S : { password: !0 }, et = y === !0 || y === "all" ? {
    script: !0,
    comment: !0,
    headFavicon: !0,
    headWhitespace: !0,
    headMetaSocial: !0,
    headMetaRobots: !0,
    headMetaHttpEquiv: !0,
    headMetaVerification: !0,
    // the following are off for slimDOMOptions === true,
    // as they destroy some (hidden) info:
    headMetaAuthorship: y === "all",
    headMetaDescKeywords: y === "all",
    headTitleMutations: y === "all"
  } : y || {};
  Ap();
  let yt, tt = 0;
  const it = (F) => {
    for (const ge of E || [])
      ge.eventProcessor && (F = ge.eventProcessor(F));
    return Z && // Disable packing events which will be emitted to parent frames.
    !xe && (F = Z(F)), F;
  };
  q = (F, ge) => {
    var _;
    const $ = F;
    if ($.timestamp = Fi(), (_ = De[0]) != null && _.isFrozen() && $.type !== K.FullSnapshot && !($.type === K.IncrementalSnapshot && $.data.source === T.Mutation) && De.forEach((Ie) => Ie.unfreeze()), Pe)
      u == null || u(it($), ge);
    else if (xe) {
      const Ie = {
        type: "rrweb",
        event: it($),
        origin: window.location.origin,
        isCheckout: ge
      };
      window.parent.postMessage(Ie, "*");
    }
    if ($.type === K.FullSnapshot)
      yt = $, tt = 0;
    else if ($.type === K.IncrementalSnapshot) {
      if ($.data.source === T.Mutation && $.data.isAttachIframe)
        return;
      tt++;
      const Ie = h && tt >= h, P = c && $.timestamp - yt.timestamp > c;
      (Ie || P) && Wi(!0);
    }
  };
  const Ue = (F) => {
    q({
      type: K.IncrementalSnapshot,
      data: x({
        source: T.Mutation
      }, F)
    });
  }, Nr = (F) => q({
    type: K.IncrementalSnapshot,
    data: x({
      source: T.Scroll
    }, F)
  }), Tr = (F) => q({
    type: K.IncrementalSnapshot,
    data: x({
      source: T.CanvasMutation
    }, F)
  }), ya = (F) => q({
    type: K.IncrementalSnapshot,
    data: x({
      source: T.AdoptedStyleSheet
    }, F)
  }), Ee = new Lm({
    mutationCb: Ue,
    adoptedStyleSheetCb: ya
  }), Be = new gm({
    mirror: Xe,
    mutationCb: Ue,
    stylesheetManager: Ee,
    recordCrossOriginIframes: A,
    wrappedEmit: q
  });
  for (const F of E || [])
    F.getMirror && F.getMirror({
      nodeMirror: Xe,
      crossOriginIframeMirror: Be.crossOriginIframeMirror,
      crossOriginIframeStyleMirror: Be.crossOriginIframeStyleMirror
    });
  const es = new km();
  kt = new xm({
    recordCanvas: Q,
    recordLocalVideos: D,
    recordRemoteVideos: ee,
    mutationCb: Tr,
    win: window,
    blockClass: p,
    blockSelector: d,
    mirror: Xe,
    sampling: (i = I == null ? void 0 : I.canvas) == null ? void 0 : i.fps,
    samplingManual: (r = I == null ? void 0 : I.canvas) == null ? void 0 : r.fpsManual,
    clearWebGLBuffer: (n = I == null ? void 0 : I.canvas) == null ? void 0 : n.clearWebGLBuffer,
    initialSnapshotDelay: (o = I == null ? void 0 : I.canvas) == null ? void 0 : o.initialSnapshotDelay,
    dataURLOptions: ye,
    resizeFactor: (a = I == null ? void 0 : I.canvas) == null ? void 0 : a.resizeFactor,
    maxSnapshotDimension: (l = I == null ? void 0 : I.canvas) == null ? void 0 : l.maxSnapshotDimension,
    logger: se
  });
  const jt = new Xm({
    mutationCb: Ue,
    scrollCb: Nr,
    bypassOptions: {
      blockClass: p,
      blockSelector: d,
      maskTextClass: f,
      maskTextSelector: V,
      inlineStylesheet: G,
      maskInputOptions: Zt,
      dataURLOptions: ye,
      maskTextFn: C,
      maskInputFn: W,
      recordCanvas: Q,
      inlineImages: D,
      inlineVideos: ee,
      privacySetting: pe,
      sampling: I,
      slimDOMOptions: et,
      iframeManager: Be,
      stylesheetManager: Ee,
      canvasManager: kt,
      keepIframeSrcFn: O,
      processedNodeManager: es
    },
    mirror: Xe
  });
  Wi = (F = !1) => {
    if (!v)
      return;
    q(
      {
        type: K.Meta,
        data: {
          href: window.location.href,
          width: Do(),
          height: Qo()
        }
      },
      F
    ), Ee.reset(), jt.init(), De.forEach((_) => _.lock());
    const ge = iu(document, {
      mirror: Xe,
      blockClass: p,
      blockSelector: d,
      maskTextClass: f,
      maskTextSelector: V,
      inlineStylesheet: G,
      maskAllInputs: Zt,
      maskTextFn: C,
      maskInputFn: W,
      slimDOM: et,
      dataURLOptions: ye,
      recordCanvas: Q,
      inlineImages: D,
      inlineVideos: ee,
      privacySetting: pe,
      onSerialize: (_) => {
        _o(_, Xe) && Be.addIframe(_), $o(_, Xe) && Ee.trackLinkElement(_), tr(_) && jt.addShadowRoot(N.shadowRoot(_), document);
      },
      onIframeLoad: (_, $) => {
        Be.attachIframe(_, $), jt.observeAttachShadow(_);
      },
      onStylesheetLoad: (_, $) => {
        Ee.attachLinkElement(_, $);
      },
      keepIframeSrcFn: O
    });
    if (!ge)
      return console.warn("Failed to snapshot the document");
    q(
      {
        type: K.FullSnapshot,
        data: {
          node: ge,
          initialOffset: Bo(window)
        }
      },
      F
    ), De.forEach((_) => _.unlock()), document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0 && Ee.adoptStyleSheets(
      document.adoptedStyleSheets,
      Xe.getId(document)
    );
  };
  try {
    const F = [], ge = ($) => {
      var Ie;
      return U(ym)(
        {
          mutationCb: Ue,
          mousemoveCb: (P, ts) => q({
            type: K.IncrementalSnapshot,
            data: {
              source: ts,
              positions: P
            }
          }),
          mouseInteractionCb: (P) => q({
            type: K.IncrementalSnapshot,
            data: x({
              source: T.MouseInteraction
            }, P)
          }),
          scrollCb: Nr,
          viewportResizeCb: (P) => q({
            type: K.IncrementalSnapshot,
            data: x({
              source: T.ViewportResize
            }, P)
          }),
          inputCb: (P) => q({
            type: K.IncrementalSnapshot,
            data: x({
              source: T.Input
            }, P)
          }),
          mediaInteractionCb: (P) => q({
            type: K.IncrementalSnapshot,
            data: x({
              source: T.MediaInteraction
            }, P)
          }),
          styleSheetRuleCb: (P) => q({
            type: K.IncrementalSnapshot,
            data: x({
              source: T.StyleSheetRule
            }, P)
          }),
          styleDeclarationCb: (P) => q({
            type: K.IncrementalSnapshot,
            data: x({
              source: T.StyleDeclaration
            }, P)
          }),
          canvasMutationCb: Tr,
          fontCb: (P) => q({
            type: K.IncrementalSnapshot,
            data: x({
              source: T.Font
            }, P)
          }),
          selectionCb: (P) => {
            q({
              type: K.IncrementalSnapshot,
              data: x({
                source: T.Selection
              }, P)
            });
          },
          customElementCb: (P) => {
            q({
              type: K.IncrementalSnapshot,
              data: x({
                source: T.CustomElement
              }, P)
            });
          },
          blockClass: p,
          ignoreClass: b,
          ignoreSelector: m,
          maskTextClass: f,
          maskTextSelector: V,
          maskInputOptions: Zt,
          inlineStylesheet: G,
          sampling: I,
          recordDOM: v,
          recordCanvas: Q,
          inlineImages: D,
          inlineVideos: ee,
          userTriggeredOnInput: te,
          collectFonts: H,
          doc: $,
          maskInputFn: W,
          maskTextFn: C,
          keepIframeSrcFn: O,
          blockSelector: d,
          slimDOMOptions: et,
          dataURLOptions: ye,
          mirror: Xe,
          iframeManager: Be,
          stylesheetManager: Ee,
          shadowDomManager: jt,
          processedNodeManager: es,
          canvasManager: kt,
          ignoreCSSAttributes: ae,
          privacySetting: pe,
          plugins: ((Ie = E == null ? void 0 : E.filter((P) => P.observer)) == null ? void 0 : Ie.map((P) => ({
            observer: P.observer,
            options: P.options,
            callback: (ts) => q({
              type: K.Plugin,
              data: {
                plugin: P.name,
                payload: ts
              }
            })
          }))) || []
        },
        R
      );
    };
    Be.addLoadListener(($) => {
      try {
        F.push(ge($.contentDocument));
      } catch (Ie) {
        console.warn(Ie);
      }
    });
    const _ = () => {
      Wi(), F.push(ge(document)), zi = !0;
    };
    return document.readyState === "interactive" || document.readyState === "complete" ? _() : (F.push(
      he("DOMContentLoaded", () => {
        q({
          type: K.DomContentLoaded,
          data: {}
        }), w === "DOMContentLoaded" && _();
      })
    ), F.push(
      he(
        "load",
        () => {
          q({
            type: K.Load,
            data: {}
          }), w === "load" && _();
        },
        window
      )
    )), () => {
      F.forEach(($) => $()), es.destroy(), zi = !1, nm();
    };
  } catch (F) {
    console.warn(F);
  }
}
Ye.addCustomEvent = (s, e) => {
  zi && q({
    type: K.Custom,
    data: {
      tag: s,
      payload: e
    }
  });
};
Ye.freezePage = () => {
  De.forEach((s) => s.freeze());
};
Ye.takeFullSnapshot = (s) => {
  if (!zi)
    throw new Error("please take full snapshot after start recording");
  Wi(s);
};
Ye.snapshotCanvas = (s) => ne(void 0, null, function* () {
  if (!kt)
    throw new Error("canvas manager is not initialized");
  yield kt.snapshot(s);
});
Ye.mirror = Xe;
var qn;
(function(s) {
  s[s.NotStarted = 0] = "NotStarted", s[s.Running = 1] = "Running", s[s.Stopped = 2] = "Stopped";
})(qn || (qn = {}));
const { addCustomEvent: el } = Ye, Jm = (s, e, t) => {
  switch (s) {
    case "strict":
      return [!0, void 0];
    case "default":
      return [!0, void 0];
    case "none":
      return [!!e, re(x({}, t), { password: !0 })];
  }
}, vm = (s) => {
  const e = (t) => {
    if (t.target) {
      const i = t.target, r = hl(i);
      s(r, t);
    }
  };
  return window.addEventListener("click", e), () => window.removeEventListener("click", e);
}, Ym = (s) => {
  const e = (t) => {
    if (t.target) {
      const i = hl(t.target);
      s(i);
    }
  };
  return window.addEventListener("focusin", e), () => window.removeEventListener("focusin", e);
}, Nm = (s) => {
  let e, t;
  if (typeof document.hidden != "undefined" ? (e = "hidden", t = "visibilitychange") : typeof document.msHidden != "undefined" ? (e = "msHidden", t = "msvisibilitychange") : typeof document.webkitHidden != "undefined" && (e = "webkitHidden", t = "webkitvisibilitychange"), t === void 0)
    return () => {
    };
  if (e === void 0)
    return () => {
    };
  const i = e, r = () => {
    const o = document[i];
    s(!!o);
  };
  document.addEventListener(t, r);
  const n = t;
  return () => document.removeEventListener(n, r);
}, Tm = (s) => {
  s(window.location.href);
  var e = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(n) {
    setTimeout(() => {
      var a;
      var o;
      try {
        o = JSON.parse((a = n == null ? void 0 : n.toString()) != null ? a : "");
      } catch (l) {
        return;
      }
      (o.type === "track" || o.type === "identify") && gs(o) && s(o);
    }, 100), e.call(this, n);
  };
  const t = (n) => {
    if (n.key === "ajs_user_id" || n.key === "ajs_anonymous_id" || n.key === "ajs_user_traits") {
      const { userId: o, userTraits: a } = tl();
      if (o) {
        let l = {};
        a && (l = JSON.parse(a));
        const u = {
          type: "identify",
          userId: o.toString(),
          traits: l
        };
        gs(u) && s(u);
      }
    }
  }, { userId: i, userTraits: r } = tl();
  if (i) {
    let n = {};
    r && (n = JSON.parse(r));
    const o = {
      type: "identify",
      userId: i.toString(),
      traits: n
    };
    gs(o) && s(o);
  }
  return window.addEventListener("storage", t), Sa(({ keyName: n }) => {
    t({
      key: n
    });
  }), () => {
    window.removeEventListener("storage", t), XMLHttpRequest.prototype.send = e;
  };
}, tl = () => {
  const s = we(
    "ajs_user_id"
    /* USER_ID */
  ), e = we(
    "ajs_user_traits"
    /* USER_TRAITS */
  ), t = we(
    "ajs_anonymous_id"
    /* ANONYMOUS_ID */
  );
  return {
    userId: s,
    userTraits: e,
    anonymousId: t
  };
}, gs = (s) => {
  if (!s)
    return !1;
  let e = "";
  try {
    e = JSON.stringify(s);
  } catch (r) {
    return !1;
  }
  const t = Um(e), i = we(
    ve.SEGMENT_LAST_SENT_HASH_KEY
  );
  return i === void 0 ? (je(ve.SEGMENT_LAST_SENT_HASH_KEY, t), !0) : t !== i ? (je(ve.SEGMENT_LAST_SENT_HASH_KEY, t), !0) : !1;
}, Um = (s) => {
  var e = 0, t = s.length, i = 0;
  if (t > 0) for (; i < t; ) e = (e << 5) - e + s.charCodeAt(i++) | 0;
  return e.toString();
}, Km = (s, e) => {
  const t = Fm(s);
  let i = [];
  const r = !1, n = !0;
  for (let o = 0; o < t.length; o++) {
    let a = t[o].split("+");
    i = [], a.length > 1 && (i = Hm(ua, a)), a = a[a.length - 1], a = a === "*" ? "*" : zm(a), a in Ce || (Ce[a] = []), Ce[a].push({
      mods: i,
      shortcut: t[o],
      key: t[o],
      method: e,
      keyup: r,
      keydown: n,
      scope: "all",
      splitKey: "+"
    });
  }
  Om(document, "keydown", (o) => {
    Em(o);
  });
};
let ce = [];
function Fm(s) {
  typeof s != "string" && (s = ""), s = s.replace(/\s/g, "");
  const e = s.split(",");
  let t = e.lastIndexOf("");
  for (; t >= 0; )
    e[t - 1] += ",", e.splice(t, 1), t = e.lastIndexOf("");
  return e;
}
const Ce = {}, Xs = typeof navigator != "undefined" ? navigator.userAgent.toLowerCase().indexOf("firefox") > 0 : !1, Mm = {
  backspace: 8,
  tab: 9,
  clear: 12,
  enter: 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  num_0: 96,
  num_1: 97,
  num_2: 98,
  num_3: 99,
  num_4: 100,
  num_5: 101,
  num_6: 102,
  num_7: 103,
  num_8: 104,
  num_9: 105,
  num_multiply: 106,
  num_add: 107,
  num_enter: 108,
  num_subtract: 109,
  num_decimal: 110,
  num_divide: 111,
  "⇪": 20,
  ",": 188,
  ".": 190,
  "/": 191,
  "`": 192,
  "-": Xs ? 173 : 189,
  "=": Xs ? 61 : 187,
  ";": Xs ? 59 : 186,
  "'": 222,
  "[": 219,
  "]": 221,
  "\\": 220
}, il = {
  16: "shiftKey",
  18: "altKey",
  17: "ctrlKey",
  91: "metaKey",
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
}, ue = {
  16: !1,
  18: !1,
  17: !1,
  91: !1
}, ua = {
  // shiftKey
  "⇧": 16,
  shift: 16,
  // altKey
  "⌥": 18,
  alt: 18,
  option: 18,
  // ctrlKey
  "⌃": 17,
  ctrl: 17,
  control: 17,
  // metaKey
  "⌘": 91,
  cmd: 91,
  command: 91
}, zm = (s) => (
  // @ts-expect-error
  Mm[s.toLowerCase()] || // @ts-expect-error
  ua[s.toLowerCase()] || s.toUpperCase().charCodeAt(0)
);
function Hm(s, e) {
  const t = e.slice(0, e.length - 1);
  for (let i = 0; i < t.length; i++)
    t[i] = s[t[i].toLowerCase()];
  return t;
}
function Om(s, e, t) {
  s.addEventListener ? s.addEventListener(e, t, !1) : s.attachEvent && s.attachEvent(`on${e}`, () => {
    t(window.event);
  });
}
function Pm(s, e, t) {
  let i;
  if (e.scope === t || e.scope === "all") {
    i = e.mods.length > 0;
    for (const r in ue)
      Object.prototype.hasOwnProperty.call(ue, r) && // @ts-expect-error
      (!ue[r] && e.mods.indexOf(+r) > -1 || // @ts-expect-error
      ue[r] && e.mods.indexOf(+r) === -1) && (i = !1);
    (e.mods.length === 0 && !ue[16] && !ue[18] && !ue[17] && !ue[91] || i || e.shortcut === "*") && e.method(s, e) === !1 && (s.preventDefault ? s.preventDefault() : s.returnValue = !1, s.stopPropagation && s.stopPropagation(), s.cancelBubble && (s.cancelBubble = !0));
  }
}
function Em(s) {
  const e = Ce["*"];
  let t = s.keyCode || s.which || s.charCode;
  if ((t === 93 || t === 224) && (t = 91), ce.indexOf(t) === -1 && t !== 229 && ce.push(t), ["ctrlKey", "altKey", "shiftKey", "metaKey"].forEach((i) => {
    const r = il[i];
    s[i] && ce.indexOf(r) === -1 ? ce.push(r) : !s[i] && ce.indexOf(r) > -1 ? ce.splice(ce.indexOf(r), 1) : i === "metaKey" && s[i] && ce.length === 3 && (s.ctrlKey || s.shiftKey || s.altKey || (ce = ce.slice(ce.indexOf(r))));
  }), !(t in ue && (ue[t] = !0, !e))) {
    for (const i in ue)
      Object.prototype.hasOwnProperty.call(ue, i) && (ue[i] = s[il[i]]);
    if (s.getModifierState && !(s.altKey && !s.ctrlKey) && s.getModifierState("AltGraph") && (ce.indexOf(17) === -1 && ce.push(17), ce.indexOf(18) === -1 && ce.push(18), ue[17] = !0, ue[18] = !0), t in Ce) {
      for (let i = 0; i < Ce[t].length; i++)
        if (
          // @ts-expect-error
          (s.type === "keydown" && Ce[t][i].keydown || // @ts-expect-error
          s.type === "keyup" && Ce[t][i].keyup) && Ce[t][i].key
        ) {
          const r = Ce[t][i];
          Pm(s, r, "all");
        }
    }
  }
}
const sl = "iframe parent ready", rl = "iframe ok", Ot = "highlightLogs", Bm = (s) => {
  let e = we(Ot) || "";
  e = e + "[" + (/* @__PURE__ */ new Date()).getTime() + "] " + s + `
`, je(Ot, e);
}, Qm = () => we(Ot) || "", Dm = (s) => {
  if (!s)
    return;
  let e = we(Ot) || "";
  e && (e.startsWith(s) ? (e = e.slice(s.length), je(Ot, e)) : Bm(
    "Unable to clear logs " + s.replace(`
`, " ") + " from " + e.replace(`
`, " ")
  ));
};
var fe = Uint8Array, me = Uint16Array, Jr = Int32Array, vr = new fe([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  /* unused */
  0,
  0,
  /* impossible */
  0
]), Yr = new fe([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  /* unused */
  0,
  0
]), nl = new fe([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), ha = function(s, e) {
  for (var t = new me(31), i = 0; i < 31; ++i)
    t[i] = e += 1 << s[i - 1];
  for (var r = new Jr(t[30]), i = 1; i < 30; ++i)
    for (var n = t[i]; n < t[i + 1]; ++n)
      r[n] = n - t[i] << 5 | i;
  return { b: t, r };
}, da = ha(vr, 2), jm = da.b, sr = da.r;
jm[28] = 258, sr[258] = 28;
var Am = ha(Yr, 0), ll = Am.r, rr = new me(32768);
for (var j = 0; j < 32768; ++j) {
  var Ke = (j & 43690) >> 1 | (j & 21845) << 1;
  Ke = (Ke & 52428) >> 2 | (Ke & 13107) << 2, Ke = (Ke & 61680) >> 4 | (Ke & 3855) << 4, rr[j] = ((Ke & 65280) >> 8 | (Ke & 255) << 8) >> 1;
}
var Jt = function(s, e, t) {
  for (var i = s.length, r = 0, n = new me(e); r < i; ++r)
    s[r] && ++n[s[r] - 1];
  var o = new me(e);
  for (r = 1; r < e; ++r)
    o[r] = o[r - 1] + n[r - 1] << 1;
  var a;
  if (t) {
    a = new me(1 << e);
    var l = 15 - e;
    for (r = 0; r < i; ++r)
      if (s[r])
        for (var u = r << 4 | s[r], c = e - s[r], h = o[s[r] - 1]++ << c, p = h | (1 << c) - 1; h <= p; ++h)
          a[rr[h] >> l] = u;
  } else
    for (a = new me(i), r = 0; r < i; ++r)
      s[r] && (a[r] = rr[o[s[r] - 1]++] >> 15 - s[r]);
  return a;
}, Ae = new fe(288);
for (var j = 0; j < 144; ++j)
  Ae[j] = 8;
for (var j = 144; j < 256; ++j)
  Ae[j] = 9;
for (var j = 256; j < 280; ++j)
  Ae[j] = 7;
for (var j = 280; j < 288; ++j)
  Ae[j] = 8;
var Hi = new fe(32);
for (var j = 0; j < 32; ++j)
  Hi[j] = 5;
var _m = /* @__PURE__ */ Jt(Ae, 9, 0), $m = /* @__PURE__ */ Jt(Hi, 5, 0), pa = function(s) {
  return (s + 7) / 8 | 0;
}, ma = function(s, e, t) {
  return (t == null || t > s.length) && (t = s.length), new fe(s.subarray(e, t));
}, Je = function(s, e, t) {
  t <<= e & 7;
  var i = e / 8 | 0;
  s[i] |= t, s[i + 1] |= t >> 8;
}, Wt = function(s, e, t) {
  t <<= e & 7;
  var i = e / 8 | 0;
  s[i] |= t, s[i + 1] |= t >> 8, s[i + 2] |= t >> 16;
}, Gs = function(s, e) {
  for (var t = [], i = 0; i < s.length; ++i)
    s[i] && t.push({ s: i, f: s[i] });
  var r = t.length, n = t.slice();
  if (!r)
    return { t: ba, l: 0 };
  if (r == 1) {
    var o = new fe(t[0].s + 1);
    return o[t[0].s] = 1, { t: o, l: 1 };
  }
  t.sort(function(y, W) {
    return y.f - W.f;
  }), t.push({ s: -1, f: 25001 });
  var a = t[0], l = t[1], u = 0, c = 1, h = 2;
  for (t[0] = { s: -1, f: a.f + l.f, l: a, r: l }; c != r - 1; )
    a = t[t[u].f < t[h].f ? u++ : h++], l = t[u != c && t[u].f < t[h].f ? u++ : h++], t[c++] = { s: -1, f: a.f + l.f, l: a, r: l };
  for (var p = n[0].s, i = 1; i < r; ++i)
    n[i].s > p && (p = n[i].s);
  var d = new me(p + 1), b = nr(t[c - 1], d, 0);
  if (b > e) {
    var i = 0, m = 0, f = b - e, V = 1 << f;
    for (n.sort(function(W, C) {
      return d[C.s] - d[W.s] || W.f - C.f;
    }); i < r; ++i) {
      var G = n[i].s;
      if (d[G] > e)
        m += V - (1 << b - d[G]), d[G] = e;
      else
        break;
    }
    for (m >>= f; m > 0; ) {
      var g = n[i].s;
      d[g] < e ? m -= 1 << e - d[g]++ - 1 : ++i;
    }
    for (; i >= 0 && m; --i) {
      var S = n[i].s;
      d[S] == e && (--d[S], ++m);
    }
    b = e;
  }
  return { t: new fe(d), l: b };
}, nr = function(s, e, t) {
  return s.s == -1 ? Math.max(nr(s.l, e, t + 1), nr(s.r, e, t + 1)) : e[s.s] = t;
}, ol = function(s) {
  for (var e = s.length; e && !s[--e]; )
    ;
  for (var t = new me(++e), i = 0, r = s[0], n = 1, o = function(l) {
    t[i++] = l;
  }, a = 1; a <= e; ++a)
    if (s[a] == r && a != e)
      ++n;
    else {
      if (!r && n > 2) {
        for (; n > 138; n -= 138)
          o(32754);
        n > 2 && (o(n > 10 ? n - 11 << 5 | 28690 : n - 3 << 5 | 12305), n = 0);
      } else if (n > 3) {
        for (o(r), --n; n > 6; n -= 6)
          o(8304);
        n > 2 && (o(n - 3 << 5 | 8208), n = 0);
      }
      for (; n--; )
        o(r);
      n = 1, r = s[a];
    }
  return { c: t.subarray(0, i), n: e };
}, Ct = function(s, e) {
  for (var t = 0, i = 0; i < e.length; ++i)
    t += s[i] * e[i];
  return t;
}, fa = function(s, e, t) {
  var i = t.length, r = pa(e + 2);
  s[r] = i & 255, s[r + 1] = i >> 8, s[r + 2] = s[r] ^ 255, s[r + 3] = s[r + 1] ^ 255;
  for (var n = 0; n < i; ++n)
    s[r + n + 4] = t[n];
  return (r + 4 + i) * 8;
}, al = function(s, e, t, i, r, n, o, a, l, u, c) {
  Je(e, c++, t), ++r[256];
  for (var h = Gs(r, 15), p = h.t, d = h.l, b = Gs(n, 15), m = b.t, f = b.l, V = ol(p), G = V.c, g = V.n, S = ol(m), y = S.c, W = S.n, C = new me(19), R = 0; R < G.length; ++R)
    ++C[G[R] & 31];
  for (var R = 0; R < y.length; ++R)
    ++C[y[R] & 31];
  for (var Z = Gs(C, 7), I = Z.t, Y = Z.l, v = 19; v > 4 && !I[nl[v - 1]]; --v)
    ;
  var Q = u + 5 << 3, A = Ct(r, Ae) + Ct(n, Hi) + o, w = Ct(r, p) + Ct(n, m) + o + 14 + 3 * v + Ct(C, I) + 2 * C[16] + 3 * C[17] + 7 * C[18];
  if (l >= 0 && Q <= A && Q <= w)
    return fa(e, c, s.subarray(l, l + u));
  var te, H, D, ee;
  if (Je(e, c, 1 + (w < A)), c += 2, w < A) {
    te = Jt(p, d, 0), H = p, D = Jt(m, f, 0), ee = m;
    var E = Jt(I, Y, 0);
    Je(e, c, g - 257), Je(e, c + 5, W - 1), Je(e, c + 10, v - 4), c += 14;
    for (var R = 0; R < v; ++R)
      Je(e, c + 3 * R, I[nl[R]]);
    c += 3 * v;
    for (var O = [G, y], pe = 0; pe < 2; ++pe)
      for (var ae = O[pe], R = 0; R < ae.length; ++R) {
        var be = ae[R] & 31;
        Je(e, c, E[be]), c += I[be], be > 15 && (Je(e, c, ae[R] >> 5 & 127), c += ae[R] >> 12);
      }
  } else
    te = _m, H = Ae, D = $m, ee = Hi;
  for (var R = 0; R < a; ++R) {
    var se = i[R];
    if (se > 255) {
      var be = se >> 18 & 31;
      Wt(e, c, te[be + 257]), c += H[be + 257], be > 7 && (Je(e, c, se >> 23 & 31), c += vr[be]);
      var ye = se & 31;
      Wt(e, c, D[ye]), c += ee[ye], ye > 3 && (Wt(e, c, se >> 5 & 8191), c += Yr[ye]);
    } else
      Wt(e, c, te[se]), c += H[se];
  }
  return Wt(e, c, te[256]), c + H[256];
}, qm = /* @__PURE__ */ new Jr([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), ba = /* @__PURE__ */ new fe(0), ef = function(s, e, t, i, r, n) {
  var o = n.z || s.length, a = new fe(i + o + 5 * (1 + Math.ceil(o / 7e3)) + r), l = a.subarray(i, a.length - r), u = n.l, c = (n.r || 0) & 7;
  if (e) {
    c && (l[0] = n.r >> 3);
    for (var h = qm[e - 1], p = h >> 13, d = h & 8191, b = (1 << t) - 1, m = n.p || new me(32768), f = n.h || new me(b + 1), V = Math.ceil(t / 3), G = 2 * V, g = function(Ue) {
      return (s[Ue] ^ s[Ue + 1] << V ^ s[Ue + 2] << G) & b;
    }, S = new Jr(25e3), y = new me(288), W = new me(32), C = 0, R = 0, Z = n.i || 0, I = 0, Y = n.w || 0, v = 0; Z + 2 < o; ++Z) {
      var Q = g(Z), A = Z & 32767, w = f[Q];
      if (m[A] = w, f[Q] = A, Y <= Z) {
        var te = o - Z;
        if ((C > 7e3 || I > 24576) && (te > 423 || !u)) {
          c = al(s, l, 0, S, y, W, R, I, v, Z - v, c), I = C = R = 0, v = Z;
          for (var H = 0; H < 286; ++H)
            y[H] = 0;
          for (var H = 0; H < 30; ++H)
            W[H] = 0;
        }
        var D = 2, ee = 0, E = d, O = A - w & 32767;
        if (te > 2 && Q == g(Z - O))
          for (var pe = Math.min(p, te) - 1, ae = Math.min(32767, Z), be = Math.min(258, te); O <= ae && --E && A != w; ) {
            if (s[Z + D] == s[Z + D - O]) {
              for (var se = 0; se < be && s[Z + se] == s[Z + se - O]; ++se)
                ;
              if (se > D) {
                if (D = se, ee = O, se > pe)
                  break;
                for (var ye = Math.min(O, se - 2), Pe = 0, H = 0; H < ye; ++H) {
                  var xe = Z - O + H & 32767, Zt = m[xe], et = xe - Zt & 32767;
                  et > Pe && (Pe = et, w = xe);
                }
              }
            }
            A = w, w = m[A], O += A - w & 32767;
          }
        if (ee) {
          S[I++] = 268435456 | sr[D] << 18 | ll[ee];
          var yt = sr[D] & 31, tt = ll[ee] & 31;
          R += vr[yt] + Yr[tt], ++y[257 + yt], ++W[tt], Y = Z + D, ++C;
        } else
          S[I++] = s[Z], ++y[s[Z]];
      }
    }
    for (Z = Math.max(Z, Y); Z < o; ++Z)
      S[I++] = s[Z], ++y[s[Z]];
    c = al(s, l, u, S, y, W, R, I, v, Z - v, c), u || (n.r = c & 7 | l[c / 8 | 0] << 3, c -= 7, n.h = f, n.p = m, n.i = Z, n.w = Y);
  } else {
    for (var Z = n.w || 0; Z < o + u; Z += 65535) {
      var it = Z + 65535;
      it >= o && (l[c / 8 | 0] = u, it = o), c = fa(l, c + 1, s.subarray(Z, it));
    }
    n.i = o;
  }
  return ma(a, 0, i + pa(c) + r);
}, tf = /* @__PURE__ */ function() {
  for (var s = new Int32Array(256), e = 0; e < 256; ++e) {
    for (var t = e, i = 9; --i; )
      t = (t & 1 && -306674912) ^ t >>> 1;
    s[e] = t;
  }
  return s;
}(), sf = function() {
  var s = -1;
  return {
    p: function(e) {
      for (var t = s, i = 0; i < e.length; ++i)
        t = tf[t & 255 ^ e[i]] ^ t >>> 8;
      s = t;
    },
    d: function() {
      return ~s;
    }
  };
}, rf = function(s, e, t, i, r) {
  if (!r && (r = { l: 1 }, e.dictionary)) {
    var n = e.dictionary.subarray(-32768), o = new fe(n.length + s.length);
    o.set(n), o.set(s, n.length), s = o, r.w = n.length;
  }
  return ef(s, e.level == null ? 6 : e.level, e.mem == null ? r.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(s.length))) * 1.5) : 20 : 12 + e.mem, t, i, r);
}, lr = function(s, e, t) {
  for (; t; ++e)
    s[e] = t, t >>>= 8;
}, nf = function(s, e) {
  var t = e.filename;
  if (s[0] = 31, s[1] = 139, s[2] = 8, s[8] = e.level < 2 ? 4 : e.level == 9 ? 2 : 0, s[9] = 3, e.mtime != 0 && lr(s, 4, Math.floor(new Date(e.mtime || Date.now()) / 1e3)), t) {
    s[3] = 8;
    for (var i = 0; i <= t.length; ++i)
      s[i + 10] = t.charCodeAt(i);
  }
}, lf = function(s) {
  return 10 + (s.filename ? s.filename.length + 1 : 0);
};
function of(s, e) {
  e || (e = {});
  var t = sf(), i = s.length;
  t.p(s);
  var r = rf(s, e, lf(e), 8), n = r.length;
  return nf(r, e), lr(r, n - 8, t.d()), lr(r, n - 4, i), r;
}
var cl = typeof TextEncoder != "undefined" && /* @__PURE__ */ new TextEncoder(), af = typeof TextDecoder != "undefined" && /* @__PURE__ */ new TextDecoder();
try {
  af.decode(ba, { stream: !0 });
} catch (s) {
}
function cf(s, e) {
  var t;
  if (cl)
    return cl.encode(s);
  for (var i = s.length, r = new fe(s.length + (s.length >> 1)), n = 0, o = function(u) {
    r[n++] = u;
  }, t = 0; t < i; ++t) {
    if (n + 5 > r.length) {
      var a = new fe(n + 8 + (i - t << 1));
      a.set(r), r = a;
    }
    var l = s.charCodeAt(t);
    l < 128 || e ? o(l) : l < 2048 ? (o(192 | l >> 6), o(128 | l & 63)) : l > 55295 && l < 57344 ? (l = 65536 + (l & 1047552) | s.charCodeAt(++t) & 1023, o(240 | l >> 18), o(128 | l >> 12 & 63), o(128 | l >> 6 & 63), o(128 | l & 63)) : (o(224 | l >> 12), o(128 | l >> 6 & 63), o(128 | l & 63));
  }
  return ma(r, 0, n);
}
function uf(s) {
  return ne(this, null, function* () {
    const e = cf(JSON.stringify(s)), t = of(e), i = yield new Promise((r) => {
      const n = new FileReader();
      n.onload = () => r(n.result), n.readAsDataURL(new Blob([new Uint8Array(t)]));
    });
    return {
      compressedBase64: i.slice(i.indexOf(",") + 1),
      compressedSize: t.length,
      bufferLength: e.length
    };
  });
}
const Za = "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", hf = (s) => Uint8Array.from(atob(s), (e) => e.charCodeAt(0)), ul = typeof self != "undefined" && self.Blob && new Blob([hf(Za)], { type: "text/javascript;charset=utf-8" });
function df(s) {
  let e;
  try {
    if (e = ul && (self.URL || self.webkitURL).createObjectURL(ul), !e) throw "";
    const t = new Worker(e, {
      name: s == null ? void 0 : s.name
    });
    return t.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(e);
    }), t;
  } catch (t) {
    return new Worker(
      "data:text/javascript;base64," + Za,
      {
        name: s == null ? void 0 : s.name
      }
    );
  } finally {
    e && (self.URL || self.webkitURL).revokeObjectURL(e);
  }
}
var We = /* @__PURE__ */ ((s) => (s[s.Initialize = 0] = "Initialize", s[s.Reset = 1] = "Reset", s[s.AsyncEvents = 2] = "AsyncEvents", s[s.Identify = 3] = "Identify", s[s.Properties = 4] = "Properties", s[s.Metrics = 5] = "Metrics", s[s.Feedback = 6] = "Feedback", s[s.CustomEvent = 7] = "CustomEvent", s[s.Stop = 8] = "Stop", s[s.GetStatus = 9] = "GetStatus", s))(We || {});
const pf = ({
  apiKey: s
}) => {
  (function(e, t) {
    var i = e.amplitude || { _q: [], _iq: {} }, r = t.createElement("script");
    r.type = "text/javascript", r.integrity = "sha384-+EO59vL/X7v6VE2s6/F4HxfHlK0nDUVWKVg8K9oUlvffAeeaShVBmbORTC2D3UF+", r.crossOrigin = "anonymous", r.async = !0, r.src = "https://cdn.amplitude.com/libs/amplitude-8.17.0-min.gz.js", r.onload = function() {
      e.amplitude.runQueuedFunctions || console.log("[Amplitude] Error: could not load SDK"), amplitude.getInstance().init(s);
    };
    var n = t.getElementsByTagName("script")[0];
    n.parentNode.insertBefore(r, n);
    function o(m, f) {
      m.prototype[f] = function() {
        return this._q.push(
          [f].concat(Array.prototype.slice.call(arguments, 0))
        ), this;
      };
    }
    for (var a = function() {
      return this._q = [], this;
    }, l = [
      "add",
      "append",
      "clearAll",
      "prepend",
      "set",
      "setOnce",
      "unset",
      "preInsert",
      "postInsert",
      "remove"
    ], u = 0; u < l.length; u++)
      o(a, l[u]);
    i.Identify = a;
    for (var c = function() {
      return this._q = [], this;
    }, h = [
      "setProductId",
      "setQuantity",
      "setPrice",
      "setRevenueType",
      "setEventProperties"
    ], p = 0; p < h.length; p++)
      o(c, h[p]);
    i.Revenue = c;
    var d = [
      "init",
      "logEvent",
      "logRevenue",
      "setUserId",
      "setUserProperties",
      "setOptOut",
      "setVersionName",
      "setDomain",
      "setDeviceId",
      "enableTracking",
      "setGlobalUserProperties",
      "identify",
      "clearUserProperties",
      "setGroup",
      "logRevenueV2",
      "regenerateDeviceId",
      "groupIdentify",
      "onInit",
      "logEventWithTimestamp",
      "logEventWithGroups",
      "setSessionId",
      "resetSessionId"
    ];
    function b(m) {
      function f(G) {
        m[G] = function() {
          m._q.push(
            [G].concat(Array.prototype.slice.call(arguments, 0))
          );
        };
      }
      for (var V = 0; V < d.length; V++)
        f(d[V]);
    }
    b(i), i.getInstance = function(m) {
      return m = (!m || m.length === 0 ? "$default_instance" : m).toLowerCase(), Object.prototype.hasOwnProperty.call(i._iq, m) || (i._iq[m] = { _q: [] }, b(i._iq[m])), i._iq[m];
    }, e.amplitude = i;
  })(window, document);
}, mf = ({
  projectToken: s
}) => {
  if (window.mixpanel)
    return;
  (function(t, i) {
    if (!i.__SV) {
      var r, n;
      window.mixpanel = i, i._i = [], i.init = function(o, a, l) {
        function u(p, d) {
          var b = d.split(".");
          b.length == 2 && (p = p[b[0]], d = b[1]), p[d] = function() {
            p.push(
              [d].concat(
                Array.prototype.slice.call(arguments, 0)
              )
            );
          };
        }
        var c = i;
        for (typeof l != "undefined" ? c = i[l] = [] : l = "mixpanel", c.people = c.people || [], c.toString = function(p) {
          var d = "mixpanel";
          return l !== "mixpanel" && (d += "." + l), p || (d += " (stub)"), d;
        }, c.people.toString = function() {
          return c.toString(1) + ".people (stub)";
        }, r = "disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(
          " "
        ), n = 0; n < r.length; n++) u(c, r[n]);
        var h = "set set_once union unset remove delete".split(" ");
        c.get_group = function() {
          function p(f) {
            d[f] = function() {
              call2_args = arguments, call2 = [f].concat(
                Array.prototype.slice.call(call2_args, 0)
              ), c.push([b, call2]);
            };
          }
          for (var d = {}, b = ["get_group"].concat(
            Array.prototype.slice.call(arguments, 0)
          ), m = 0; m < h.length; m++)
            p(h[m]);
          return d;
        }, i._i.push([o, a, l]);
      }, i.__SV = 1.2;
    }
  })(document, window.mixpanel || []);
  const e = document.createElement("script");
  e.src = ff, document.head.appendChild(e), e.addEventListener("load", () => {
    var t;
    (t = window.mixpanel) == null || t.init(s);
  });
}, ff = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";
class bf {
  constructor(e) {
    L(this, "options");
    /** Determines if the client is running on a Highlight property (e.g. frontend). */
    L(this, "isRunningOnHighlight");
    /** Verbose project ID that is exposed to users. Legacy users may still be using ints. */
    L(this, "organizationID");
    L(this, "graphqlSDK");
    L(this, "events");
    L(this, "sessionData");
    L(this, "ready");
    L(this, "manualStopped");
    L(this, "state");
    L(this, "logger");
    L(this, "enableSegmentIntegration");
    L(this, "privacySetting");
    L(this, "enableCanvasRecording");
    L(this, "samplingStrategy");
    L(this, "inlineImages");
    L(this, "inlineVideos");
    L(this, "inlineStylesheet");
    L(this, "debugOptions");
    L(this, "listeners");
    L(this, "firstloadVersion");
    L(this, "environment");
    L(this, "sessionShortcut");
    /** The end-user's app version. This isn't Highlight's version. */
    L(this, "appVersion");
    L(this, "serviceName");
    L(this, "_worker");
    L(this, "_optionsInternal");
    L(this, "_backendUrl");
    L(this, "_recordingStartTime");
    L(this, "_isOnLocalHost");
    L(this, "_onToggleFeedbackFormVisibility");
    L(this, "_isCrossOriginIframe");
    L(this, "_eventBytesSinceSnapshot");
    L(this, "_lastSnapshotTime");
    L(this, "_lastVisibilityChangeTime");
    L(this, "pushPayloadTimerId");
    L(this, "hasSessionUnloaded");
    L(this, "hasPushedData");
    L(this, "reloaded");
    L(this, "_hasPreviouslyInitialized");
    L(this, "_recordStop");
    L(this, "_integrations", []);
    var i, r, n, o, a;
    this.options = e, typeof ((i = this.options) == null ? void 0 : i.debug) == "boolean" ? this.debugOptions = this.options.debug ? { clientInteractions: !0 } : {} : this.debugOptions = (n = (r = this.options) == null ? void 0 : r.debug) != null ? n : {}, this.logger = new Aa(this.debugOptions.clientInteractions), this._worker = new df(), this._worker.onmessage = (l) => {
      var u, c, h;
      ((u = l.data.response) == null ? void 0 : u.type) === We.AsyncEvents ? (this._eventBytesSinceSnapshot += l.data.response.eventsSize, this.logger.log(
        `Web worker sent payloadID ${l.data.response.id} size ${l.data.response.eventsSize} bytes, compression ratio ${l.data.response.eventsSize / l.data.response.compressedSize}.
                Total since snapshot: ${(this._eventBytesSinceSnapshot / 1e6).toFixed(1)}MB`
      )) : ((c = l.data.response) == null ? void 0 : c.type) === We.CustomEvent ? this.addCustomEvent(
        l.data.response.tag,
        l.data.response.payload
      ) : ((h = l.data.response) == null ? void 0 : h.type) === We.Stop && (Fe(
        "worker.onmessage",
        "warn",
        "Stopping recording due to worker failure",
        l.data.response
      ), this.stop(!1));
    };
    let t = ss();
    if (this.reloaded = !1, !((o = this.sessionData) != null && o.sessionSecureID) && (t != null && t.sessionSecureID))
      this.sessionData = t, this.options.sessionSecureID = t.sessionSecureID, this.reloaded = !0, this.logger.log(
        `Tab reloaded, continuing previous session: ${this.sessionData.sessionSecureID}`
      );
    else {
      for (const l of Object.values(ve))
        Fr(l);
      this.sessionData = {
        sessionSecureID: this.options.sessionSecureID,
        projectID: 0,
        sessionStartTime: Date.now()
      };
    }
    this._hasPreviouslyInitialized = !1;
    try {
      window.parent.document && (this._isCrossOriginIframe = !1);
    } catch (l) {
      this._isCrossOriginIframe = (a = this.options.recordCrossOriginIframe) != null ? a : !0;
    }
    this._initMembers(this.options);
  }
  // Start a new session
  _reset(i) {
    return ne(this, arguments, function* ({
      forceNew: e,
      sessionKey: t
    }) {
      this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      let r, n;
      if (!e)
        try {
          r = we(ve.USER_IDENTIFIER);
          const o = we(
            ve.USER_OBJECT
          );
          o && (n = JSON.parse(o));
        } catch (o) {
        }
      for (const o of Object.values(ve))
        Fr(o);
      this.sessionData.sessionSecureID = t ? rs(`${this.organizationID}-${t}`) : rs(), this.sessionData.sessionKey = t, this.sessionData.sessionStartTime = Date.now(), this.options.sessionSecureID = this.sessionData.sessionSecureID, this.stop(), this._worker.postMessage({ message: { type: We.Reset } }), yield this.start(), r && n && this.identify(r, n);
    });
  }
  _initMembers(e) {
    var n, o, a, l, u, c, h, p, d;
    this.sessionShortcut = !1, this._recordingStartTime = 0, this._isOnLocalHost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname === "", this.ready = !1, this.state = "NotRecording", this.manualStopped = !1, this.enableSegmentIntegration = !!e.enableSegmentIntegration, this.privacySetting = (n = e.privacySetting) != null ? n : "default", this.enableCanvasRecording = (o = e.enableCanvasRecording) != null ? o : !1, this.inlineImages = (a = e.inlineImages) != null ? a : this._isOnLocalHost, this.inlineVideos = (l = e.inlineVideos) != null ? l : this._isOnLocalHost, this.inlineStylesheet = (u = e.inlineStylesheet) != null ? u : this._isOnLocalHost, this.samplingStrategy = x({
      canvasFactor: 0.5,
      canvasMaxSnapshotDimension: 360,
      canvasClearWebGLBuffer: !0,
      dataUrlOptions: Ia()
    }, (c = e.samplingStrategy) != null ? c : {
      canvas: 2
    }), this._backendUrl = (h = e == null ? void 0 : e.backendUrl) != null ? h : "https://pub.observability.app.launchdarkly.com", this._backendUrl[0] === "/" && (this._backendUrl = new URL(this._backendUrl, document.baseURI).href);
    const t = new Wa(`${this._backendUrl}`, {
      headers: {}
    });
    this.graphqlSDK = Va(t, Ra()), this.environment = (p = e.environment) != null ? p : "production", this.appVersion = e.appVersion, this.serviceName = (d = e.serviceName) != null ? d : "browser", typeof e.organizationID == "string" ? this.organizationID = e.organizationID : this.organizationID = e.organizationID.toString(), this.isRunningOnHighlight = this.organizationID === "1" || this.organizationID === "1jdkoe52", this.firstloadVersion = e.firstloadVersion || "unknown", this.sessionShortcut = e.sessionShortcut || !1, this._onToggleFeedbackFormVisibility = () => {
    };
    const b = e, { firstloadVersion: i } = b, r = Qe(b, ["firstloadVersion"]);
    this._optionsInternal = r, this.listeners = [], this.events = [], this.hasSessionUnloaded = !1, this.hasPushedData = !1, window.Intercom && window.Intercom("onShow", () => {
      window.Intercom("update", {
        highlightSessionURL: this.getCurrentSessionURLWithTimestamp()
      }), this.addProperties({ event: "Intercom onShow" });
    }), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime(), this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime();
  }
  identify(e, t = {}, i) {
    if (!e || e === "") {
      Fe(
        "identify",
        "warn",
        "Highlight's identify() call was passed an empty identifier.",
        { user_identifier: e, user_object: t }
      );
      return;
    }
    this.sessionData.userIdentifier = e.toString(), this.sessionData.userObject = t, je(
      ve.USER_IDENTIFIER,
      e.toString()
    ), je(ve.USER_OBJECT, JSON.stringify(t)), this._worker.postMessage({
      message: {
        type: We.Identify,
        userIdentifier: e,
        userObject: t,
        source: i
      }
    });
  }
  track(e, t) {
    this.addProperties(re(x({}, t), { event: e }));
  }
  addProperties(e = {}, t) {
    const i = x({}, e);
    Object.entries(i).forEach(([r, n]) => {
      try {
        structuredClone(n);
      } catch (o) {
        delete i[r];
      }
    }), this._worker.postMessage({
      message: {
        type: We.Properties,
        propertiesObject: i,
        propertyType: t
      }
    });
  }
  /**
   * Add custom session-level properties. These are attached to the current session
   * and are searchable, but do not create timeline Track events.
   */
  addSessionProperties(e) {
    this.addProperties(e, { type: "session" });
  }
  start(e) {
    return ne(this, null, function* () {
      var t, i, r, n, o, a, l, u, c, h;
      if (!((t = navigator == null ? void 0 : navigator.userAgent) != null && t.includes("Googlebot") || (i = navigator == null ? void 0 : navigator.userAgent) != null && i.includes("AdsBot")))
        try {
          if (e != null && e.forceNew) {
            yield this._reset(e);
            return;
          }
          if (e != null && e.sessionKey && (e == null ? void 0 : e.sessionKey) !== this.sessionData.sessionKey) {
            yield this._reset(re(x({}, e), { forceNew: !0 }));
            return;
          }
          this.logger.log(
            "Initializing...",
            e,
            this.sessionData,
            this.options
          ), this.sessionData = (r = ss(this.sessionData.sessionSecureID)) != null ? r : this.sessionData, (n = this.sessionData) != null && n.sessionStartTime ? this._recordingStartTime = (o = this.sessionData) == null ? void 0 : o.sessionStartTime : (this._recordingStartTime = (/* @__PURE__ */ new Date()).getTime(), this.sessionData.sessionStartTime = this._recordingStartTime);
          let p = we(Mr.CLIENT_ID);
          p || (p = rs(), je(Mr.CLIENT_ID, p));
          let d;
          this.options.disableSessionRecording || this.options.disableNetworkRecording !== void 0 || typeof this.options.networkRecording == "boolean" ? d = !1 : d = ((a = this.options.networkRecording) == null ? void 0 : a.recordHeadersAndBody) || !1;
          let b = [];
          if (typeof this.options.networkRecording == "object" && ((l = this.options.networkRecording.destinationDomains) != null && l.length) && (b = this.options.networkRecording.destinationDomains), this._isCrossOriginIframe)
            yield this._setupCrossOriginIframe();
          else {
            const g = yield this.graphqlSDK.initializeSession({
              organization_verbose_id: this.organizationID,
              enable_strict_privacy: this.privacySetting === "strict",
              privacy_setting: this.privacySetting,
              enable_recording_network_contents: d,
              clientVersion: this.firstloadVersion,
              firstloadVersion: this.firstloadVersion,
              clientConfig: JSON.stringify(this._optionsInternal),
              environment: this.environment,
              id: p,
              appVersion: this.appVersion,
              serviceName: this.serviceName,
              session_secure_id: this.sessionData.sessionSecureID,
              session_key: this.sessionData.sessionKey,
              client_id: p,
              network_recording_domains: b,
              disable_session_recording: this.options.disableSessionRecording
            });
            if (g.initializeSession.secure_id !== this.sessionData.sessionSecureID && this.logger.log(
              `Unexpected secure id returned by initializeSession: ${g.initializeSession.secure_id}, expected ${this.sessionData.sessionSecureID}`
            ), this.sessionData.sessionSecureID = g.initializeSession.secure_id, this.sessionData.projectID = parseInt(
              ((u = g == null ? void 0 : g.initializeSession) == null ? void 0 : u.project_id) || "0"
            ), !this.sessionData.projectID || !this.sessionData.sessionSecureID) {
              console.error(
                "Failed to initialize Highlight; an error occurred on our end.",
                this.sessionData
              );
              return;
            }
          }
          ns(""), gt(this.sessionData), this.logger.log(
            `Loaded Highlight
Remote: ${this._backendUrl}
Project ID: ${this.sessionData.projectID}
SessionSecureID: ${this.sessionData.sessionSecureID}`
          ), this.options.sessionSecureID = this.sessionData.sessionSecureID, this._worker.postMessage({
            message: {
              type: We.Initialize,
              sessionSecureID: this.sessionData.sessionSecureID,
              backend: this._backendUrl,
              debug: !!this.debugOptions.clientInteractions,
              recordingStartTime: this._recordingStartTime
            }
          });
          for (const g of this._integrations)
            g.init(this.sessionData.sessionSecureID);
          if (this.sessionData.userIdentifier && this.identify(
            this.sessionData.userIdentifier,
            this.sessionData.userObject
          ), this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this._isCrossOriginIframe || (this.pushPayloadTimerId = setTimeout(() => {
            this._save();
          }, zr)), this.options.disableSessionRecording) {
            this.logger.log(
              "Highlight is NOT RECORDING a session replay per H.init setting."
            ), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
            return;
          }
          const m = (g, S) => {
            S && this.logger.log("received isCheckout emit", { event: g }), this.events.push(g);
          };
          m.bind(this);
          const f = !!this._recordStop;
          this._recordStop && (this._recordStop(), this._recordStop = void 0);
          const [V, G] = Jm(
            this.privacySetting,
            this.options.maskAllInputs,
            this.options.maskInputOptions
          );
          this._recordStop = Ye({
            ignoreClass: (c = this.options.ignoreClass) != null ? c : "highlight-ignore",
            ignoreSelector: this.options.ignoreSelector,
            blockClass: (h = this.options.blockClass) != null ? h : "highlight-block",
            blockSelector: this.options.blockSelector,
            emit: m,
            recordCrossOriginIframes: this.options.recordCrossOriginIframe,
            privacySetting: this.privacySetting,
            maskAllInputs: V,
            maskInputOptions: G,
            maskTextClass: this.options.maskTextClass,
            maskTextSelector: this.options.maskTextSelector,
            recordCanvas: this.enableCanvasRecording,
            sampling: {
              canvas: {
                fps: this.samplingStrategy.canvas,
                fpsManual: this.samplingStrategy.canvasManualSnapshot,
                resizeFactor: this.samplingStrategy.canvasFactor,
                clearWebGLBuffer: this.samplingStrategy.canvasClearWebGLBuffer,
                initialSnapshotDelay: this.samplingStrategy.canvasInitialSnapshotDelay,
                dataURLOptions: this.samplingStrategy.dataUrlOptions,
                maxSnapshotDimension: this.samplingStrategy.canvasMaxSnapshotDimension
              }
            },
            keepIframeSrcFn: (g) => !this.options.recordCrossOriginIframe,
            inlineImages: this.inlineImages,
            inlineVideos: this.inlineVideos,
            collectFonts: this.inlineImages,
            inlineStylesheet: this.inlineStylesheet,
            plugins: [ec()],
            logger: typeof this.options.debug == "boolean" && this.options.debug || typeof this.options.debug == "object" && this.options.debug.domRecording ? {
              debug: this.logger.log,
              warn: Fe.bind("RecordSDK", "warn")
            } : void 0
          }), f || this.options.recordCrossOriginIframe && this._setupCrossOriginIframeParent(), document.referrer && (window && document.referrer.includes(window.location.origin) || (this.addCustomEvent("Referrer", document.referrer), this.addProperties(
            { referrer: document.referrer },
            { type: "session" }
          ))), this.sessionData.sessionKey && this.addProperties(
            {
              sessionKey: this.sessionData.sessionKey
            },
            { type: "session" }
          ), this._setupWindowListeners(), this.ready = !0, this.state = "Recording", this.manualStopped = !1;
        } catch (p) {
          Fe("initializeSession _setupWindowListeners", "warn", p);
        }
    });
  }
  _visibilityHandler(e) {
    return ne(this, null, function* () {
      if (this.manualStopped) {
        this.logger.log("Ignoring visibility event due to manual stop.");
        return;
      }
      (/* @__PURE__ */ new Date()).getTime() - this._lastVisibilityChangeTime < Ca || (this._lastVisibilityChangeTime = (/* @__PURE__ */ new Date()).getTime(), this.logger.log(`Detected window ${e ? "hidden" : "visible"}.`), e ? (this.addCustomEvent("TabHidden", !0), this.options.disableBackgroundRecording && this.stop()) : (this.options.disableBackgroundRecording && (yield this.start()), this.addCustomEvent("TabHidden", !1)));
    });
  }
  _setupCrossOriginIframe() {
    return ne(this, null, function* () {
      this.logger.log("highlight in cross-origin iframe is waiting "), yield new Promise((e) => {
        const t = (i) => {
          if (i.data.highlight === sl) {
            const r = i.data;
            this.logger.log("highlight got window message ", r), this.sessionData.projectID = r.projectID, this.sessionData.sessionSecureID = r.sessionSecureID, window.parent.postMessage(
              {
                highlight: rl
              },
              "*"
            ), window.removeEventListener("message", t), e();
          }
        };
        window.addEventListener("message", t);
      });
    });
  }
  _setupCrossOriginIframeParent() {
    this.logger.log(
      "highlight setting up cross origin iframe parent notification"
    ), setInterval(() => {
      window.document.querySelectorAll("iframe").forEach((e) => {
        var t;
        (t = e.contentWindow) == null || t.postMessage(
          {
            highlight: sl,
            projectID: this.sessionData.projectID,
            sessionSecureID: this.sessionData.sessionSecureID
          },
          "*"
        );
      });
    }, zr), window.addEventListener("message", (e) => {
      e.data.highlight === rl && this.logger.log(
        "highlight got response from initialized iframe"
      );
    });
  }
  _setupWindowListeners() {
    var i;
    try {
      const r = this;
      this.enableSegmentIntegration && this.listeners.push(
        Tm((o) => {
          if (o.type === "track") {
            const a = {};
            a["segment-event"] = o.event, r.addProperties(a, {
              type: "track",
              source: "segment"
            });
          } else if (o.type === "identify") {
            const a = o.userId.replace(
              /^"(.*)"$/,
              "$1"
            );
            r.identify(
              a,
              o.traits,
              "segment"
            );
          }
        })
      ), this.listeners.push(
        wa((o) => {
          this.reloaded ? (this.addCustomEvent("Reload", o), this.reloaded = !1, r.addProperties(
            { reload: !0 },
            { type: "session" }
          )) : this.addCustomEvent("Navigate", o);
        })
      ), this.listeners.push(
        xa(
          (o) => {
            this.addCustomEvent("Viewport", o);
          }
        )
      ), this.listeners.push(
        vm((o, a) => {
          let l = null, u = null;
          if (a && a.target) {
            const c = a.target;
            l = La(c), u = c.textContent, u && u.length > 2e3 && (u = u.substring(0, 2e3));
          }
          this.addCustomEvent("Click", {
            clickTarget: o,
            clickTextContent: u,
            clickSelector: l
          });
        })
      ), this.listeners.push(
        Ym((o) => {
          o && this.addCustomEvent("Focus", o);
        })
      ), this.sessionShortcut && Km(this.sessionShortcut, () => {
        window.open(
          this.getCurrentSessionURLWithTimestamp(),
          "_blank"
        );
      }), this._hasPreviouslyInitialized || ((i = window.electron) != null && i.ipcRenderer ? (window.electron.ipcRenderer.on(
        "highlight.run",
        ({ visible: o }) => {
          this._visibilityHandler(!o);
        }
      ), this.logger.log("Set up Electron highlight.run events.")) : (Nm(
        (o) => this._visibilityHandler(o)
      ), this.logger.log("Set up document visibility listener.")), this._hasPreviouslyInitialized = !0);
      const n = () => {
        this.hasSessionUnloaded = !0, this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0);
      };
      window.addEventListener("beforeunload", n), this.listeners.push(
        () => window.removeEventListener("beforeunload", n)
      );
    } catch (r) {
      Fe("initializeSession _setupWindowListeners", "warn", r);
    }
    const e = () => {
      this.addCustomEvent("Page Unload", ""), ns(this.sessionData.sessionSecureID), gt(this.sessionData);
    };
    if (window.addEventListener("beforeunload", e), this.listeners.push(
      () => window.removeEventListener("beforeunload", e)
    ), navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
      const r = () => {
        this.addCustomEvent("Page Unload", ""), ns(this.sessionData.sessionSecureID), gt(this.sessionData);
      };
      window.addEventListener("pagehide", r), this.listeners.push(
        () => window.removeEventListener("beforeunload", r)
      );
    }
  }
  /**
   * Stops Highlight from recording.
   * @param manual The end user requested to stop recording.
   */
  stop(e) {
    this.manualStopped = !!e, this.manualStopped && this.addCustomEvent(
      "Stop",
      "H.stop() was called which stops Highlight from recording."
    ), this.state = "NotRecording", e && this._recordStop && (this._recordStop(), this._recordStop = void 0), this.listeners.forEach((t) => t()), this.listeners = [];
  }
  /**
   * Returns the current timestamp for the current session.
   */
  getCurrentSessionURLWithTimestamp() {
    const e = (/* @__PURE__ */ new Date()).getTime(), { projectID: t, sessionSecureID: i } = this.sessionData, r = (e - this._recordingStartTime) / 1e3;
    return `https://${Hr}/${t}/sessions/${i}?ts=${r}`;
  }
  getCurrentSessionURL() {
    const e = this.sessionData.projectID, t = this.sessionData.sessionSecureID;
    return e && t ? `https://${Hr}/${e}/sessions/${t}` : null;
  }
  snapshot(e) {
    return ne(this, null, function* () {
      yield Ye.snapshotCanvas(e);
    });
  }
  addSessionFeedback({
    timestamp: e,
    verbatim: t,
    user_email: i,
    user_name: r
  }) {
    var n;
    this._worker.postMessage({
      message: {
        type: We.Feedback,
        verbatim: t,
        timestamp: e,
        userName: r || this.sessionData.userIdentifier,
        userEmail: i || ((n = this.sessionData.userObject) == null ? void 0 : n.name)
      }
    });
  }
  // Reset the events array and push to a backend.
  _save() {
    return ne(this, null, function* () {
      var e;
      try {
        this.state === "Recording" && this.listeners && !this.sessionData.sessionKey && this.sessionData.sessionStartTime && Date.now() - this.sessionData.sessionStartTime > ka && (this.logger.log("Resetting session", {
          start: this.sessionData.sessionStartTime
        }), yield this._reset({}));
        let t;
        ((e = this.options) == null ? void 0 : e.sendMode) === "local" && (t = (i) => ne(this, null, function* () {
          let r = new Blob(
            [
              JSON.stringify({
                query: Fa(Ma),
                variables: i
              })
            ],
            {
              type: "application/json"
            }
          );
          return yield window.fetch(`${this._backendUrl}`, {
            method: "POST",
            body: r
          }), 0;
        })), yield this._sendPayload({ sendFn: t }), this.hasPushedData = !0, this.sessionData.lastPushTime = Date.now(), gt(this.sessionData);
      } catch (t) {
        Fe("_save", "warn", t);
      }
      this.state === "Recording" && (this.pushPayloadTimerId && (clearTimeout(this.pushPayloadTimerId), this.pushPayloadTimerId = void 0), this.pushPayloadTimerId = setTimeout(() => {
        this._save();
      }, Ja));
    });
  }
  /**
   * This proxy should be used instead of rrweb's native addCustomEvent.
   * The proxy makes sure recording has started before emitting a custom event.
   */
  addCustomEvent(e, t) {
    if (this.state === "NotRecording") {
      let i;
      const r = () => {
        clearInterval(i), this.state === "Recording" && this.events.length > 0 ? el(e, t) : i = setTimeout(r, 500);
      };
      i = setTimeout(r, 500);
    } else this.state === "Recording" && (this.events.length > 0 || this.hasPushedData) && el(e, t);
  }
  _sendPayload(t) {
    return ne(this, arguments, function* ({
      sendFn: e
    }) {
      const i = [...this.events], { bytes: r, time: n } = this.enableCanvasRecording ? Or.canvas : Or.normal;
      this._eventBytesSinceSnapshot >= r && (/* @__PURE__ */ new Date()).getTime() - this._lastSnapshotTime >= n && this.takeFullSnapshot(), this.logger.log(
        `Sending: ${i.length} events, 
To: ${this._backendUrl}
Org: ${this.organizationID}
SessionSecureID: ${this.sessionData.sessionSecureID}`
      );
      const o = (/* @__PURE__ */ new Date()).getTime(), a = Qm();
      if (e) {
        const l = {
          session_secure_id: this.sessionData.sessionSecureID,
          payload_id: o.toString(),
          events: { events: i },
          messages: va({ messages: [] }),
          resources: JSON.stringify({ resources: [] }),
          web_socket_events: JSON.stringify({
            webSocketEvents: []
          }),
          errors: [],
          is_beacon: !1,
          has_session_unloaded: this.hasSessionUnloaded,
          highlight_logs: a || void 0
        }, { compressedBase64: u } = yield uf(l);
        yield e({
          session_secure_id: this.sessionData.sessionSecureID,
          payload_id: o.toString(),
          data: u
        });
      } else
        this._worker.postMessage({
          message: {
            type: We.AsyncEvents,
            id: o,
            events: i,
            messages: [],
            errors: [],
            resourcesString: JSON.stringify({ resources: [] }),
            webSocketEventsString: JSON.stringify({
              webSocketEvents: []
            }),
            hasSessionUnloaded: this.hasSessionUnloaded,
            highlightLogs: a
          }
        });
      gt(this.sessionData), this.events = this.events.slice(i.length), Dm(a);
    });
  }
  takeFullSnapshot() {
    if (!this._recordStop) {
      this.logger.log("skipping full snapshot as rrweb is not running");
      return;
    }
    this.logger.log("taking full snapshot", {
      bytesSinceSnapshot: this._eventBytesSinceSnapshot,
      lastSnapshotTime: this._lastSnapshotTime
    }), Ye.takeFullSnapshot(), this._eventBytesSinceSnapshot = 0, this._lastSnapshotTime = (/* @__PURE__ */ new Date()).getTime();
  }
  register(e, t) {
    this._integrations.push(new Ya(e, t));
  }
  getHooks(e) {
    return this._integrations.flatMap((t) => {
      var i, r;
      return (r = (i = t.getHooks) == null ? void 0 : i.call(t, e)) != null ? r : [];
    });
  }
  getRecordingState() {
    var e;
    return (e = this == null ? void 0 : this.state) != null ? e : "NotRecording";
  }
  getSession() {
    const e = this.sessionData.sessionSecureID, t = ss(e);
    if (!t)
      return null;
    const i = `${this.getFrontendUrl()}/sessions/${e}`;
    if (!i || !(t == null ? void 0 : t.sessionStartTime))
      return null;
    const n = (/* @__PURE__ */ new Date()).getTime();
    let o;
    try {
      o = new URL(i);
    } catch (u) {
      return Fe(
        "identify",
        "warn",
        `failed to construct session url from ${i}`,
        u
      ), null;
    }
    const a = new URL(o), l = (n - this._recordingStartTime) / 1e3;
    return a.searchParams.set("ts", l.toString()), {
      url: o.toString(),
      urlWithTimestamp: a.toString(),
      sessionSecureID: e
    };
  }
  getFrontendUrl() {
    var t, i;
    const e = this._backendUrl.match(Na);
    if (e && ((t = e == null ? void 0 : e.groups) != null && t.domain)) {
      const r = (i = e.groups.domain) != null ? i : "";
      return `https://${Ta[r]}${Ua}`;
    }
    return Ka;
  }
}
class qf extends za {
  constructor(t) {
    super(t);
    L(this, "record");
    L(this, "options");
    this.options = t;
  }
  initialize(t, i) {
    var r, n, o, a, l, u, c, h, p;
    try {
      if (typeof window == "undefined" || typeof document == "undefined") {
        console.warn(
          "@launchdarkly/session-replay is not initializing because it is not supported in this environment."
        );
        return;
      }
      if (typeof Worker == "undefined") {
        console.warn(
          "@launchdarkly/session-replay is not initializing because Worker is not supported."
        );
        return;
      }
      if (!t) {
        console.warn(
          "@launchdarkly/session-replay is not initializing because the SDK credential is undefined."
        );
        return;
      }
      this.configureSession(t, i);
      const d = re(x({}, i), {
        organizationID: t,
        firstloadVersion: Ha,
        environment: (i == null ? void 0 : i.environment) || "production",
        appVersion: i == null ? void 0 : i.version,
        sessionSecureID: this.sessionSecureID,
        privacySetting: (r = i == null ? void 0 : i.privacySetting) != null ? r : "strict"
      });
      this.record = new bf(d), i != null && i.manualStart || this.record.start(), _a.load(this.record), !((o = (n = i == null ? void 0 : i.integrations) == null ? void 0 : n.mixpanel) != null && o.disabled) && ((l = (a = i == null ? void 0 : i.integrations) == null ? void 0 : a.mixpanel) != null && l.projectToken) && mf(i.integrations.mixpanel), !((c = (u = i == null ? void 0 : i.integrations) == null ? void 0 : u.amplitude) != null && c.disabled) && ((p = (h = i == null ? void 0 : i.integrations) == null ? void 0 : h.amplitude) != null && p.apiKey) && pf(i.integrations.amplitude);
    } catch (d) {
      Fe(
        "Error initializing @launchdarkly/session-replay SDK",
        "error",
        d
      );
    }
  }
  getMetadata() {
    return {
      name: "@launchdarkly/session-replay"
    };
  }
  register(t, i) {
    var r;
    (r = this.record) == null || r.register(t, i);
  }
  getHooks(t) {
    var r, n, o, a;
    const i = x(x({
      [ja]: t.sdk.name,
      [Da]: t.sdk.version,
      [Qa]: t.clientSideId,
      [Ba]: "LaunchDarkly"
    }, (r = t.application) != null && r.id ? { [Ea]: t.application.id } : {}), (n = t.application) != null && n.version ? {
      [Pa]: t.application.version
    } : {});
    return this.initialize(
      (a = (o = t.sdkKey) != null ? o : t.mobileKey) != null ? a : t.clientSideId,
      this.options
    ), [
      {
        getMetadata: () => ({
          name: "@launchdarkly/session-replay/hooks"
        }),
        afterIdentify: (l, u, c) => {
          var h, p, d, b, m, f, V, G;
          for (const g of (d = (p = (h = this.record) == null ? void 0 : h.getHooks) == null ? void 0 : p.call(h, t)) != null ? d : [])
            (b = g.afterIdentify) == null || b.call(g, l, u, c);
          if (c.status === "completed") {
            const g = re(x({}, Oa(l.context)), {
              key: (V = (f = (m = this.options) == null ? void 0 : m.contextFriendlyName) == null ? void 0 : f.call(
                m,
                l.context
              )) != null ? V : Pr(l.context),
              canonicalKey: Pr(l.context)
            });
            (G = this.record) == null || G.identify(
              g.key,
              x(x({}, i), g),
              "LaunchDarkly"
            );
          }
          return u;
        },
        afterEvaluation: (l, u, c) => {
          var h, p, d, b;
          for (const m of (d = (p = (h = this.record) == null ? void 0 : h.getHooks) == null ? void 0 : p.call(h, t)) != null ? d : [])
            (b = m.afterEvaluation) == null || b.call(m, l, u, c);
          return u;
        },
        afterTrack: (l) => {
          var u, c, h, p, d;
          for (const b of (h = (c = (u = this.record) == null ? void 0 : u.getHooks) == null ? void 0 : c.call(u, t)) != null ? h : [])
            (p = b.afterTrack) == null || p.call(b, l);
          (d = this.record) == null || d.track(l.key, {
            data: l.data,
            value: l.metricValue
          });
        }
      }
    ];
  }
}
export {
  vm as C,
  Ym as F,
  sl as I,
  We as M,
  Nm as P,
  qf as R,
  Tm as S,
  df as W,
  rl as a,
  Km as b,
  el as c,
  Dm as d,
  ec as e,
  Jm as f,
  Qm as g,
  pf as h,
  uf as p,
  Ye as r,
  mf as s
};
//# sourceMappingURL=record-BfJEdMr3.js.map
